// CreateJobOrder.js (refactored)
// - UI unchanged
// - removed unused states & redundant functions
// - JD upload: drag & drop / choose file / validate / import -> parse-jd -> populate form

import axios from "axios";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
// import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Select, { components } from 'react-select';
import CompanySelector from "ATSComponents/Common/CompanySelector";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Slider } from "primereact/slider";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { FaPlus, FaSearch, FaTimes, FaCog, FaEnvelopeOpenText, FaDownload, FaRegEye, FaRegEnvelope, FaWhatsapp, FaHistory, FaCopy, FaRegTrashAlt, FaPhoneAlt } from "react-icons/fa";
import { Col, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, Row, Spinner, TabContent, TabPane } from "reactstrap";
import documentIcon from '../../assets/images/documentIcon.png'
import EmailAC from "ATSComponents/Candidates/EmailAC";
import ResumePreviewPanel from "ATSComponents/Candidates/ResumePreviewPanel";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import deleteIcon from '../../assets/images/deleteIcon.png'
import DataTable from "react-data-table-component";
import { MultiSelect } from "primereact/multiselect";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import SocialMediaPost2 from "./SocialMediaPost2";
import { mapAtsUsersToOptions } from "../../utils/userOptions";
import { Dialog } from "primereact/dialog";
import { IoIosSend } from "react-icons/io";
import AIResultPanel from "./Airesultpanel";
import ScheduleInterviewDialog from "ATSComponents/Common/ScheduleInterviewDialog";
import { downloadQuestionsDocx, downloadScreeningDocx } from "./downloadQuestions";
const paginationOptions = {
  rowsPerPageText: "Rows per page:",
  rangeSeparatorText: "of",
  selectAllRowsItem: true,
  selectAllRowsItemText: "All",
};
const apiRequestCache = new Map();

const normalizeDesignationList = (value) => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.results)) return value.results;
    if (Array.isArray(value?.data)) return value.data;
    if (Array.isArray(value?.designations)) return value.designations;
    return [];
};

const normalizeDepartmentList = (value) => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.results)) return value.results;
    if (Array.isArray(value?.data)) return value.data;
    if (Array.isArray(value?.departments)) return value.departments;
    return [];
};

const hasQuestionContent = (value) => {
    if (Array.isArray(value)) {
        return value.some(hasQuestionContent);
    }

    if (value && typeof value === "object") {
        return Object.values(value).some(hasQuestionContent);
    }

    if (typeof value === "string") {
        return value.trim().length > 0;
    }

    return false;
};

const getCachedRequest = (key, request, persist = false) => {
    if (apiRequestCache.has(key)) {
        return apiRequestCache.get(key);
    }

    const promise = request().catch((error) => {
        apiRequestCache.delete(key);
        throw error;
    });

    if (!persist) {
        promise.then(
            () => apiRequestCache.delete(key),
            () => apiRequestCache.delete(key)
        );
    }

    apiRequestCache.set(key, promise);
    return promise;
};


const CreateJobOrder = () => {
    document.title = "Bharat ATS - Create Job Order";
    const rolesEditorRef = useRef(null);
    const jdDescriptions = useRef(null);
    const roles_responsibilitys = useRef(null);
    const createJobOrderPageRef = useRef(null);
    const lastFetchedJobTextsRef = useRef(null);
    const jobCandidatesInFlightRef = useRef({});
    const jobOrderFetchInFlightRef = useRef({});
    const editJobOptionsFetchedForRef = useRef("");
    const [filterValue, setFilterValue] = useState("");
    const [panelKey, setPanelKey] = useState(0); 
    const [phoneCallCandidate, setPhoneCallCandidate] = useState(null);
    const [jobOrderMenuOpen, setJobOrderMenuOpen] = useState(false);
    const jobOrderSearchFocusedRef = useRef(false);
    const [phoneCallModal, setPhoneCallModal] = useState(false);
    const [phoneCallLoading, setPhoneCallLoading] = useState(false);
    const [parsedJdMeta, setParsedJdMeta] = useState(null);
    const [automateTalentScan, setAutomateTalentScan] = useState(false);
    const [fromDateMap, setFromDateMap] = useState({})
    const [richScheduleModalOpen, setRichScheduleModalOpen] = useState(false);
    const [richScheduleCandidate, setRichScheduleCandidate] = useState(null);
    const [previousQuestionsModal, setPreviousQuestionsModal] = useState(false);
    const [previousGeneratedQuestions, setPreviousGeneratedQuestions] = useState({});
    const [previousScreeningQuestions, setPreviousScreeningQuestions] = useState({});
    const [previousScreeningModal, setPreviousScreeningModal] = useState(false);
    const [previousManualQuestions, setPreviousManualQuestions] = useState({});
    const [showAllScreeningModal, setShowAllScreeningModal] = useState(false);
    const [folderFilterMap, setFolderFilterMap] = useState({});
    const [addToFolderId, setAddToFolderId] = useState("");
    const [toDateMap, setToDateMap] = useState({})
    const handlePhoneCallOpen = (row) => {
    if (!row?.mobile_phone && !row?.candidate_phone) {
        Swal.fire({
        icon: "warning",
        title: "Phone Number Missing",
        html: `Cannot initiate call — <strong>${row?.first_name || ""}</strong> 
                <strong>${row?.middle_name || ""}</strong> 
                <strong>${row?.last_name || ""}</strong> 
                does not have a phone number on record.<br/><br/>
                Please update the candidate's phone number first.`,
        confirmButtonText: "OK",
        });
        return;
    }
    setPhoneCallCandidate(row);
    setPhoneCallModal(true);
    };
    const handlePhoneCallClose = () => {
    setPhoneCallModal(false);
    setPhoneCallCandidate(null);
    };
    const handlePhoneCallProceed = async () => {
    const jobCandidateId = phoneCallCandidate?.job_candidate_id;
    if (!jobCandidateId) {
        Swal.fire("Warning", "Candidate ID not found.", "warning");
        return;
    }
    try {
        setPhoneCallLoading(true);
        const response = await axios.post("/api/v1/vitel/click2call/", {
        job_candidate_id: jobCandidateId,
        });
        const callUrl = response?.data?.data?.click_to_call_url;
        const message = response?.data?.message || "Call initiated successfully.";
        setPhoneCallModal(false);
        setPhoneCallCandidate(null);
        Swal.fire({
        title: "Success!",
        text: message,
        icon: "success",
        confirmButtonText: "OK",
        }).then(async (result) => {
        if (result.isConfirmed && callUrl) {
            try {
            await fetch(callUrl, { mode: "no-cors" });
            } catch (e) {
            console.error("Error triggering call URL:", e);
            }
        }
        });

    } catch (err) {
        Swal.fire(
        "Error",
        err?.response?.data?.message || "Failed to initiate call.",
        "error"
        );
    } finally {
        setPhoneCallLoading(false);
    }
    };

    const [showWebsiteDomainModal, setShowWebsiteDomainModal] = useState(false);
    const [selectedWebsiteDomain, setSelectedWebsiteDomain] = useState("vitelglobal.com");
    const [isVitelGlobalCompany, setIsVitelGlobalCompany] = useState(false);
    const [showAllQuestionsModal, setShowAllQuestionsModal] = useState(false);
    const [showAddDepartmentModal, setShowAddDepartmentModal] = useState(false);
    const [filterHasNoResults, setFilterHasNoResults] = useState(false);
    const [newDepartmentName, setNewDepartmentName] = useState("");
    const [addDeptLoading, setAddDeptLoading] = useState(false);
    const [candidateDataMap, setCandidateDataMap] = useState({})
    const [addDeptError, setAddDeptError] = useState("");
    const [consentStatusFilterMap, setConsentStatusFilterMap] = useState({})
    const [emailSentFilterMap, setEmailSentFilterMap] = useState({})
    const [sendTestFilterMap, setSendTestFilterMap] = useState({})
    const [aiScreeningFilterMap, setAiScreeningFilterMap] = useState({})
    const sourceOptions = [
        { value: "Vitel Global", label: "Vitel Global" },
        ];
    const handleAddDepartment = async () => {
    if (!newDepartmentName.trim()) {
        setAddDeptError("Department name is required");
        return;
    }
    setAddDeptLoading(true);
    setAddDeptError("");
    try {
        const res = await axios.post(`/api/v1/departmentsv1/`, {
            company_id: companyId,
            name: newDepartmentName.trim(),
            description: "",
        });

        const updated = await axios.get(`/api/v1/get-all-departments/?company_id=${companyId}`);
        const updatedList = normalizeDepartmentList(updated.data);
        apiRequestCache.delete(`departments:${companyId}`);
        setDepartments(updatedList);
        const newDept =
            res.data?.department_id
                ? updatedList.find(d => d.department_id === res.data.department_id)
                : updatedList.find(d => d.name.toLowerCase() === newDepartmentName.trim().toLowerCase());

        if (newDept) {
            setSelectedDepartment(newDept.department_id);
            setValue("job_order_department", newDept.department_id);
            clearErrors("job_order_department");
        }

        setShowAddDepartmentModal(false);
        setNewDepartmentName("");
        toast("success", "Success", "Department added successfully.");
    } catch (error) {
        setAddDeptError(
            error?.response?.data?.message || "Failed to add department. Please try again."
        );
    } finally {
        setAddDeptLoading(false);
    }
};
const [showAddDesignationModal, setShowAddDesignationModal] = useState(false);
const [newDesignationName, setNewDesignationName] = useState("");
const [addDesignLoading, setAddDesignLoading] = useState(false);
const [addDesignError, setAddDesignError] = useState("");
const handleAddDesignation = async () => {
    if (!newDesignationName.trim()) {
        setAddDesignError("Designation name is required");
        return;
    }
    setAddDesignLoading(true);
    setAddDesignError("");
    try {
        const res = await axios.post(`/api/v1/designationsv1/`, {
            company_id: companyId,
            name: newDesignationName.trim(),
            description: "",
        });

        const updated = await axios.get(`/api/v1/designationsv1/?company_id=${companyId}&no_pagination=true`);
        const updatedList = normalizeDesignationList(updated.data);
        apiRequestCache.delete(`designations:${companyId}`);
        setDesignation(updatedList);

        const newDesign =
            res.data?.designation_id
                ? updatedList.find(d => d.designation_id === res.data.designation_id)
                : updatedList.find(d => d.name.toLowerCase() === newDesignationName.trim().toLowerCase());

        if (newDesign) {
            setSelectedDesignation(newDesign.designation_id);
            setValue("job_order_designation", newDesign.designation_id);
            clearErrors("job_order_designation");
        }

        setShowAddDesignationModal(false);
        setNewDesignationName("");
        toast("success", "Success", "Designation added successfully.");
    } catch (error) {
        setAddDesignError(
            error?.response?.data?.message || "Failed to add designation. Please try again."
        );
    } finally {
        setAddDesignLoading(false);
    }
};
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedStateId, setSelectedStateId] = useState("");
    const [selectedCityId, setSelectedCityId] = useState("");
    const getLocationOptionId = (option, type) =>
        option?.[`${type}_id`] ?? option?.id ?? option?.code ?? "";
    const getLocationOptionName = (option, type) =>
        option?.name ?? option?.[`${type}_name`] ?? "";
    const normalizeLocationValue = (value) =>
        String(value ?? "").trim().toLowerCase();
    const findLocationOption = (options = [], value, type) => {
        const normalizedValue = normalizeLocationValue(value);
        if (!normalizedValue) return null;

        return options.find((option) => {
            const optionId = normalizeLocationValue(getLocationOptionId(option, type));
            const optionName = normalizeLocationValue(getLocationOptionName(option, type));
            return optionId === normalizedValue || optionName === normalizedValue;
        }) || null;
    };
    useEffect(() => {
        if (!hasVgus) return;
    const fetchStates = async () => {
        try {
        const res = await axios.get("/api/v1/get-all-states/?country_id=7");
        const data = res.data;
        setStates(data.results || []);
        } catch (err) {
        console.error(err);
        }
    };
    fetchStates();
    }, []);
    const fetchCities = async (stateId) => {
        if (!hasVgus) return [];
        try {
            const res = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`);
            const data = res.data;
            const cityOptions = data.results || [];
            setCities(cityOptions);
            return cityOptions;
        } catch (err) {
            console.error(err);
            return [];
        }
    };


    const navigate = useNavigate();
    const locationRoute = useLocation();
    const toastRef = useRef(null);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState("");
    // kept states that are used by UI & logic
    const [departments, setDepartments] = useState([]);
    const departmentList = useMemo(
        () => normalizeDepartmentList(departments),
        [departments]
    );
    const [permissions, setPermissions] = useState({});
    const [designation, setDesignation] = useState([]);
    const designationList = useMemo(
        () => normalizeDesignationList(designation),
        [designation]
    );
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedDesignation, setSelectedDesignation] = useState("");
    const [agentOptions, setAgentOptions] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [loadingAgents, setLoadingAgents] = useState(false);
    // ===== COMMUNICATION ACTION STATES =====
    const [selectedCandidateRows, setSelectedCandidateRows] = useState({});
    const [configureCallModal, setConfigureCallModal] = useState(false);
    const [configureCallData, setConfigureCallData] = useState({
        testType: null,
        agent: null,
        source: null,
        scheduleDate: null,
        firstScreeningQuestions: [""],
        secondScreeningQuestions: {},
    });
    const [configureCallStep, setConfigureCallStep] = useState("second");
    const [configureCallJob, setConfigureCallJob] = useState(null);
    const [originalSecondSQ, setOriginalSecondSQ] = useState({});
    const [loadingInitiateCall, setLoadingInitiateCall] = useState(false);
    const [loadingCreateCall, setLoadingCreateCall] = useState(false);
    const [firstScreeningData, setFirstScreeningData] = useState([]);
    const [firstScreeningLoading, setFirstScreeningLoading] = useState(false);
    const [voiceOptions, setVoiceOptions] = useState([]);
    const [showBulkOutreachModal, setShowBulkOutreachModal] = useState(false);
    const [outreachTab, setOutreachTab] = useState("compose");
    const [outreachChannels, setOutreachChannels] = useState({ email: true, whatsapp: true, sms: false });
    const [outreachSubject, setOutreachSubject] = useState("");
    const [outreachBody, setOutreachBody] = useState("");
    const [outreachPayloadBody, setOutreachPayloadBody] = useState("");
    const [outreachFrequency, setOutreachFrequency] = useState("daily");
    const [outreachMaxReminders, setOutreachMaxReminders] = useState(5);
    const [outreachAutoStop, setOutreachAutoStop] = useState({ accept: true, decline: true, max: true });
    const [isSendingOutreach, setIsSendingOutreach] = useState(false);
    // ===== END COMMUNICATION ACTION STATES =====
    const [isPostedToWebsite, setIsPostedToWebsite] = useState(false);
    const [modeOfOperationTypes, setModeOfOperationTypes] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [jobOrderId, setJobOrderId] = useState("");
    const [jdDocumentUrl, setJdDocumentUrl] = useState("");
    const [copySuccess, setCopySuccess] = useState(false);
    const [showLinkedInModal, setShowLinkedInModal] = useState(false);
    const [selectedLinkedInOrg, setSelectedLinkedInOrg] = useState(null);
    const [postToLinkedIn, setPostToLinkedIn] = useState(false);
    const [showReviewModal, setShowReviewModal] = useState(false);
const [isPosting, setIsPosting] = useState(false)
const [selectedTemplateContent, setSelectedTemplateContent] = useState("")
const [selectedPreviewId, setSelectedPreviewId] = useState(null)
  const handleChange = (e) => {
        setSelectedContacts(e.value);
        setValue("selectedContacts", e.value);
        setOnchangeTrue(true);
        setOnlySaveDone(false);
        clearErrors("selectedContacts");

        // ✅ instantly clear filter
        setFilterText("");
    };

const handlePostToLinkedIn = async () => {
  if (!selectedTemplateContent) {
    Swal.fire({
      icon: "warning",
      title: "No template selected",
      text: "Please select a LinkedIn template before posting.",
    })
    return
  }

  try {
    setIsPosting(true)

    const payload = {
      job_id: Number(jobData.job_id),
      content: selectedTemplateContent,
      preview_id: selectedPreviewId,
      post_to_linkedin:postToLinkedIn
    }

    await axios.post("/api/v1/post-to-linkedin/", payload)
    await getsingleJobOrderid(jobData.job_id);
    setJobData(prev => ({ ...prev, post_to_linkedin: true }));
    setPostToLinkedIn(true); 

     Swal.fire({
      icon: "success",
      title: "Posted Successfully",
      text: "Job has been posted to LinkedIn.",
    }).then(() => {
      navigateBackToJobOrders();
    });

    // setPostToLinkedIn(true)
    // await getsingleJobOrderid(jobData.job_id)

  }catch (error) {
  console.log(error)

  const errorMessage =
    error?.response?.data?.message ||   // ✅ your case
    error?.response?.data?.error ||     // backup
    error?.message ||                   // axios message
    "Failed to post job on LinkedIn."

  Swal.fire({
    icon: "error",
    title: "Posting Failed",
    text: errorMessage,
  }).then(() => {
    navigateBackToJobOrders()
  })
} finally {
  setIsPosting(false)
}

}


    const [linkedInOrgs, setLinkedInOrgs] = useState([]);
    const fetchLinkedInOrgs = async () => {
    try {
        const response = await axios.get(`/api/v1/linkedin-details/?company_id=${companyId}`);
        console.log("response.data.results",response.data.results)
        setLinkedInOrgs(response.data.results || []);
    } catch (error) {
        console.error("Error fetching LinkedIn organizations:", error);
        toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch LinkedIn organizations.",
        life: 3000,
        });
    }
    };



// Function to copy content to clipboard
const handleCopyContent = () => {
    // Get the modal body content
    const modalBody = document.querySelector('.modal-body');
    if (!modalBody) return;

    // Extract all text content (including table)
    const contentToCopy = Array.from(modalBody.querySelectorAll('*'))
        .map(el => {
            if (el.tagName === 'A') return `${el.textContent}: ${el.href}`; // Include links
            return el.textContent || '';
        })
        .filter(text => text.trim() !== '')
        .join('\n\n');

    // Copy to clipboard
    navigator.clipboard.writeText(contentToCopy)
        .then(() => {
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        })
        .catch((err) => {
            console.error("Failed to copy: ", err);
            alert("Failed to copy content. Please try again.");
        });
};



    const fetchModeOfOperationTypes = async () => {
        try {
            const response = await getCachedRequest(
                "workplace-types",
                () => axios.get('/api/v1/get-all-workplace-type/', {}),
                true
            );
            console.log("response",response)
            const types = response.data?.results.map(item => ({
                id: item.id,
                name: item.workplace_type,
            })) || [];
            setModeOfOperationTypes(types);
        } catch (error) {
            console.error("Error fetching mode of operation types:", error);
        }
    };
    useEffect(() => {
        fetchModeOfOperationTypes();
    }, []);
    const [difficultyLevel, setDifficultyLevel] = useState("");
    const [sectionData, setSectionData] = useState([]);
    const [testtypes, setTesttypes] = useState([]);
    const [pendingPermissions, setPendingPermissions] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("");
     const [selectedCategoryname, setSelectedCategoryName] = useState("");
    const [headingText, setHeadingText] = useState("");
    const [jobIdStr, setJobIdStr] = useState("");
    const [mainTab, setMainTab] = useState(0);
    const [questionsGenerated, setQuestionsGenerated] = useState(false);
    const [userSearchText, setUserSearchText] = useState("");
    const [postToWebsite, setPostToWebsite] = useState(false);



    const [time_settings, set_time_settings] = useState([]);
    const [TimesettingError, setTimesettingError] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [jobData, setJobData] = useState(null);
    const jobDataId = jobData?.job_id || jobData?.id;
    const [editJobOptions, setEditJobOptions] = useState([]);
    const [selectedEditJobId, setSelectedEditJobId] = useState(id || "");
    const [editJobsLoading, setEditJobsLoading] = useState(false);
    const [editJobPage, setEditJobPage] = useState(1);
    const [editJobTotalCount, setEditJobTotalCount] = useState(0);
    const [editJobSearchText, setEditJobSearchText] = useState("");
    const [jobCandidates, setJobCandidates] = useState([]);
    const [jobCandidatesLoading, setJobCandidatesLoading] = useState(false);
    const lastJobCandidatesRequestKeyRef = useRef("");
    const candidateFoldersLoadedRef = useRef({});
    const [selectedJobCandidate, setSelectedJobCandidate] = useState(null);
    const [jobCandidateViewTab, setJobCandidateViewTab] = useState("resume");
    const [jobCandidateSearch, setJobCandidateSearch] = useState("");
    const [candidateApiSearch, setCandidateApiSearch] = useState("");
    const [candidateFolders, setCandidateFolders] = useState([]);
    const [candidateFoldersLoading, setCandidateFoldersLoading] = useState(false);
    // const [selectedCandidateFolderId, setSelectedCandidateFolderId] = useState("");
    const [selectedShortlistFolderId, setSelectedShortlistFolderId] = useState("");
    const [showAddToFolderModal, setShowAddToFolderModal] = useState(false);
    const [showFolderCandidatesModal, setShowFolderCandidatesModal] = useState(false);
    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
    const [newFolderName, setNewFolderName] = useState("");
    const [creatingCandidateFolder, setCreatingCandidateFolder] = useState(false);
    const [addingCandidatesToFolder, setAddingCandidatesToFolder] = useState(false);
    const [folderCandidates, setFolderCandidates] = useState([]);
    const [folderCandidatesLoading, setFolderCandidatesLoading] = useState(false);
    const [aiResultFilterOpen, setAiResultFilterOpen] = useState(false);
    const [scheduleInterviewModal, setScheduleInterviewModal] = useState(false);
    const [scheduleInterviewCandidate, setScheduleInterviewCandidate] = useState(null);
    const [scheduleInterviewSaving, setScheduleInterviewSaving] = useState(false);
    const [scheduleInterviewForm, setScheduleInterviewForm] = useState({
        subject: "",
        start: "",
        end: "",
        contactIds: "",
        body: "",
    });
    const [testResultsModal, setTestResultsModal] = useState(false);
    const [testResultsCandidate, setTestResultsCandidate] = useState(null);
    const [candidateTalentScanResultMap, setCandidateTalentScanResultMap] = useState({});
    const [loadingTalentScanResultMap, setLoadingTalentScanResultMap] = useState({});
    useEffect(() => {
        const scrollToCreateJobOrderTop = () => {
            if (createJobOrderPageRef.current) {
                createJobOrderPageRef.current.scrollTop = 0;
            }
        };

        requestAnimationFrame(scrollToCreateJobOrderTop);
    }, [mainTab]);
        // useEffect(() => {
        // if (!selectedJobCandidate) return;
        // const jobId = jobData?.job_id || jobOrderId || id;
        // if (!jobId) return; 
        // const candidateId = selectedJobCandidate?.candidate_id || selectedJobCandidate?.id;
        // if (!candidateId) return;
        // const resultKey = `${jobId}-${candidateId}`;
        //     setCandidateTalentScanResultMap(prev => {
        //     const updated = { ...prev };
        //     delete updated[resultKey];
        //     return updated;
        // });
        // fetchCandidateTalentScanResult(selectedJobCandidate);
        // }, [
        // selectedJobCandidate?.job_candidate_id ?? selectedJobCandidate?.candidate_id,
        // jobData?.job_id  
        // ]);
        useEffect(() => {
            if (!selectedJobCandidate) return;
            fetchCandidateTalentScanResult(selectedJobCandidate);
        }, [
            selectedJobCandidate?.job_candidate_id ?? selectedJobCandidate?.candidate_id,
            jobData?.job_id  
        ]);
    const formatUTCDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
const getCandidateTalentScanJobId = candidate =>
    candidate?.job_id ??
    candidate?.job?.job_id ??
    candidate?.job?.id ??
    candidate?.job_candidate?.job_id ??
    candidate?.job_candidate_job_id ??
    (jobData?.job_id || jobOrderId || id);
const getCandidateTalentScanId = candidate =>
    candidate?.candidate_id ??   
    candidate?.talent_scan_id ??
    candidate?.candidate_talent_scan_id ??
    candidate?.id;
const getTalentScanResultKey = candidate => {
    const jobId = getCandidateTalentScanJobId(candidate);
    const talentScanId = getCandidateTalentScanId(candidate);
    return jobId && talentScanId ? `${String(jobId)}-${String(talentScanId)}` : "";
};
const fetchCandidateTalentScanResult = async candidate => {
    const resultKey = getTalentScanResultKey(candidate);
    if (!resultKey) return
    if (loadingTalentScanResultMap[resultKey]) return
    if (candidateTalentScanResultMap[resultKey]) return 

    const jobId = getCandidateTalentScanJobId(candidate);
    const talentScanId = getCandidateTalentScanId(candidate);
    if (!jobId || !talentScanId) return;

    try {
        setLoadingTalentScanResultMap(prev => ({ ...prev, [resultKey]: true }));
        const response = await axios.post(
            `/api/v1/candidate-talent-scan-result/`,
            { talent_scan_id: talentScanId, job_id: jobId },
            { params: { page: 1, size: 10, ...(companyId ? { company_id: companyId } : {}) } }
        );
        setCandidateTalentScanResultMap(prev => ({
            ...prev,
            [resultKey]: response?.data?.talent_scan_result ?? { results: [] },
        }));
    } catch (error) {
        console.error("Failed to fetch candidate talent scan result", error);
        setCandidateTalentScanResultMap(prev => ({ ...prev, [resultKey]: { results: [] } }));
    } finally {
        setLoadingTalentScanResultMap(prev => ({ ...prev, [resultKey]: false }));
    }
};
useEffect(() => {
  if (testResultsModal && testResultsCandidate) {
    const resultKey = getTalentScanResultKey(testResultsCandidate);
    const alreadyHasData = resultKey && candidateTalentScanResultMap[resultKey]?.results?.length > 0;
    if (!alreadyHasData) {
      fetchCandidateTalentScanResult(testResultsCandidate);
    }
  }
}, [testResultsModal, testResultsCandidate]);

    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info") || "{}");
    const extension = userInfos?.user_details?.extension
    const companies = userInfos?.user_details?.companies_data || [];
        const hasVgus = companies.some(
        (c) => c.company_domain === "vgus"
        );
    const routeState = locationRoute.state || {};
    const hasReturnCompanyId = Object.prototype.hasOwnProperty.call(
        routeState,
        "selectedCompanyId"
    );
    const returnCompanyId = hasReturnCompanyId
        ? routeState.selectedCompanyId
        : routeState.companyId;
    const intialcompanyId =
        returnCompanyId !== undefined
            ? returnCompanyId
            : userInfos?.user_details?.companies_data?.[0]?.company_id;
    const [companyId, setCompanyId] = useState(id ? (returnCompanyId ?? "") : intialcompanyId);
    const navigateBackToJobOrders = () => {
        const selectedCompanyId =
            returnCompanyId !== undefined ? returnCompanyId : companyId;
        navigate("/all-job-orders", { state: { selectedCompanyId } });
    };
    const getJobIdValue = (job) => {
        const safeJob = job || {};
        return safeJob.job_id ?? safeJob.id ?? safeJob.job_order_id ?? safeJob.value ?? "";
    };
    const getJobTitleValue = (job) => {
        const safeJob = job || {};
        return safeJob.job_title || safeJob.position || safeJob.job_order_id || safeJob.label || "Job Order";
    };
    const normalizeEditJobOption = (job) => {
        if (!job) return null;
        const value = getJobIdValue(job);
        if (!value) return null;

        return {
            value: String(value),
            label: getJobTitleValue(job),
            job,
        };
    };
    const mergeEditJobOptions = (jobs = [], currentJob = jobData) => {
        const optionMap = new Map();

        jobs.forEach((job) => {
            const option = normalizeEditJobOption(job);
            if (option) optionMap.set(option.value, option);
        });

        const currentOption = normalizeEditJobOption(currentJob);
        if (currentOption) optionMap.set(currentOption.value, currentOption);

        return Array.from(optionMap.values());
    };
    const getJobCompanyId = (data = {}) =>
        data.company_id ??
        data.company?.company_id ??
        data.company?.id ??
        (typeof data.company === "number" || typeof data.company === "string" ? data.company : null) ??
        data.client_id ??
        null;
    const getWebsiteDomainFromPostKey = (postKey, region) => {
        const normalized = String(postKey || region || "").trim().toLowerCase();

        if (
            normalized === "vg.com" ||
            normalized === "us" ||
            normalized === "usa" ||
            normalized.includes("united states")
        ) {
            return "vitelglobal.com";
        }

        if (
            normalized === "vg.in" ||
            normalized === "in" ||
            normalized.includes("india")
        ) {
            return "vitelglobal.in";
        }

        return "";
    };
    const getPostedWebsiteDomain = (data = jobData) =>
        getWebsiteDomainFromPostKey(
            data?.post_in || data?.posted_in || data?.website_key,
            data?.key_region || data?.region || data?.job_region
        ) || selectedWebsiteDomain;
    const normalizeCandidateList = value => {
        if (Array.isArray(value)) return value.filter(Boolean);
        if (typeof value === "string") {
            return value.split(",").map(item => item.trim()).filter(Boolean);
        }
        return [];
    };
    const getSelectedJobCandidateList = (...keys) => {
        for (const key of keys) {
            const values = normalizeCandidateList(selectedJobCandidate?.[key]);
            if (values.length) return values;
        }
        return [];
    };
    const selectedJobPrimarySkills = getSelectedJobCandidateList("primary_skills", "primary_skill_names");
    const selectedJobSecondarySkills = getSelectedJobCandidateList("secondary_skills", "secondary_skill_names");
    const selectedJobOtherSkills = getSelectedJobCandidateList("other_skills", "other_skill_names", "skills");
    const selectedJobEducation = normalizeCandidateList(selectedJobCandidate?.education || selectedJobCandidate?.education_history);
    const selectedJobEmployment = normalizeCandidateList(selectedJobCandidate?.employment || selectedJobCandidate?.employment_history);
    const selectedJobCertificates = normalizeCandidateList(selectedJobCandidate?.certificates || selectedJobCandidate?.certifications);
    const getCandidateName = candidate =>
        [candidate?.first_name, candidate?.middle_name, candidate?.last_name]
            .filter(Boolean)
            .join(" ")
            .trim() || "Candidate";
    const filteredJobCandidates = useMemo(() => jobCandidates, [jobCandidates]);
    const displayCandidates = filteredJobCandidates;
    const folderJobId = String(jobDataId || jobOrderId || id || "");
    const normalizeFolderResponse = data => {
    if (Array.isArray(data)) return data;
    
    // Direct candidates array
    if (Array.isArray(data?.candidates)) return data.candidates;
    
    // Standard DRF results
    if (Array.isArray(data?.results)) return data.results;
    
    // Nested under results.candidates (your current API)
    if (data?.results?.candidates && Array.isArray(data.results.candidates)) {
        return data.results.candidates;
    }
    
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.data?.results)) return data.data.results;
    if (Array.isArray(data?.data?.candidates)) return data.data.candidates;
    if (Array.isArray(data?.folders)) return data.folders;
    
    return [];
};
    const getFolderId = folder =>
        folder?.id ?? folder?.folder_id ?? folder?.value ?? "";
    const getFolderName = folder =>
        folder?.name ?? folder?.folder_name ?? folder?.label ?? "Folder";
    const fetchCandidateFolders = async (jobId = folderJobId) => {
        if (!jobId) {
            setCandidateFolders([]);
            return;
        }

        try {
            setCandidateFoldersLoading(true);
            const normalizedJobId = String(jobId);
            if (candidateFoldersLoadedRef.current[normalizedJobId]) {
                setCandidateFolders(candidateFoldersLoadedRef.current[normalizedJobId]);
                return;
            }

            const response = await getCachedRequest(
                `folders:${normalizedJobId}`,
                () => axios.get("/api/v1/folders/", {
                    params: { job_id: normalizedJobId },
                }),
                true
            );
            const folders = normalizeFolderResponse(response?.data);
            candidateFoldersLoadedRef.current[normalizedJobId] = folders;
            setCandidateFolders(folders);

            setFolderFilterMap(prev => {
                const prevValue = prev[normalizedJobId];
                if (!prevValue) return prev;
                const stillExists = folders.some(
                    folder => String(getFolderId(folder)) === String(prevValue)
                );
                if (stillExists) return prev; 
                return { ...prev, [normalizedJobId]: "" };
            });

        } catch (error) {
            setCandidateFolders([]);
            Swal.fire(
                "Error",
                error?.response?.data?.message || "Failed to fetch folders.",
                "error"
            );
        } finally {
            setCandidateFoldersLoading(false);
        }
    };
    const fetchFolderCandidates = async (folderId) => {
    if (!folderId) {
        setFolderCandidates([]);
        return;
    }

    try {
        setFolderCandidatesLoading(true);
        const response = await axios.get(`/api/v1/folders/${folderId}/candidates/`);
        
        const candidates = normalizeFolderResponse(response?.data);
        setFolderCandidates(candidates);

        // Optional: Store folder name for display
        const folderName = response?.data?.results?.folder_name || 
                          response?.data?.folder_name || 
                          "Selected Folder";
        
        // You can add a state for folder name if needed
        console.log(`Loaded ${candidates.length} candidates from folder: ${folderName}`);

    } catch (error) {
        console.error("Folder candidates fetch error:", error);
        setFolderCandidates([]);
        Swal.fire({
            icon: "error",
            title: "Failed to load folder",
            text: error?.response?.data?.message || "Failed to fetch folder candidates.",
        });
    } finally {
        setFolderCandidatesLoading(false);
    }
};
    const handleCreateCandidateFolder = async () => {
    const folderName = newFolderName.trim();
    if (!folderJobId) {
        Swal.fire("Warning", "Job ID not found.", "warning");
        return;
    }
    if (!folderName) {
        Swal.fire("Warning", "Please enter folder name.", "warning");
        return;
    }

    try {
        setCreatingCandidateFolder(true);
        await axios.post("/api/v1/folders/", {
            job_id: folderJobId,
            name: folderName,
        });
        apiRequestCache.delete(`folders:${String(folderJobId)}`);
        delete candidateFoldersLoadedRef.current[String(folderJobId)];
        await fetchCandidateFolders(folderJobId);
        setShowCreateFolderModal(false);
        setNewFolderName("");
        Swal.fire("Success", "Folder created successfully.", "success");
    } catch (error) {
        Swal.fire(
            "Error",
            error?.response?.data?.message || "Failed to create folder.",
            "error"
        );
    } finally {
        setCreatingCandidateFolder(false);
    }
};
const handleAddSelectedCandidatesToFolder = async (folderIdParam) => {
    const folderId = folderIdParam;
    const selected = selectedCandidateRows[jobDataId] || [];
    if (!folderId) {
        Swal.fire("Warning", "Please select a folder.", "warning");
        return;
    }
    if (selected.length === 0) {
        Swal.fire("Warning", "Please select at least one candidate.", "warning");
        return;
    }

    try {
        setAddingCandidatesToFolder(true);

        const results = await Promise.allSettled(
            selected.map(candidateId =>
                axios.post(`/api/v1/folders/${folderId}/candidates/`, {
                    job_candidate_id: candidateId,
                })
            )
        );

        const succeeded = results.filter(r => r.status === "fulfilled").length;
        const alreadyInFolder = results.filter(r =>
            r.status === "rejected" &&
            (r.reason?.response?.data?.error === "Candidate already in folder" ||
             r.reason?.response?.data?.message === "Candidate already in folder")
        ).length;
        const otherFailed = results.filter(r =>
            r.status === "rejected" &&
            r.reason?.response?.data?.error !== "Candidate already in folder" &&
            r.reason?.response?.data?.message !== "Candidate already in folder"
        ).length;

        setShowAddToFolderModal(false);
        setAddToFolderId("");

        // Build summary message
        const lines = [];
        if (succeeded > 0) lines.push(`✅ ${succeeded} candidate(s) added successfully.`);
        if (alreadyInFolder > 0) lines.push(`⚠️ ${alreadyInFolder} candidate(s) already in folder.`);
        if (otherFailed > 0) lines.push(`❌ ${otherFailed} candidate(s) failed to add.`);

        const allAlready = alreadyInFolder === selected.length;
        const allSuccess = succeeded === selected.length;

        Swal.fire({
            icon: allAlready ? "warning" : allSuccess ? "success" : "info",
            title: allAlready
                ? "Already in Folder"
                : allSuccess
                ? "Added Successfully"
                : "Partial Success",
            html: lines.join("<br/>"),
        });

    } catch (error) {
        Swal.fire("Error", error?.response?.data?.message || "Failed to add candidates to folder.", "error");
    } finally {
        setAddingCandidatesToFolder(false);
    }
};
const [deletingCandidateFolder, setDeletingCandidateFolder] = useState(false);
const handleDeleteCandidateFolder = async (folderId) => {
    if (!folderId) {
        Swal.fire("Warning", "Please select a folder to delete.", "warning");
        return;
    }
    const folder = candidateFolders.find(f => String(getFolderId(f)) === String(folderId));
    const folderName = getFolderName(folder);

    const result = await Swal.fire({
        title: "Delete Folder?",
        text: `Are you sure you want to delete "${folderName}"? This cannot be undone.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
    });
    if (!result.isConfirmed) return;

    try {
        setDeletingCandidateFolder(true);
        await axios.delete(`/api/v1/folders/${folderId}/`);
        setFolderFilterMap(prev => ({ ...prev, [jobDataId]: "" }));
        setFolderCandidates([]);
        setSelectedCandidateRows(prev => ({ ...prev, [jobDataId]: [] }));
        apiRequestCache.delete(`folders:${String(folderJobId)}`);
        delete candidateFoldersLoadedRef.current[String(folderJobId)];
        await fetchCandidateFolders(folderJobId);
        Swal.fire("Deleted", "Folder deleted successfully.", "success");
    } catch (error) {
        Swal.fire(
            "Error",
            error?.response?.data?.message || "Failed to delete folder.",
            "error"
        );
    } finally {
        setDeletingCandidateFolder(false);
    }
};
const handleRemoveCandidateFromFolder = async (jobCandidateId) => {
    const folderId = folderFilterMap[jobDataId];
    if (!folderId) return;

    const result = await Swal.fire({
        title: "Remove from Folder?",
        text: "Are you sure you want to remove this candidate from the folder?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, remove",
        cancelButtonText: "Cancel",
    });
    if (!result.isConfirmed) return;

    try {
        await axios.delete(`/api/v1/folders/${folderId}/candidates/`, {
            data: { job_candidate_id: jobCandidateId },
        });
        Swal.fire({
            icon: "success",
            title: "Removed",
            text: "Candidate removed from folder.",
            timer: 1500,
            showConfirmButton: false,
        });
        // Refresh the candidate list
            setSelectedCandidateRows(prev => ({
            ...prev,
            [jobDataId]: (prev[jobDataId] || []).filter(id => id !== jobCandidateId),
        }));
        lastJobCandidatesRequestKeyRef.current = "";
        setPage(1);
        setFolderFilterMap(prev => ({ ...prev, [jobDataId]: folderId }));
    } catch (err) {
        Swal.fire(
            "Error",
            err?.response?.data?.message || "Failed to remove candidate from folder.",
            "error"
        );
    }
};
    const getFolderCandidateName = candidate =>
        getCandidateName(candidate?.candidate || candidate) ||
        candidate?.candidate_name ||
        candidate?.name ||
        "Candidate";
    const getFolderCandidateEmail = candidate =>
        candidate?.email ||
        candidate?.candidate_email ||
        candidate?.candidate?.email ||
        "-";
    const getFolderCandidatePhone = candidate =>
        candidate?.mobile_phone ||
        candidate?.candidate_phone ||
        candidate?.candidate?.mobile_phone ||
        "-";
    const handleShowShortlistedFolderChange = async folderId => {
        setSelectedShortlistFolderId(folderId);
        if (!folderId) return;
        await fetchFolderCandidates(folderId);
        setShowFolderCandidatesModal(true);
    };
   useEffect(() => {
    if (mainTab === 5 && folderJobId) {
        fetchCandidateFolders(folderJobId);
    }
}, [mainTab, folderJobId]);
    const activeAiResultFilterCount = [
        emailSentFilterMap[jobDataId],
        sendTestFilterMap[jobDataId],
        consentStatusFilterMap[jobDataId],
         aiScreeningFilterMap[jobDataId],
    ].filter(Boolean).length;
    const renderSkillPills = skills =>
        skills.length ? (
            skills.map((skill, index) => (
                <span key={`${skill}-${index}`} className="badge bg-light text-dark border me-2 mb-2">
                    {skill}
                </span>
            ))
        ) : (
            <span className="text-muted">-</span>
        );
    const renderCandidateHistory = (items, type) => {
        if (!items.length) return <div className="text-muted">No records found.</div>;
        return items.map((item, index) => (
            <div key={`${type}-${index}`} className="border-bottom py-2">
                {type === "education" && (
                    <>
                        <div className="fw-semibold">{item.degree || "-"}</div>
                        <div className="text-muted small">{item.school_name || "-"}</div>
                        <div className="small">{[item.field_of_study, item.end_year].filter(Boolean).join(" | ") || "-"}</div>
                    </>
                )}
                {type === "employment" && (
                    <>
                        <div className="fw-semibold">{item.job_title || "-"}</div>
                        <div className="text-muted small">{item.company_name || "-"}</div>
                        {/* <div className="small">{[item.start_date, item.end_date || "Present"].filter(Boolean).join(" - ") || "-"}</div>  */}
                    </>
                )}
                {type === "certificates" && (
                    <div className="fw-semibold">{item.certificate_name || item.name || item.title || "-"}</div>
                )}
            </div>
        ));
    };
    const toDateInputValue = date => {
        const pad = value => String(value).padStart(2, "0");
        const d = date ? new Date(date) : new Date();
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };
    const formatScheduleDate = value => value ? String(value).split("T")[0] : "";
    const formatScheduleTime = value => value ? String(value).split("T")[1] || "" : "";
    const openScheduleInterview = (candidate = selectedJobCandidate) => {
        const start = new Date();
        start.setHours(start.getHours() + 1, 0, 0, 0);
        const end = new Date(start);
        end.setMinutes(end.getMinutes() + 30);
        setScheduleInterviewCandidate(candidate);
        setScheduleInterviewForm({
            subject: `Interview - ${getCandidateName(candidate)}`,
            start: toDateInputValue(start),
            end: toDateInputValue(end),
            contactIds: "",
            body: "",
        });
        setScheduleInterviewModal(true);
    };
    const closeScheduleInterview = () => {
        setScheduleInterviewModal(false);
        setScheduleInterviewCandidate(null);
    };
    const saveScheduleInterview = async () => {
        const candidate = scheduleInterviewCandidate || selectedJobCandidate;
        const currentJobId = jobData?.job_id || jobOrderId || id;
        const candidateId = candidate?.candidate_id || candidate?.id;
        const candidateEmail = candidate?.email || candidate?.candidate_email;
        const contactIds = scheduleInterviewForm.contactIds
            .split(",")
            .map(item => item.trim())
            .filter(Boolean);

        if (!currentJobId || !candidateId || !scheduleInterviewForm.subject || !scheduleInterviewForm.start || !scheduleInterviewForm.end) {
            Swal.fire("Missing Details", "Please add subject, start time, end time, and make sure candidate/job are available.", "warning");
            return;
        }

        try {
            setScheduleInterviewSaving(true);
            await axios.post(`api/v1/events/?company_id=${companyId}`, {
                event_sub_type: "Panel Interview",
                event_type: "Interview",
                start_date: formatScheduleDate(scheduleInterviewForm.start),
                end_date: formatScheduleDate(scheduleInterviewForm.end),
                start_time: formatScheduleTime(scheduleInterviewForm.start),
                end_time: formatScheduleTime(scheduleInterviewForm.end),
                event_time: new Date(scheduleInterviewForm.start).toISOString(),
                candidate_id: [candidateId],
                candidates: candidateEmail ? [candidateEmail] : [],
                job_id: [currentJobId],
                contact_id: contactIds,
                subject: scheduleInterviewForm.subject,
                body: scheduleInterviewForm.body,
                event_priority: "Low",
                private: false,
                completed: false,
                reminder: 10,
            });

            Swal.fire("Success", "Interview scheduled successfully.", "success");
            closeScheduleInterview();
        } catch (error) {
            Swal.fire(
                "Error",
                error?.response?.data?.error || error?.response?.data?.message || "Failed to schedule interview.",
                "error"
            );
        } finally {
            setScheduleInterviewSaving(false);
        }
    };
    const createJobCandidateTabs = [
        { key: "resume", label: "Resume" },
        { key: "skills", label: "Skills" },
        { key: "education", label: `Education (${selectedJobEducation.length})` },
        { key: "employment", label: `Employment (${selectedJobEmployment.length})` },
        { key: "certificates", label: `Certificates (${selectedJobCertificates.length})` },
        // { key: "ai_result",    label: "AI Screening" }, 
    ];
    const renderCreateJobCandidateDetails = () => {
        if (!selectedJobCandidate) {
            return <div className="text-muted text-center py-4">Select a candidate to view details.</div>;
        }

        return (
            <div className="create-job-candidate-detail-card">
                <div className="create-job-candidate-detail-tabs">
                    {createJobCandidateTabs.map(tab => (
                        <button
                            key={tab.key}
                            type="button"
                            className={`btn btn-sm ${jobCandidateViewTab === tab.key ? "btn-primary" : "btn-light"}`}
                            onClick={() => setJobCandidateViewTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <div className="create-job-candidate-detail-body">
                    {jobCandidateViewTab === "resume" && (
                        <ResumePreviewPanel resumeUrl={selectedJobCandidate?.resume} height="600px" minHeight="600px" />
                    )}
                    {jobCandidateViewTab === "skills" && (
                        <>
                            <h6 className="fw-bold mb-2">Primary Skills ({selectedJobPrimarySkills.length})</h6>
                            <div className="mb-3">{renderSkillPills(selectedJobPrimarySkills)}</div>
                            <h6 className="fw-bold mb-2">Secondary Skills ({selectedJobSecondarySkills.length})</h6>
                            <div className="mb-3">{renderSkillPills(selectedJobSecondarySkills)}</div>
                            <h6 className="fw-bold mb-2">Other Skills ({selectedJobOtherSkills.length})</h6>
                            <div>{renderSkillPills(selectedJobOtherSkills)}</div>
                        </>
                    )}
                    {jobCandidateViewTab === "education" && renderCandidateHistory(selectedJobEducation, "education")}
                    {jobCandidateViewTab === "employment" && renderCandidateHistory(selectedJobEmployment, "employment")}
                    {jobCandidateViewTab === "certificates" && renderCandidateHistory(selectedJobCertificates, "certificates")}
                    {jobCandidateViewTab === "ai_result" && (
                        <AIResultPanel
                            candidate={selectedJobCandidate}
                            companyId={companyId}
                            onViewTestResults={(results) => {
                                setTestResultsCandidate(selectedJobCandidate);
                                if (Array.isArray(results) && results.length) {
                                    const resultKey = getTalentScanResultKey(selectedJobCandidate);
                                    if (resultKey) {
                                        setCandidateTalentScanResultMap(prev => ({
                                            ...prev,
                                            [resultKey]: { results }
                                        }));
                                    }
                                }
                                setTestResultsModal(true);
                            }}
                           onScheduleInterview={() => {
                                setRichScheduleCandidate({
                                    ...selectedJobCandidate,
                                    company: selectedJobCandidate?.company || selectedJobCandidate?.company_id || companyId,
                                });
                                setRichScheduleModalOpen(true);
                            }}
                        />
                    )}
                    
                </div>
            </div>
        );
    };
    const setCompanyWebsiteFlags = (company = {}) => {
        const companyName = String(
            company.company_name ||
            company.name ||
            company.company_domain ||
            ""
        ).toLowerCase();
        const isVitel =
            companyName.includes("vitel global") ||
            companyName.includes("vitelglobal");

        setIsVitelGlobalCompany(isVitel);

        if (!isVitel) {
            setSelectedWebsiteDomain("vitelglobal.com");
        }
    };
    const testTypeOptions = [
        { value: "telephonic_test", label: "Telephonic Test" },
    ];
    const buildConsentScheduleUrl = (job, consentToken = "") => {
        const params = new URLSearchParams();
        if (job?.id || job?.job_id) params.set("job_id", String(job?.id || job?.job_id));
        if (consentToken) params.set("consent_token", consentToken);
        const query = params.toString();
        return `${window.location.origin}/consent-schedule/${query ? `?${query}` : ""}`;
    };
    const buildConsentUnsubscribeUrl = (job) => {
        const params = new URLSearchParams();
        const companyName = job?.company_name || job?.client_name || "";
        const recruiterName = Array.isArray(job?.recruiters_names)
            ? job.recruiters_names.join(", ")
            : job?.created_by_name || "";
        const locationValue = Array.isArray(job?.location)
            ? job.location.join(", ")
            : job?.location || "";
        const skillsValue = Array.isArray(job?.skills)
            ? job.skills
            : typeof job?.skills === "string"
              ? job.skills.split(",").map(skill => skill.trim()).filter(Boolean)
              : [];
        if (job?.job_title) params.set("job_title", job.job_title);
        if (companyName) params.set("company_name", companyName);
        if (recruiterName) params.set("recruiter_name", recruiterName);
        if (locationValue) params.set("location", locationValue);
        if (job?.min_exp !== undefined && job?.min_exp !== null) params.set("min_exp", String(job.min_exp));
        if (job?.max_exp !== undefined && job?.max_exp !== null) params.set("max_exp", String(job.max_exp));
        if (job?.job_type || job?.employment_type || job?.type) {
            params.set("job_type", job?.job_type || job?.employment_type || job?.type);
        }
        if (job?.job_description) params.set("jd", job.job_description);
        if (skillsValue.length) params.set("skills", JSON.stringify(skillsValue));
        const query = params.toString();
        return `${window.location.origin}/consent-unsubscribe/`;
    };
    const fetchVoices = async () => {
        try {
            const response = await axios.get("/api/v1/voices/");
            if (response.data) {
                setVoiceOptions(response.data.map(v => ({ value: v.voice_code, label: v.name, language_code: v.language_code, audio_file: v.audio_file })));
            }
        } catch (err) {
            console.error("Error fetching voices:", err);
        }
    };

    useEffect(() => { 
        fetchVoices(); 
    }, []);

    const handleConfigureCallOpen = (job) => {
        const fq = job?.second_screening_questions || {};
        const firstScreening = Object.values(fq).filter(q => typeof q === "string" && q.trim() !== "");
        const firstScreeningArr = firstScreening.length > 0 ? firstScreening : [""];

        const sq = job?.second_screening_questions || {};
        const secondSQ = {};
        Object.entries(sq).forEach(([category, questions]) => {
            secondSQ[category] = Array.isArray(questions) && questions.length > 0 ? questions : [""];
        });

        const consentUrl = buildConsentScheduleUrl(job);

        setConfigureCallJob(job);
        setOriginalSecondSQ(JSON.parse(JSON.stringify(secondSQ)));
        setConfigureCallData({
            testType: testTypeOptions[0],
            agent: null,
            source: null,
            scheduleDate: null,
            firstScreeningQuestions: firstScreeningArr,
            secondScreeningQuestions: secondSQ,
        });
        setConfigureCallStep("second");
        setConfigureCallModal(true);
    };

    const handleConfigureCallClose = () => {
        setConfigureCallModal(false);
        setConfigureCallStep("first");
        setFirstScreeningData([]);
    };
    const handleCreateCall = async () => {
        const jobId = configureCallJob?.job_id;
        const candidateIds = selectedCandidateRows[jobId] || [];
        if (!jobId || candidateIds.length === 0) {
            Swal.fire("Warning", "Please select at least one candidate.", "warning");
            return;
        }
        const agentId = configureCallData.agent?.value;
        if (!agentId) {
            Swal.fire("Warning", "Please select an agent.", "warning");
            return;
        }
        if (!configureCallData.agent?.voice_code) {
            Swal.fire({
                icon: "warning",
                title: "Voice Not Configured",
                html: `The selected agent does not have a voice configured. Please assign a voice to this agent before sending consent.`,
                confirmButtonText: "OK",
            });
            return;
        }
        const questions = {};
        Object.entries(configureCallData.secondScreeningQuestions).forEach(([category, qs]) => {
            const filtered = qs.filter(q => q.trim() !== "");
            if (filtered.length > 0) {
                questions[category] = filtered;
            }
        });
        let scheduledDateTime = null;
        if (configureCallData.scheduleDate) {
            const d = configureCallData.scheduleDate;
            const pad = (n) => String(n).padStart(2, "0");
            scheduledDateTime = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}Z`;
        }
        setLoadingCreateCall(true);
        try {
            const hasChanged = JSON.stringify(questions) !== JSON.stringify(
                Object.fromEntries(
                    Object.entries(originalSecondSQ).map(([cat, qs]) => {
                        const filtered = qs.filter(q => q.trim() !== "");
                        return filtered.length > 0 ? [cat, filtered] : null;
                    }).filter(Boolean)
                )
            );
            if (hasChanged && Object.keys(questions).length > 0) {
                await axios.patch("/api/v1/update-screening-questions/", {
                    job_id: jobId,
                    second_screening_questions: questions,
                });
            }
            const consentLink = `${window.location.origin}/callconsent`;
            const response = await axios.post("api/v1/send-consent-mail/", {
                job_candidate_id: candidateIds.join(","),
                agent_id: configureCallData.agent?.agent_id || agentId,
                questions,
                interview_round: "secondary",
                consent_link: consentLink,
                ...(scheduledDateTime ? { scheduled_date_time: scheduledDateTime } : {}),
                ...(configureCallData.source ? { source: configureCallData.source.value } : {}),
            });
           const { skipped = [] } = response.data || {};

                if (skipped.length > 0) {
                const rows = skipped.map((item, index) => {
                    const name = item?.candidate || `Candidate ${index + 1}`;
                    const reason = item?.reason || "N/A";

                    return `
                    <tr>
                        <td style="padding:10px;border:1px solid #e5e7eb;font-weight:500;">
                        ${name}
                        </td>
                        <td style="padding:10px;border:1px solid #e5e7eb;color:#ef4444;">
                        ${reason}
                        </td>
                    </tr>
                    `;
                }).join("");

                const tableHtml = `
                    <div style="max-height:320px;overflow:auto;border-radius:8px;">
                    <table style="width:100%;border-collapse:collapse;font-size:13px;">
                        
                        <thead style="background:#f8fafc;">
                        <tr>
                            <th style="padding:10px;border:1px solid #e5e7eb;text-align:center;">
                            Candidate Name
                            </th>
                            <th style="padding:10px;border:1px solid #e5e7eb;text-align:center;">
                            Reason
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        ${rows}
                        </tbody>

                    </table>
                    </div>
                `;

                await Swal.fire({
                    title: "⚠️ Skipped Candidates",
                    html: tableHtml,
                    icon: "warning",
                    width: 720,
                    confirmButtonText: "OK",
                });
                } else {
                await Swal.fire({
                    title: "Success!",
                    text: "Consent request sent successfully.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            }
            setSelectedCandidateRows(prev => {
                const updated = { ...prev };
                delete updated[jobId];
                return updated;
            });
            handleConfigureCallClose();
        } catch (error) {
            const msg = error?.response?.data?.error || error?.response?.data?.message || "Failed to create call.";
            Swal.fire("Error", msg, "error");
        } finally {
            setLoadingCreateCall(false);
        }
    };

    const handleAddSecondSQ = (category) => {
        setConfigureCallData(prev => ({
            ...prev,
            secondScreeningQuestions: {
                ...prev.secondScreeningQuestions,
                [category]: [...(prev.secondScreeningQuestions[category] || []), ""],
            },
        }));
    };

    const handleEditSecondSQ = (category, index, value) => {
        setConfigureCallData(prev => ({
            ...prev,
            secondScreeningQuestions: {
                ...prev.secondScreeningQuestions,
                [category]: prev.secondScreeningQuestions[category].map((q, i) => (i === index ? value : q)),
            },
        }));
    };

    const handleRemoveSecondSQ = (category, index) => {
        setConfigureCallData(prev => ({
            ...prev,
            secondScreeningQuestions: {
                ...prev.secondScreeningQuestions,
                [category]: prev.secondScreeningQuestions[category].filter((_, i) => i !== index),
            },
        }));
    };

    const handleAddFirstSQ = () => {
        setConfigureCallData(prev => ({
            ...prev,
            firstScreeningQuestions: [...prev.firstScreeningQuestions, ""],
        }));
    };

    const handleEditFirstSQ = (index, value) => {
        setConfigureCallData(prev => ({
            ...prev,
            firstScreeningQuestions: prev.firstScreeningQuestions.map((q, i) => (i === index ? value : q)),
        }));
    };

    const handleRemoveFirstSQ = (index) => {
        setConfigureCallData(prev => ({
            ...prev,
            firstScreeningQuestions: prev.firstScreeningQuestions.filter((_, i) => i !== index),
        }));
    };
    // ===== END COMMUNICATION ACTION HELPERS =====

    // react-hook-form
    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
        trigger,
        getValues,
        setValue,
        reset,
        clearErrors,
        control,
    } = useForm({
        defaultValues: {
            secondScreeningQuestions: [
                { question: "Current Organization" },
                { question: "Current CTC For Annum" },
                { question: "Expected CTC For Annum" },
                { question: "Total Experience" },
                { question: "Relevant Experience" },
            ],
            selectedContacts: [],
            screening_percentage: "",
            workplace_types: "",
            difficultyLevel: "", 
            shift: "",       
            location: "",
            modeOfOperation: "", 
            noOfOpenings: "",
            roles_responsibility: "",
            education_level: "",
            state: "",
            preferred_skills: ""
        },
        mode:"onChange"
    });

    useEffect(() => {
        register("agent", { required: "Agent is required" });
    }, [register]);

    useEffect(() => {
        if (!hasVgus || !jobData || states.length === 0) return;

        let isActive = true;
        const hydrateSelectedLocation = async () => {
            const stateValue = jobData.state_name || jobData.state || "";
            const cityValue =
                jobData.city_name ||
                jobData.city ||
                jobData.location ||
                jobData.job_location ||
                "";
            const stateOption = findLocationOption(states, stateValue, "state");

            if (!stateOption) {
                setSelectedStateId("");
                setSelectedCityId("");
                setCities([]);
                return;
            }

            const stateId = getLocationOptionId(stateOption, "state");
            const stateName = getLocationOptionName(stateOption, "state");
            setSelectedStateId(String(stateId));
            setValue("state", stateName || stateValue, { shouldValidate: true });

            const loadedCities = await fetchCities(stateId);
            if (!isActive) return;

            const cityOption = findLocationOption(loadedCities, cityValue, "city");
            if (cityOption) {
                const cityId = getLocationOptionId(cityOption, "city");
                const cityName = getLocationOptionName(cityOption, "city");
                setSelectedCityId(String(cityId));
                setValue("location", cityName || cityValue, { shouldValidate: true });
            } else {
                setSelectedCityId("");
                setValue("location", cityValue, { shouldValidate: true });
            }
        };

        hydrateSelectedLocation();

        return () => {
            isActive = false;
        };
    }, [
        hasVgus,
        jobData,
        states,
        setValue,
    ]);

    // field arrays
    const {
        fields: firstQuestions,
        append: appendFirst,
        remove: removeFirst,
        replace: replaceFirst,
    } = useFieldArray({
        control,
        name: "firstScreeningQuestions",
    });

    const {
        fields: secondQuestions,
        append: appendSecond,
        remove: removeSecond,
    } = useFieldArray({
        control,
        name: "secondScreeningQuestions",
    });

    const categories = [
        "Personal Profiling",
        "Technical Compatibility",
        "Situational & Cultural Fit Assessment",
        "Others",
    ];

    // fields state for second screening
    const [fieldsState, setFieldsState] = useState(
        categories.reduce((acc, category) => {
            if (category === "Personal Profiling") {
                return {
                    ...acc,
                    [category]: [
                        "Current Organization",
                        "Current CTC For Annum",
                        "Expected CTC For Annum",
                        "Total Experience",
                        "Relevant Experience",
                    ],
                };
            }
            return { ...acc, [category]: [""] };
        }, {})
    );

    const [activeTab, setActiveTab] = useState(0);
    const [screeningQuestions, setScreeningQuestions] = useState({
        "Personal Profiling": [
            "Current Organization",
            "Current CTC For Annum",
            "Expected CTC For Annum",
            "Total Experience",
            "Relevant Experience",
        ],
    });
    const handleAddScreeningQuestion = (category) => {
  setScreeningQuestions((prev) => ({
    ...prev,
    [category]: [...prev[category], ""],
  }));
};

const handleEditScreeningQuestion = (category, index, value) => {
  setScreeningQuestions((prev) => ({
    ...prev,
    [category]: prev[category].map((q, i) => (i === index ? value : q)),
  }));
};
const validateSections = () => {
  const invalidSections = sectionData.filter(
    (section) => section.checked && (section.no_of_questions === 0 || !section.no_of_questions)
  );

  if (invalidSections.length > 0) {
    toastRef.current.show({
      severity: "error",
      summary: "Validation Error",
      detail: "Selected sections must have at least 1 question.",
      life: 3000,
    });
    const firstInvalidSection = invalidSections[0];
    const sectionIndex = sectionData.findIndex((s) => s.id === firstInvalidSection.id);

   if (sectionIndex !== -1) {
      setTimeout(() => {
        const input = document.getElementById(`NoOfQuestions_${sectionIndex}`);
        console.log("input",input)
        if (input) {
          input.scrollIntoView({ behavior: "smooth", block: "center" });
          input.focus();
          input.style.border = "2px solid red";
        }
      }, 300);
    }
    return false;
  }
  return true;
};



    const [skillConfig, setSkillConfig] = useState([]);
    const [skill_level_conferror, setSkillLevelConfError] = useState("");
    const [generatedQuestions, setGeneratedQuestions] = useState({});
    const [manualQuestions, setManualQuestions] = useState({});
    const [isGenerating, setIsGenerating] = useState(false);
    const [generationSuccess, setGenerationSuccess] = useState(false);

    const [isSubmittingJob, setIsSubmittingJob] = useState(false);

    const [onchangeTrue, setOnchangeTrue] = useState(false);
    const [jobFinalized, setJobFinalized] = useState(false);
    const [onlySaveDone, setOnlySaveDone] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [users, setUsers] = useState([]);
    

    // const handleCheckboxChange = (userId, field, value) => {
    // setUsers((prevUsers) =>
    //     prevUsers.map((user) => {
    //     if (user.id === userId) {
    //         if (field === "canViewQuestions" && !value) {
    //         return {
    //             ...user,
    //             canViewQuestions: value,
    //             canAddQuestions: false,
    //             canEditQuestions: false,
    //             canDeleteQuestions: false,
    //         };
    //         }
    //         return { ...user, [field]: value };
    //     }
    //     return user;
    //     })
    // );
    // };
const handleCheckboxChange = (userId, field, value) => {
  setPermissions((prev) => {
    const existing = prev[userId] || {};

    // If unchecking "canViewQuestions"
    if (field === "canViewQuestions" && !value) {
      return {
        ...prev,
        [userId]: {
          ...existing,
          canViewQuestions: false,
          canAddQuestions: false,
          canEditQuestions: false,
          canDeleteQuestions: false,
        },
      };
    }

    return {
      ...prev,
      [userId]: {
        ...existing,
        [field]: value,
      },
    };
  });
};

const permissionFields = [
  "canEditJob",
  "canViewQuestions",
  "canAddQuestions",
  "canEditQuestions",
  "canDeleteQuestions",
];

const isAllPermissionsSelected = (userId) =>
  permissionFields.every((field) => Boolean(permissions[userId]?.[field]));

const handleSelectAllPermissions = (userId, value) => {
  setPermissions((prev) => ({
    ...prev,
    [userId]: {
      ...(prev[userId] || {}),
      canEditJob: value,
      canViewQuestions: value,
      canAddQuestions: value,
      canEditQuestions: value,
      canDeleteQuestions: value,
    },
  }));
};



// useEffect(() => {
//   if (users.length > 0) {
//     setUsers((prevUsers) =>
//       prevUsers.map((user) => {
//         if (user.role_name === "SuperAdmin" || user.role_name !== "Employee") {
//           return {
//             ...user,
//             canEditJob: true,
//             canViewQuestions: true,
//             canAddQuestions: true,
//             canEditQuestions: true,
//             canDeleteQuestions: true,
//           };
//         }
//         return user;
//       })
//     );
//   }
// }, [users]);

// const columns = [
//   {
//     name: "Employee",
//     selector: (row) => row.name,
//     cell: (row) => (
//       <span title={`${row.name}`}>
//         {row.name}
//       </span>
//     ),
//     sortable: true,
//   },
//   {
//     name: "Department",
//     selector: (row) => row.department,
//     sortable: true,
//      cell: (row) => (
//       <span title={`${row.department}`}>
//         {row.department}
//       </span>
//     ),
//   },
//   {
//     name: "Designation",
//     selector: (row) => row.designation,
//     sortable: true,
//     cell: (row) => (
//       <span title={`${row.designation}`}>
//         {row.designation}
//       </span>
//     ),
//   },
//   {
//     name: "Can Edit Job",
//     cell: (row) => (
//       <input
//         type="checkbox"
//         checked={Boolean(row.canEditJob)}
//         style={{textAlign: 'center' }}
//         onChange={(e) => handleCheckboxChange(row.id, "canEditJob", e.target.checked)}
//       />
//     ),
//   },
//   {
//     name: "Can View Questions",
//     cell: (row) => (
//       <input
//         type="checkbox"
//         checked={Boolean(row.canViewQuestions)}
//         onChange={(e) => handleCheckboxChange(row.id, "canViewQuestions", e.target.checked)}
//       />
//     ),
//   },
//   {
//     name: "Can Add Questions",
//     cell: (row) => (
//       <input
//         type="checkbox"
//         checked={Boolean(row.canAddQuestions)}
//         onChange={(e) => handleCheckboxChange(row.id, "canAddQuestions", e.target.checked)}
//         disabled={!row.canViewQuestions}
//       />
//     ),
//   },
//   {
//     name: "Can Edit Questions",
//     cell: (row) => (
//       <input
//         type="checkbox"
//         checked={Boolean(row.canEditQuestions)}
//         disabled={!row.canViewQuestions}
//         onChange={(e) => handleCheckboxChange(row.id, "canEditQuestions", e.target.checked)}
//         title={!row.canViewQuestions ? "Enable 'Can View Questions' to allow this" : ""}
//       />
//     ),
//   },
//   {
//     name: "Can Delete Questions",
//     cell: (row) => (
//       <input
//         type="checkbox"
//         checked={Boolean(row.canDeleteQuestions)}
//         disabled={!row.canViewQuestions}
//         onChange={(e) => handleCheckboxChange(row.id, "canDeleteQuestions", e.target.checked)}
//       />
//     ),
//   },
// ];
// const isValidValue = (val) =>
//   val !== null &&
//   val !== undefined &&
//   val !== ""
const columns = useMemo(() => {
//   const hasValidDepartment = users?.some(
//     (u) => isValidValue(u.department_name)
//   );
//   const hasValidDesignation = users?.some(
//     (u) => isValidValue(u.designation_name)
//   );
//   console.info("hasValidDepartment",hasValidDepartment,"hasValidDesignation",hasValidDesignation)
// const hasValidDepartment = users?.some(
//     (u) => u.department_name !== null
//   );
//   const hasValidDesignation = users?.some(
//     (u) => u.designation_name !== null
//   );
  return [
    {
      name: "Employee",
      selector: (row) => row.name,
      cell: (row) => <span title={row.name}>{row.name}</span>,
      sortable: true,
    },
    {
      name: "Select All",
      center: true,
      cell: (row) => (
        <input
          type="checkbox"
          checked={isAllPermissionsSelected(row.id)}
          onChange={(e) => handleSelectAllPermissions(row.id, e.target.checked)}
          title="Select or clear all permissions for this user"
          disabled={isJobReadOnly}
        />
      ),
      width: "110px",
    },
    // ...(hasValidDepartment
    //   ? [
    //       {
    //         name: "Department",
    //         selector: (row) => row.department_name,
    //         sortable: true,
    //       },
    //     ]
    //   : []),
    // ...(hasValidDesignation
    //   ? [
    //       {
    //         name: "Designation",
    //         selector: (row) => row.designation_name,
    //         sortable: true,
    //       },
    //     ]
    //   : []),
   {
    name: "Can Edit Job",
    cell: (row) => (
      <input
        type="checkbox"
        // checked={Boolean(row.canEditJob)}
        checked={Boolean(permissions[row.id]?.canEditJob)}
        disabled={isJobReadOnly}
        style={{textAlign: 'center' }}
        onChange={(e) => handleCheckboxChange(row.id, "canEditJob", e.target.checked)}
      />
    ),
  },
  {
    name: "Can View Questions",
    cell: (row) => (
      <input
        type="checkbox"
        // checked={Boolean(row.canViewQuestions)}
        disabled={isJobReadOnly}
        checked={Boolean(permissions[row.id]?.canViewQuestions)}
        onChange={(e) => handleCheckboxChange(row.id, "canViewQuestions", e.target.checked)}
      />
    ),
  },
  {
    name: "Can Add Questions",
    cell: (row) => (
      <input
        type="checkbox"
        // checked={Boolean(row.canAddQuestions)}
        checked={Boolean(permissions[row.id]?.canAddQuestions)}   
        onChange={(e) => handleCheckboxChange(row.id, "canAddQuestions", e.target.checked)}
        disabled={!permissions[row.id]?.canViewQuestions || isJobReadOnly}
      />
    ),
  },
  {
    name: "Can Edit Questions",
    cell: (row) => (
      <input
        type="checkbox"
        // checked={Boolean(row.canEditQuestions)}
        checked={Boolean(permissions[row.id]?.canEditQuestions)}
        disabled={!permissions[row.id]?.canViewQuestions || isJobReadOnly}
        onChange={(e) => handleCheckboxChange(row.id, "canEditQuestions", e.target.checked)}
        title={!permissions[row.id]?.canViewQuestions ? "Enable 'Can View Questions' to allow this" : ""}
      />
    ),
  },
  {
    name: "Can Delete Questions",
    cell: (row) => (
      <input
        type="checkbox"
        // checked={Boolean(row.canDeleteQuestions)}
        checked={Boolean(permissions[row.id]?.canDeleteQuestions)}
        // disabled={!row.canViewQuestions}
        disabled={!permissions[row.id]?.canViewQuestions || isJobReadOnly}
        onChange={(e) => handleCheckboxChange(row.id, "canDeleteQuestions", e.target.checked)}
      />
    ),
  },
  ];
}, [users,permissions]);

    // JD upload states (consolidated)
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [isSubmittingJd, setIsSubmittingJd] = useState(false);
    const [errorJdMessage, setErrorJdMessage] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]); // show list & upload first file

    const toast = (icon, title, text) => Swal.fire({ icon, title, text, timer: 2000 });

    // const handleCompanyChange = (company) => {
    //     if (company?.company_id) {
    //         setCompanyId(company?.company_id);
    //     }
    // };
    const handleCompanyChange = (company) => {
    const selectedCompanyId = getJobCompanyId(company);
    if (selectedCompanyId) {
        setCompanyId(selectedCompanyId);
        setSelectedAgent(null);
        setAgentOptions([]);
        setValue("agent", null);
        setCompanyWebsiteFlags(company);
    }
};
useEffect(() => {
    setIsEditMode(Boolean(id));
}, [id]);
const parseLocalDateOnly = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = String(dateStr).split("-").map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day); 
};
const getLocalTodayStr = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
const parseApiDateToInputValue = (dateStr) => {
    if (!dateStr) return "";
    return String(dateStr).split("T")[0]; 
};
const [isUsersLoading, setIsUsersLoading] = useState(true);
const fetchEditJobOptions = async (companyIdParam = companyId, page = 1, search = "") => {
    if (!id || !companyIdParam) {
        setEditJobOptions(mergeEditJobOptions([], jobData));
        return;
    }

    setEditJobsLoading(true);
    try {
        const response = await axios.get(`/api/v1/create-job-order/`, {
            params: {
                company_id: companyIdParam,
                page,
                size: 10,
                ...(search ? { search } : {}),
            },
        });
        const jobs =
            response?.data?.results?.data ??
            response?.data?.results ??
            response?.data?.data ??
            response?.data ??
            [];
        const totalCount =
            response?.data?.count ??
            response?.data?.results?.count ??
            0;

        setEditJobOptions(mergeEditJobOptions(Array.isArray(jobs) ? jobs : [jobs], jobData));
        setEditJobTotalCount(totalCount);
        setEditJobPage(page);
    } catch (error) {
        console.error("Error fetching job order list:", error);
        setEditJobOptions(mergeEditJobOptions([], jobData));
    } finally {
        setEditJobsLoading(false);
    }
};
// useEffect(() => {
//   if (users.length > 0) {
//     setIsUsersLoading(false);
//   }
// }, [users]);
// const fetchUsers = async (search) => {
//   setIsUsersLoading(true);
//   setUsers([]);
//   try {
//     let url = `/api/v1/get-all-recruiters/?company_id=${companyId}`;
//     if (search && search.trim() !== "") {
//       url += `&search=${encodeURIComponent(search)}`;
//     }
//     const response = await axios.get(url);
//     const data = response.data || [];
//     console.log("API Response Data:", data);
//     const mappedUsers = data.map((user) => {
//       const isSuperAdmin = user.role_name === "SuperAdmin";
//       return {
//         id: user.id,
//         name: `${user.first_name} ${user.middle_name || ""} ${user.last_name || ""}`.trim(),
//         department: user.department_name || "N/A",
//         designation: user.designation_name || "N/A",
//         role_name: user.role_name || "N/A",
//         // Auto-check all permissions for SuperAdmin
//         canEditJob: isSuperAdmin ? true : user.canEditJob ?? false,
//         canViewQuestions: isSuperAdmin ? true : user.canViewQuestions ?? false,
//         canAddQuestions: isSuperAdmin ? true : user.canAddQuestions ?? false,
//         canEditQuestions: isSuperAdmin ? true : user.canEditQuestions ?? false,
//         canDeleteQuestions: isSuperAdmin ? true : user.canDeleteQuestions ?? false,
//       };
//     });
//     console.log("Mapped Users:", mappedUsers);
//     setUsers(mappedUsers);
//   } catch (error) {
//     console.error("Error fetching users:", error);
//   } finally {
//     setIsUsersLoading(false);
//   }
// };

// const fetchUsers = async (search) => {
//   setIsUsersLoading(true);
//   setUsers([]);
//   try {
//     let url = `/api/v1/get-all-recruiters/?company_id=${companyId}`;
//     if (search && search.trim() !== "") {
//       url += `&search=${encodeURIComponent(search)}`;
//     }
//     const response = await axios.get(url);
//     const data = response.data || [];
//     // console.log("API Response Data:", data);

//     const currentUserId = userInfos?.user_details?.user_id;

//     const mappedUsers = data.map((user) => {
//       const isSuperAdmin = user.role_name === "SuperAdmin";
//       const isCurrentUser = user.id === currentUserId;
//        const defaultPermissions = {
//             canEditJob: isSuperAdmin || (!isEditMode && isCurrentUser)
//             ? true
//             : user.canEditJob ?? false,
//             canViewQuestions: isSuperAdmin || (!isEditMode && isCurrentUser)
//             ? true
//             : user.canViewQuestions ?? false,
//             canAddQuestions: isSuperAdmin || (!isEditMode && isCurrentUser)
//             ? true
//             : user.canAddQuestions ?? false,
//             canEditQuestions: isSuperAdmin || (!isEditMode && isCurrentUser)
//             ? true
//             : user.canEditQuestions ?? false,
//             canDeleteQuestions: isSuperAdmin || (!isEditMode && isCurrentUser)
//             ? true
//             : user.canDeleteQuestions ?? false,
//         };
//         setPermissions(prev => ({
//             ...prev,
//             [user.id]: prev[user.id] ?? defaultPermissions
//         }));


//       return {
//         id: user.id,
//         name: `${user.first_name} ${user.middle_name || ""} ${user.last_name || ""}`.trim(),
//         department: user.department_name || "N/A",
//         designation: user.designation_name || "N/A",
//         role_name: user.role_name || "N/A",
//         // Auto-check all permissions for SuperAdmin
//         // For current user in create mode, enable all permissions
//         // canEditJob: isSuperAdmin || (!isEditMode && isCurrentUser) ? true : user.canEditJob ?? false,
//         // canViewQuestions: isSuperAdmin || (!isEditMode && isCurrentUser) ? true : user.canViewQuestions ?? false,
//         // canAddQuestions: isSuperAdmin || (!isEditMode && isCurrentUser) ? true : user.canAddQuestions ?? false,
//         // canEditQuestions: isSuperAdmin || (!isEditMode && isCurrentUser) ? true : user.canEditQuestions ?? false,
//         // canDeleteQuestions: isSuperAdmin || (!isEditMode && isCurrentUser) ? true : user.canDeleteQuestions ?? false,
//       };
//     });
//     // console.log("Mapped Users:", mappedUsers);
//     setUsers(mappedUsers);
//   } catch (error) {
//     console.error("Error fetching users:", error);
//   } finally {
//     setIsUsersLoading(false);
//   }
// };
const mapRecruitersToOptions = (payload = {}) => {
  const recruiters = Array.isArray(payload?.users)
    ? payload.users
    : Array.isArray(payload?.results)
    ? payload.results
    : Array.isArray(payload)
    ? payload
    : [];

  return recruiters.map((recruiter) => {
    const id = recruiter?.id ?? recruiter?.user_id ?? recruiter?.recruiter_id ?? null;
    const name =
      recruiter?.full_name ||
      [recruiter?.first_name, recruiter?.middle_name, recruiter?.last_name]
        .map((part) => String(part || "").trim())
        .filter(Boolean)
        .join(" ")
        .trim() ||
      recruiter?.name ||
      recruiter?.email ||
      "Recruiter";

    return {
      ...recruiter,
      id,
      name,
      email: recruiter?.email || "",
      phone_number: recruiter?.phone_number || "",
      role_name:
        recruiter?.role_name ||
        recruiter?.hrms_role__hrms_role_name ||
        recruiter?.user_role_name ||
        "",
    };
  });
};

const fetchUsers = async (search) => {
  setIsUsersLoading(true);
  setLoadingContacts(true);
  setUsers([]);

  try {
    const trimmedSearch = search?.trim() || "";
    const cacheKey = trimmedSearch ? `ats-users:${trimmedSearch}` : "ats-users";
    const url =
      trimmedSearch !== ""
        ? `/api/v1/ats-users/?search=${encodeURIComponent(trimmedSearch)}`
        : `/api/v1/ats-users/`;

    // const response = await axios.get(url);
    // const data = mapAtsUsersToOptions(response.data);

    const response = await getCachedRequest(
      cacheKey,
      () => axios.get(url),
      trimmedSearch === ""
    );
    const data = mapRecruitersToOptions(response.data);
    const contactOptions = mapAtsUsersToOptions(response.data);
    const currentUserId = userInfos?.user_details?.user_id;

    // 🔥 Build permission object first
    const newPermissions = {};

    const mappedUsers = data.map((user) => {
      const isSuperAdmin = user.role_name === "SuperAdmin";
      const isCurrentUser = user.id === currentUserId;

      const defaultPermissions = {
        canEditJob:
          isSuperAdmin || (!isEditMode && isCurrentUser)
            ? true
            : user.canEditJob ?? false,
        // canViewQuestions:
        //   isSuperAdmin || (!isEditMode && isCurrentUser)
        //     ? true
        //     : user.canViewQuestions ?? false,
        canViewQuestions: true,
        canAddQuestions:
          isSuperAdmin || (!isEditMode && isCurrentUser)
            ? true
            : user.canAddQuestions ?? false,
        canEditQuestions:
          isSuperAdmin || (!isEditMode && isCurrentUser)
            ? true
            : user.canEditQuestions ?? false,
        canDeleteQuestions:
          isSuperAdmin || (!isEditMode && isCurrentUser)
            ? true
            : user.canDeleteQuestions ?? false,
      };

      newPermissions[user.id] = defaultPermissions;

      return {
        id: user.id,
        name: user.name,
        email: user.email || "N/A",
        phone_number: user.phone_number || "N/A",
        role_name: user.role_name || "N/A",
      };
    });

    setPermissions((prev) => {
        const merged = { ...newPermissions };
        Object.keys(prev).forEach((userId) => {
            merged[userId] = prev[userId];
        });
        return merged;
        });
    setUsers(mappedUsers);
    setContacts(contactOptions);
  } catch (error) {
    console.error("Error fetching users:", error);
  } finally {
    setIsUsersLoading(false);
    setLoadingContacts(false);
  }
};

const fetchAgents = async () => {
  if (!companyId) {
    setAgentOptions([]);
    setSelectedAgent(null);
    setValue("agent", null);
    return;
  }

  setLoadingAgents(true);

    try {
    const response = await getCachedRequest(
      "agents-dropdown",
      () => axios.get("/api/v1/agents/", { params: { dropdown: true, company_id: companyId } })
    );

    const agents = response?.data?.data || [];
    const options = agents.map((agent) => ({
      value: agent.id,
      label: agent.bot_name,
      agent_id: agent.agent_id,
      voice_code: agent.voice_code,
    }));
    setAgentOptions(options);
    if (options.length === 1 && !selectedAgent) {
      setSelectedAgent(options[0]);
      setValue("agent", options[0]);
      clearErrors("agent");
    }
  } catch (error) {
    console.error("Error fetching agents:", error);
  } finally {
    setLoadingAgents(false);
  }
};

const [jobTextsResponse, setJobTextsResponse] = useState(null);

useEffect(() => {
  if (postToLinkedIn && jobOrderId && lastFetchedJobTextsRef.current !== String(jobOrderId)) {
    const fetchJobTexts = async () => {
      try {
        lastFetchedJobTextsRef.current = String(jobOrderId);
        const response = await axios.get(
          `/api/v1/job-texts/?job_id=${jobOrderId}`
        );
        // Store the response for preview
        setJobTextsResponse(response.data);
      } catch (error) {
        lastFetchedJobTextsRef.current = null;
        console.error("Error fetching job texts:", error);
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to fetch job details for preview.",
          life: 3000,
        });
      }
    };
    fetchJobTexts();
  }
}, [postToLinkedIn, jobOrderId]);


useEffect(() => {
  fetchUsers();
  fetchAgents();
}, [companyId]);

const [totalCandidates, setTotalCandidates] = useState(0);
useEffect(() => {
  const timer = setTimeout(() => {
    setPage(1);
    setCandidateApiSearch(jobCandidateSearch.trim());
  }, 350);

  return () => clearTimeout(timer);
}, [jobCandidateSearch]);

useEffect(() => {
  const currentJobId = String(jobData?.job_id || jobOrderId || id || "");

  if (!currentJobId || !companyId) {
    setJobCandidates([]);
    setSelectedJobCandidate(null);
    setTotalCandidates(0);

    return;
  }

  const fetchJobCandidates = async () => {
  const requestKey = JSON.stringify({
    job_id: currentJobId,
    company_id: companyId,
    page,
    size: pageSize,
    search: candidateApiSearch,
    email_sent: emailSentFilterMap[currentJobId],
    send_test: sendTestFilterMap[currentJobId],
    consent_status: consentStatusFilterMap[currentJobId],
    from_date: fromDateMap[currentJobId],
  to_date: toDateMap[currentJobId],
  ai_screening: aiScreeningFilterMap[currentJobId],
  folder_id: folderFilterMap[currentJobId],
  });

  if (
    jobCandidatesInFlightRef.current[requestKey] ||
    lastJobCandidatesRequestKeyRef.current === requestKey
  ) {
    return;
  }

  setJobCandidatesLoading(true);
  jobCandidatesInFlightRef.current[requestKey] = true;

  try {
    const response = await axios.get(
      "/api/v1/candidates/candidates-by-job/",
      {
        params: {
          company_id: companyId,
          job_id: currentJobId,
          page: page,
          size: pageSize,
          ...(candidateApiSearch ? { search: candidateApiSearch } : {}),
          ...(emailSentFilterMap[currentJobId] ? { email_sent: true } : {}),
          ...(sendTestFilterMap[currentJobId] ? { send_test: true } : {}),
          ...(consentStatusFilterMap[currentJobId]
            ? { consent_status: consentStatusFilterMap[currentJobId] }
            : {}),
             ...(fromDateMap[currentJobId]
            ? { from_date: fromDateMap[currentJobId] }
            : {}),
        ...(aiScreeningFilterMap[currentJobId] ? { ai_screening: true } : {}),
        ...(folderFilterMap[currentJobId] ? { folder_id: folderFilterMap[currentJobId] } : {}), // ✅ added
        ...(toDateMap[currentJobId]
            ? { to_date: toDateMap[currentJobId] }
            : {}),
                },
      }
    );

    const count = response?.data?.count || 0;
    const candidates = response?.data?.results?.candidates || [];
       const normalized = candidates.map((c, idx) => ({
      ...c,

      job_candidate_id:
        c.job_candidate_id ??
        c.candidate_job_id ??
        c.candidate_id ??
        c.id ??
        idx + 1,

      candidate_id: c.candidate_id ?? c.id ?? idx + 1,

      job_id:
        c.job_id ??
        c.job?.job_id ??
        c.job?.id ??
        currentJobId,

      first_name: c.first_name ?? c.name ?? "",
      last_name: c.last_name ?? "",
      email: c.email ?? c.candidate_email ?? "",

      full_name:
        `${c.first_name || ""} ${c.last_name || ""}`.trim() ||
        c.name ||
        "Unknown",
    }));
    const activeFilters =
        emailSentFilterMap[currentJobId] ||
        sendTestFilterMap[currentJobId] ||
        consentStatusFilterMap[currentJobId]||
        candidateApiSearch ||
        fromDateMap[currentJobId] ||      
        folderFilterMap[currentJobId] ||
    toDateMap[currentJobId]; 
     aiScreeningFilterMap[currentJobId]; 
    setTotalCandidates(count);
    if (normalized.length > 0) {
        setJobCandidates(normalized);
        setFilterHasNoResults(false);
    } else if (activeFilters) {
        setFilterHasNoResults(true);
        toastRef.current?.show({
            severity: "warn",
            summary: "No Results",
            detail: "No candidates match the selected filters.",
            life: 3000,
        });
    } else {
        setJobCandidates([]);
        setFilterHasNoResults(false);
    }
        setCandidateDataMap((prev) => ({
      ...prev,
      [currentJobId]: normalized,
    }));
    lastJobCandidatesRequestKeyRef.current = requestKey;
    setSelectedJobCandidate((prev) => {
      if (!normalized.length) return null;
      const previousId =
        prev?.job_candidate_id || prev?.candidate_id;
      return (
        normalized.find(
          (c) => c.job_candidate_id === previousId
        ) || normalized[0]
      );
    });

    setJobCandidateViewTab((prev) => prev || "resume");
  } catch (error) {
    console.error("Error fetching job candidates:", error);

    setJobCandidates([]);
    setSelectedJobCandidate(null);
    setTotalCandidates(0);
    setCandidateDataMap((prev) => ({
      ...prev,
      [currentJobId]: [],
    }));
    lastJobCandidatesRequestKeyRef.current = "";
  } finally {
    setJobCandidatesLoading(false);
    delete jobCandidatesInFlightRef.current[requestKey];
  }
};
  fetchJobCandidates();
}, [
  jobData?.job_id,
  jobOrderId,
  id,
  companyId,
  page,
  pageSize,
  candidateApiSearch,
  emailSentFilterMap,
  sendTestFilterMap,
  consentStatusFilterMap,
  fromDateMap,
  toDateMap,
  aiScreeningFilterMap,
  folderFilterMap,  
])
useEffect(() => {
  if (!jobData || agentOptions.length === 0) return;
  if (selectedAgent) return;
  const jobAgentId = jobData.agent_id || jobData.agent;
  const selected = agentOptions.find((opt) =>
    opt.agent_id === jobAgentId ||
    opt.value === jobAgentId ||
    opt.id === jobAgentId ||
    opt.label?.toLowerCase() === String(jobData.agent || "").toLowerCase()
  );
  if (selected) {
    setSelectedAgent(selected);
    setValue("agent", selected);
  }
}, [jobData, agentOptions, setValue]);

//    const getsingleJobOrderid = async (jobId) => {
//     setLoading(true);
//     try {
//         const response = await axios.get(`/api/v1/create-job-order/get-job/?job_id=${jobId}&company_id=${companyId}`);
//         const data = response.data; 

//        if (data.permissions && Array.isArray(data.permissions)) {
//     setPendingPermissions(data.permissions);   // <-- store for later
// }
 const getsingleJobOrderid = async (jobId, companyIdOverride) => {
     const requestedCompanyId = companyIdOverride ?? (id ? null : companyId);
        const requestKey = `${jobId}:${requestedCompanyId || "api-company"}`;
        if (jobOrderFetchInFlightRef.current[requestKey]) {
            return;
        }
        jobOrderFetchInFlightRef.current[requestKey] = true;
    setLoading(true);
    try {
        const requestedCompanyId = companyIdOverride ?? (id ? null : companyId);
        const companyQuery = requestedCompanyId ? `&company_id=${requestedCompanyId}` : "";
        let response;
        try {
            response = await getCachedRequest(
                `job-order:${jobId}:${requestedCompanyId || "api-company"}`,
                () => axios.get(`/api/v1/create-job-order/get-job/?job_id=${jobId}${companyQuery}`)
            );
        } catch (error) {
            if (requestedCompanyId || !companyId) throw error;

            response = await getCachedRequest(
                `job-order:${jobId}:${companyId}`,
                () => axios.get(`/api/v1/create-job-order/get-job/?job_id=${jobId}&company_id=${companyId}`)
            );
        }

        if (response.data) {
            const data = response.data;
            const apiCompanyId = getJobCompanyId(data);
            console.log(" state: data.state",data)
            // if (data.permissions && Array.isArray(data.permissions)) {
            //     setPendingPermissions(data.permissions);} 
            if (data.permissions && Array.isArray(data.permissions)) {

                const formattedPermissions = {};

                data.permissions.forEach((perm) => {
                    formattedPermissions[perm.user_id] = {
                        canEditJob: perm.can_edit_job ?? false,
                        canViewQuestions: perm.can_view_questions ?? false,
                        canAddQuestions: perm.can_add_questions ?? false,
                        canEditQuestions: perm.can_edit_questions ?? false,
                        canDeleteQuestions: perm.can_delete_questions ?? false,
                    };
                });

                setPermissions(formattedPermissions);
            }


            setJobData(data);
            setSelectedEditJobId(String(jobId));
            setEditJobOptions((prev) => mergeEditJobOptions(prev.map((option) => option.job || option), data));
            setIsEditMode(true);
            if (apiCompanyId) {
                setCompanyId(apiCompanyId);
            }
            const fetchedCompanyId = apiCompanyId || companyId;
            if (fetchedCompanyId) {
                try {
                    const [deptRes, desigRes] = await Promise.all([
                        getCachedRequest(
                            `departments:${fetchedCompanyId}`,
                                () => axios.get(`/api/v1/get-all-departments/?company_id=${fetchedCompanyId}`),
                            true
                        ),
                        getCachedRequest(
                            `designations:${fetchedCompanyId}`,
                            () => axios.get(`/api/v1/designationsv1/?company_id=${fetchedCompanyId}&no_pagination=true`),
                            true
                        )
                    ]);

                    const deptList = normalizeDepartmentList(deptRes.data);
                    const desigList = normalizeDesignationList(desigRes.data);

                    setDepartments(deptList);
                    setDesignation(desigList);
                    const deptId = String(data.department_id ?? data.department ?? "");
                    const desigId = String(data.designation_id ?? data.position ?? "");

                    const matchedDept = deptList.find(d => String(d.department_id) === deptId);
                    const matchedDesig = desigList.find(d => String(d.designation_id) === desigId);
                    if (matchedDept) {
                        setValue("job_order_department", deptId);
                    }
                    if (matchedDesig) {
                        setValue("job_order_designation", desigId);
                    }
                } catch (err) {
                    console.error("Error fetching dept/desig for edit mode:", err);
                }
            }
            setCompanyWebsiteFlags(data);
              setValue("modeOfOperation", data.workplace_types);

            // If you need to display the name somewhere, fetch workplace types first
            if (modeOfOperationTypes.length === 0) {
                await fetchModeOfOperationTypes();
            }

            // Optional: Log the name for debugging
            const workplaceType = modeOfOperationTypes.find(
                (type) => type.id === data.workplace_types
            )?.name;
        
        console.log("workplaceType",workplaceType)

            // ✅ Populate basic fields
            // setValue("job_title", data.job_title);
            // setValue("job_order_id", data.job_order_id);
            // setValue("department", data.department);
            // setSelectedDepartment(data.department);
            // setValue("designation", data.position);
            // setSelectedDesignation(data.position);
            // setDifficultyLevel(data.criticality_level);
            // setValue("testname", data.test_name);
            // setValue("minExperience", Number(data.min_exp));
            // setValue("maxExperience", Number(data.max_exp));
            // setValue("closeDate", data.close_date ? moment(data.close_date).format("YYYY-MM-DD") : "");
            // setValue("primarySkills", data.skills ? data.skills.join(",") : "");
            // setValue("domain", data.domain);
            // setValue("difficultyLevel", data.criticality_level);
            // setValue("category", data.category);
            // setSelectedCategory(data.category);
            // setSelectedCategoryName(data.category_name || "");

            // setOnchangeTrue(true);
            // set_time_settings(data.time_settings || []);
             reset({
                job_title: data.job_title,
                job_order_id: data.job_order_id,
                job_order_department: String(data.department_id ?? data.department),
                job_order_designation: String(data.designation_id ?? data.position),
                screening_percentage: data.screening_percentage || "",
                minExperience: Number(data.min_exp),
                maxExperience: Number(data.max_exp),
                closeDate: parseApiDateToInputValue(data.close_date),
                primarySkills: data.skills ? data.skills.join(",") : "",
                domain: data.domain,
                difficultyLevel: data.criticality_level,
                category: data.category,
                budget: data.salary_max ,
                 shift: data.shift || "",          
                 location: data.city_name || data.location ||data.job_location  || "",  
                 jdDescription: data.job_description || "",
                noOfOpenings: data.openings  || "",
                roles_responsibility: data.roles_responsibility || "",
                education_level: data.education_level || "",
                state: data.state_name || data.state || "",
                modeOfOperation: data.workplace_types ? String(data.workplace_types) : "",
                // Add other fields here as needed
            });

            // Manually set other states if needed
            // setSelectedDepartment(data.department_id ?? data.department);
            // setSelectedDesignation(data.designation_id ?? data.position);
            setSelectedDepartment(String(data.department_id ?? data.department ?? ""));
            setAutomateTalentScan(data.automate_talent_scan || false);
            setSelectedDesignation(String(data.designation_id ?? data.position ?? ""));
            setDifficultyLevel(data.criticality_level);
            setSelectedCategory(data.category);
            setSelectedCategoryName(data.category_name || "");
            // setModeOfOperationTypes(workplaceType);
             if (data.post_to_website) {
                setPostToWebsite(data.post_to_website);
                setIsPostedToWebsite(data.post_to_website);
                setSelectedWebsiteDomain(getPostedWebsiteDomain(data));
            }

            // ✅ First Screening Questions
            if (data.first_screening_questions && typeof data.first_screening_questions === "object") {
                const firstQs = Object.values(data.first_screening_questions).map((q) => ({ question: q }));
                replaceFirst(firstQs.length ? firstQs : [{ question: "" }]);
                reset((prev) => ({
                    ...prev,
                    firstScreeningQuestions: firstQs.length ? firstQs : [{ question: "" }],
                }));
            }
            if (data.post_to_linkedin !== undefined) {
                 if (isEditMode) {
    setPostToLinkedIn(!!data.post_to_linkedin);
  }
                // setPostToLinkedIn(!!data.post_to_linkedin);
                console.log("post_to_linkedin set to:", !!data.post_to_linkedin);
            }
            //  if (data.organisation_id && data.organisation_name) {
            //     setSelectedLinkedInOrg({
            //         id: data.organisation_id,
            //         organisation_name: data.organisation_name,
            //     });
            // }

            // ✅ ✅ MultiSelect (Employees) Mapping
            if (data.recruiters && Array.isArray(data.recruiters)) {
                setSelectedContacts(data.recruiters); // set to MultiSelect state
                setValue("selectedContacts", data.recruiters); // set to form
            } else {
                setSelectedContacts([]);
                setValue("selectedContacts", []);
            }
            if (data.agent_id || data.agent) {
                const selected = agentOptions.find(
                    (opt) =>
                        opt.agent_id === data.agent_id ||
                        opt.value === data.agent_id ||
                        opt.label?.toLowerCase() === String(data.agent || "").toLowerCase()
                );
                if (selected) {
                    setSelectedAgent(selected);
                    setValue("agent", selected);
                }
            }
            if (data.time_settings && data.time_settings.length > 0) {
                set_time_settings(data.time_settings);
                setQuestionsGenerated(true);
            }


            // ✅ Second Screening Questions
            const secondQs = data.second_screening_questions || {};
            setFieldsState(
                categories.reduce((acc, category) => {
                    acc[category] = secondQs[category] || [""];
                    return acc;
                }, {})
            );

            // ✅ Skill config
            if (data.skill_level_conf && Array.isArray(data.skill_level_conf)) {
                const config = data.skill_level_conf.map((skill) => ({
                    name: skill.skill_name || "",
                    rating: skill.rating || 1,
                    profficiency: skill.profficiency || "beginner",
                    questions:
                        (skill.ratio?.beginner || 0) +
                        (skill.ratio?.intermediate || 0) +
                        (skill.ratio?.advanced || 0),
                    ratio: {
                        beginner: skill.ratio?.beginner || 0,
                        intermediate: skill.ratio?.intermediate || 0,
                        advanced: skill.ratio?.advanced || 0,
                    },
                }));
                setSkillConfig(config);
            }

            // ✅ Extract Tech Skills questions
        //     let skillWiseQuestions = {};
        //     let skillWiseQuestions2 = {};
        //     let manualQuestions = {};
        //     const techSkillSection = data.time_settings?.find(
        //         (section) => section.section_name?.toLowerCase() === "techskills"
        //     );
        //     console.log("techSkillSection:", techSkillSection);

        //     let nonselected = [];
        //     const NontechSkillSection = data.time_settings?.map((section) => {
        //         if (section.section_name?.toLowerCase() !== "techskills") {
        //             nonselected.push(section);
        //             return section;
        //         }
        //     });
        //     if (data.category_name) {
                
        //         setSelectedCategoryName(data.category_name);
        //         if (data.category_name.toLowerCase().includes("technical")) {
        //             setHeadingText("Technical");
        //         } else {
        //             setHeadingText("Non-Technical");
        //         }
        //     }


        //     // if (techSkillSection && techSkillSection.skill_wise_questions) {
        //     //     Object.entries(techSkillSection.skill_wise_questions).forEach(([skill, details]) => {
        //     //         skillWiseQuestions[skill.toLowerCase()] = {
        //     //             beginner: Array(details.beginner || 0).fill({ text: "" }),
        //     //             intermediate: Array(details.intermediate || 0).fill({ text: "" }),
        //     //             advanced: Array(details.advanced || 0).fill({ text: "" }),
        //     //             duration: details.duration || "",
        //     //             cutoff_score: details.cutoff_score || 0,
        //     //             no_of_questions: details.no_of_questions || 0,
        //     //         };
        //     //     });
        //     //    if (Array.isArray(NontechSkillSection) && NontechSkillSection.length > 0) {
        //     //         NontechSkillSection.filter(section => section !== null)  
        //     //             .forEach((section) => {
        //     //                 if (section && section.section_name) {  
        //     //                     console.log("section", section.section_name,NontechSkillSection); 
        //     //                     manualQuestions[section.section_name] = section.manual_questions || {
        //     //                         questions: {
        //     //                             beginner: [],
        //     //                             intermediate: [],
        //     //                             advanced: [],
        //     //                         },
        //     //                     };
        //     //                 } else {
        //     //                     console.error("Invalid section or missing section_name:", section);
        //     //                 }
        //     //             });
        //     //     } else {
        //     //         console.error("NontechSkillSection is either undefined or empty");
        //     //     }


        //     //     const configArray = Object.entries(techSkillSection.skill_wise_questions).map(
        //     //         ([skill, details]) => ({
        //     //             name: skill,
        //     //             beginner: details.beginner || 0,
        //     //             intermediate: details.intermediate || 0,
        //     //             advanced: details.advanced || 0,
        //     //             duration: details.duration || "",
        //     //             cutoff_score: details.cutoff_score || 0,
        //     //             no_of_questions: details.no_of_questions || 0,
        //     //         })
        //     //     );
        //     //     setSkillConfig(configArray);
        //     // }
        //         if (techSkillSection && techSkillSection.skill_wise_questions) {
        //             Object.entries(techSkillSection.skill_wise_questions).forEach(([skill, details]) => {
        //                 skillWiseQuestions[skill.toLowerCase()] = {
        //                     beginner: details.questions.beginner || [],
        //                     intermediate: details.questions.intermediate || [],
        //                     advanced: details.questions.advanced || [],
        //                     duration: details.duration || "",
        //                     cutoff_score: details.cutoff_score || 0,
        //                     no_of_questions: details.no_of_questions || 0,
        //                 };
        //             });
        //         }

        //     if (nonselected.length !== 0) {
        //         nonselected.map((skill) => {
        //             skillWiseQuestions2[skill.section_name] = skill.manual_questions;
        //             return skill;
        //         });
        //     }

        //     setOnchangeTrue(false);
        //     setOnlySaveDone(true);
        //     setGeneratedQuestions(skillWiseQuestions);
        //     setManualQuestions(skillWiseQuestions2);
        // }
         let skillWiseQuestions = {};
      let manualQuestions = {};

      // Parse time_settings for manual questions and TechSkills questions
      data?.time_settings?.forEach((section) => {
        if (section.section_name?.toLowerCase() === "techskills") {
          // TechSkills section: parse skill_wise_questions
          if (section.skill_wise_questions) {
            Object.entries(section.skill_wise_questions).forEach(([skill, details]) => {
              skillWiseQuestions[skill.toLowerCase()] = {
                beginner: details.questions?.beginner?.map(q => ({ text: q })) || [],
                intermediate: details.questions?.intermediate?.map(q => ({ text: q })) || [],
                advanced: details.questions?.advanced?.map(q => ({ text: q })) || [],
                duration: details.duration || "",
                cutoff_score: details.cutoff_score || 0,
                no_of_questions: details.no_of_questions || 0,
              };
            });
          }
        } else {
          // Non-TechSkills sections: parse manual_questions
          if (section.manual_questions) {
            // manualQuestions[section.section_name] = {
            //   questions: {
            //     beginner: section.manual_questions.questions.beginner || [],
            //     intermediate: section.manual_questions.questions.intermediate || [],
            //     advanced: section.manual_questions.questions.advanced || [],
            //   },
            // };
              const nested = section.manual_questions[section.section_name];
                const questionsObj = nested
                    ? nested.questions
                    : section.manual_questions.questions;
                   manualQuestions[section.section_name] = {
                    questions: {
                        beginner: questionsObj?.beginner || [],
                        intermediate: questionsObj?.intermediate || [],
                        advanced: questionsObj?.advanced || [],
                    },
                    };
          }
        }
      });

      console.log("Generated Questions:", skillWiseQuestions);
      setPostToWebsite(data.post_to_website || false);
      if (data.post_to_website) {
        setSelectedWebsiteDomain(getPostedWebsiteDomain(data));
      }
      setGeneratedQuestions(skillWiseQuestions);
      setManualQuestions(manualQuestions);

      setOnchangeTrue(false);
      setOnlySaveDone(true);
      setQuestionsGenerated(Object.keys(skillWiseQuestions).length > 0);
      setScreeningQuestions(data.second_screening_questions || {}); 
       const currentUserId = userInfos?.user_details?.user_id;
            const currentUserPerm = data.permissions?.find(p => p.user_id === currentUserId);

            // If no permissions found for current user, set default permissions
            // if (!currentUserPerm) {
            //     setUsers(prevUsers =>
            //         prevUsers.map(user => {
            //             if (user.id === currentUserId) {
            //                 return {
            //                     ...user,
            //                     canEditJob: true,
            //                     canViewQuestions: true,
            //                     canAddQuestions: true,
            //                     canEditQuestions: true,
            //                     canDeleteQuestions: true,
            //                 };
            //             }
            //             return user;
            //         })
            //     );
            // }
        
        }
    } catch (error) {
        console.info(error);
        console.error("Error fetching job order:", error);
         Swal.fire({
            title: "Error!",
            text: "Failed to fetch job order details.",
            icon: "error",
            confirmButtonText: "OK",
        });
    }finally {
        setLoading(false);  
    }
};
const handleRemoveScreeningQuestion = (category, index) => {
  setScreeningQuestions((prev) => {
    const updated = { ...prev };
    if (updated[category] && Array.isArray(updated[category])) {
      updated[category] = updated[category].filter((_, i) => i !== index);
    }
    return updated;
  });
};

useEffect(() => {
  if (users.length > 0 && pendingPermissions) {
    setUsers(prevUsers =>
      prevUsers.map(user => {
        const perm = pendingPermissions.find(p => p.user_id === user.id);
        if (!perm) return user;

        return {
          ...user,
          canEditJob: perm.can_edit_job || false,
          canViewQuestions: perm.can_view_questions || false,
          canAddQuestions: perm.can_add_questions || false,
          canEditQuestions: perm.can_edit_questions || false,
          canDeleteQuestions: perm.can_delete_questions || false,
        };
      })
    );

    setPendingPermissions(null); 
  }
}, [users, pendingPermissions]);

    // fetch departments & designations & testtypes
    const fetchDepartments = async () => {
        if (!companyId) {
            setDepartments([]);
            return;
        }
        try {
            const initialResponse = await getCachedRequest(
                `departments:${companyId}`,
                () => axios.get(`/api/v1/get-all-departments/?company_id=${companyId}`),
                true
            );

            setDepartments(normalizeDepartmentList(initialResponse.data));
        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    const fetchDesignation = async () => {
        if (!companyId) {
            setDesignation([]);
            return;
        }
        try {
              const initialResponse = await getCachedRequest(
                `designations:${companyId}`,
                () => axios.get(`/api/v1/designationsv1/?company_id=${companyId}&no_pagination=true`),
                true
            );

            setDesignation(normalizeDesignationList(initialResponse.data));
        } catch (error) {
            console.error("Error fetching designations:", error);
            setDesignation([]);
        }
    };

    const gettesttypes = () => {
        getCachedRequest(
            "test-types",
            () => axios.get(`/api/v1/test-types/`),
            true
        )
            .then((res) => {
                if (res.data) setTesttypes(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // get sections for a category
    const getSectionsFromCategory = (Category = selectedCategory) => {
    //     if (!Category) {
    //     setSectionData([]);
    //     return;
    // }
        const config = {
            headers: { "content-type": "multipart/form-data" },
        };

        getCachedRequest(
            `sections:${Category}`,
            () => axios.get(`/api/v1/sections/?category_id=${Category}`, config),
            true
        )
            .then((res) => {
                let sectiondatalist = (res.data || []).filter((section) => section.name !== "TechSkills");
                // if (time_settings && time_settings.length) {
                //     time_settings.forEach((item) => {
                //         sectiondatalist.forEach((sce) => {
                //             if (item.section_name === sce.name) {
                //                 sce.checked = true;
                //                 sce.duration = item.duration;
                //                 sce.no_of_questions = item.no_of_questions;
                //                 sce.total_score = item.total_score;
                //                 sce.cutoff_score = parseInt(item.total_score) / 2;
                //             }
                //         });
                //     });
                // } else {
                //     sectiondatalist = sectiondatalist.map((section) => ({
                //         ...section,
                //         errorDuration: false,
                //         errorTotalQuestions: false,
                //         errorTotalScore: false,
                //         checked: false,
                //     }));
                // }
                if (time_settings && time_settings.length) {
                    sectiondatalist = sectiondatalist.map((section) => {
                        const found = time_settings.find((item) => item.section_name === section.name);
                        return {
                            ...section,
                            checked: !!found,
                            duration: found ? found.duration : section.duration,
                            no_of_questions: found ? found.no_of_questions : section.no_of_questions,
                            total_score: found ? found.total_score : section.total_score,
                            cutoff_score: found ? parseInt(found.total_score) / 2 : section.cutoff_score,
                            errorDuration: false,
                            errorTotalQuestions: false,
                            errorTotalScore: false,
                        };
                    });
                } else {
                    sectiondatalist = sectiondatalist.map((section) => ({
                        ...section,
                        duration: getDurationForQuestionCount(section.no_of_questions, section.name),
                        checked: false,
                        errorDuration: false,
                        errorTotalQuestions: false,
                        errorTotalScore: false,
                        
                    }));
                }

                sectiondatalist = sectiondatalist.map((items) => {
                    items.cutoff_score = items.total_score / 2;
                    return items;
                });
                setSectionData([...sectiondatalist]);
            })
            .catch((err) => { });
    };

    // effects
    useEffect(() => {
        if (id) {
            setSelectedEditJobId(String(id));
            getsingleJobOrderid(id);
        }
        // eslint-disable-next-line
    }, []);

   useEffect(() => {
    if (!id || !companyId) return;
    const key = `${id}:${companyId}`;
    if (editJobOptionsFetchedForRef.current === key) return;
    editJobOptionsFetchedForRef.current = key;

    setEditJobSearchText("");
    fetchEditJobOptions(companyId, 1, "");
}, [id, companyId]);

    const handleEditJobChange = async (option) => {
        const nextJobId = option?.value;
        if (!nextJobId || nextJobId === selectedEditJobId) return;

        setJobOrderMenuOpen(false);
        setSelectedEditJobId(nextJobId);
        navigate(`/create-job-orders-view/${nextJobId}`, {
            replace: true,
            state: { selectedCompanyId: companyId },
        });
        await getsingleJobOrderid(nextJobId, companyId);
        setMainTab(0);
    };

    useEffect(() => {
        if (selectedCategory) {
            getSectionsFromCategory();
        }
        // eslint-disable-next-line
    }, [selectedCategory]);

    useEffect(() => {
        gettesttypes();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetchDesignation();
        fetchDepartments();
        // eslint-disable-next-line
    }, [companyId]);

    // category change handler
    const handleCategoryChange = (value) => {
        setOnchangeTrue(true);
        setOnlySaveDone(false);
        clearErrors("category");
        setSelectedCategory(value);

        const selected = testtypes.find((t) => t.id === parseInt(value));
        console.log(selected)
        setSelectedCategoryName(selected ? selected.name : "");
        // if (value === 1) {

        //     setHeadingText("Technical");
        // } else {
        //     setHeadingText("Non-Technical");
        // }
        setHeadingText(
        selected && selected.name.includes("Non-") 
            ? "Non-Technical" 
            :"Technical"
        );

    };

    // sections toggles & value changes
    const changeselectedcheck = (checked, index) => {
        setOnlySaveDone(false);
        setOnchangeTrue(true);
        const updatedSections = [...sectionData];
        updatedSections[index].checked = checked;
        setSectionData(updatedSections);
        if (!checked) {
        setTimeout(() => {
            const input = document.getElementById(`NoOfQuestions_${index}`);
            if (input) {
                input.style.border = "";
            }
        }, 100);
    }
    };
const minutesToDuration = (totalMinutes) => {
    const safeMinutes = Math.max(0, totalMinutes || 0);
    return new Date(safeMinutes * 60 * 1000).toISOString().substr(11, 8);
};

const getMinutesPerQuestion = (sectionName) =>
    String(sectionName || "").trim().toLowerCase() === "coding" ? 5 : 2;

const getDurationForQuestionCount = (questionCount, sectionName) => {
    const questions = Math.max(parseInt(questionCount, 10) || 0, 0);
    return minutesToDuration(questions * getMinutesPerQuestion(sectionName));
};

    const changeselectionValue = (value, idVal, index, field) => {
        setOnchangeTrue(true);
        setOnlySaveDone(false);
        const updatedSections = [...sectionData];
        const section = updatedSections[index];
        if (!section) return;
        if (field === "questions") {
            section.no_of_questions = parseInt(value, 10) || 0;
            section.total_score = section.no_of_questions * 1;
            section.cutoff_score = section.total_score / 2;
            section.duration = getDurationForQuestionCount(section.no_of_questions, section.name);
        if (section.no_of_questions > 0) {
            setTimeout(() => {
            const sectionElement = document.getElementById(`NoOfQuestions_${index}`);
            if (sectionElement) {
                sectionElement.style.border = "";
            }
            }, 100);
        }
        } else if (field === "duration") {
            if (value === "00:00:00") {
                 Swal.fire({
                    icon: "error",
                    title: "Invalid Duration",
                    text: "Duration must be greater than 0 minutes.",
                });
                return;
                // return false;
            } else {
                section.duration = value;
            }
        } else if (field === "cutoff_score") {
            let total = parseInt(section.total_score);
            if (value <= total) {
                section.cutoff_score = value;
            } else {
                Swal.fire({
                icon: "error",
                title: "Invalid Cutoff Score",
                text: "Cutoff score must be less than or equal to total score.",
            });
            return;
            }
            
        }
        setSectionData(updatedSections);
    };

    // create / update order
    const difficultyMapping = {
        beginner: "easy",
        intermediate: "medium",
        advanced: "hard",
    };

    const createNewOrder = async (data) => {
    if (!data) return;

    const criticalityLevel = difficultyMapping[data.difficultyLevel] || data.difficultyLevel;
    setIsSaving(true);

    // ✅ Build TechSkills
    let techSkillsSection = null;
    let skill_level_conf = [];
    let skillsPayload = [];
    //    const permissionsPayload = users
    // .map(user => ({
    //   user_id: user.id,
    //   can_edit_job: user.canEditJob || false,
    //   can_view_questions: user.canViewQuestions || false,
    //   can_add_questions: user.canAddQuestions || false,
    //   can_edit_questions: user.canEditQuestions || false,
    //   can_delete_questions: user.canDeleteQuestions || false,
    // }));
      const permissionsPayload = Object.keys(permissions).map(userId => ({
  user_id: Number(userId),
  can_edit_job: permissions[userId]?.canEditJob ?? false,
  can_view_questions: permissions[userId]?.canViewQuestions ?? false,
  can_add_questions: permissions[userId]?.canAddQuestions ?? false,
  can_edit_questions: permissions[userId]?.canEditQuestions ?? false,
  can_delete_questions: permissions[userId]?.canDeleteQuestions ?? false,
}));

    if (skillConfig && skillConfig.length > 0) {
        const totalQuestions = skillConfig.reduce((sum, skill) => sum + (parseInt(skill.questions) || 0), 0);
        const totalDurationMinutes = totalQuestions * 2;
        const totalDuration = new Date(totalDurationMinutes * 60 * 1000)
            .toISOString()
            .substr(11, 8);

        techSkillsSection = {
            section: 5,
            section_name: "TechSkills",
            no_of_questions: totalQuestions.toString(),
            duration: totalDuration,
            total_score: totalQuestions.toString(),
            cutoff_score: totalQuestions / 2,
            question_type: "DESC",
            criticality: criticalityLevel,
            category: selectedCategory,
            skill_wise_questions: {},
        };

        skillConfig.forEach((skill) => {
            const skillKey = (skill.name || "").toLowerCase();
            const skillQuestions = generatedQuestions[skillKey] || { beginner: [], intermediate: [], advanced: [] };

            const totalQ =
                (skillQuestions.beginner?.length || 0) +
                (skillQuestions.intermediate?.length || 0) +
                (skillQuestions.advanced?.length || 0) ||
                skill.questions ||
                5;

            const skillDuration = new Date(totalQ * 2 * 60 * 1000).toISOString().substr(11, 8);
            const cutoff = totalQ / 2;

            const { beginner, intermediate, advanced } = getQuestionRatio(skill.rating, totalQ);

            techSkillsSection.skill_wise_questions[skillKey] = {
                level: skill.rating,
                no_of_questions: totalQ,
                beginner,
                intermediate,
                advanced,
                cutoff_score: cutoff,
                duration: skillDuration,
                questions: {
                    beginner: skillQuestions.beginner.map((q) => q.text || ""),
                    intermediate: skillQuestions.intermediate.map((q) => q.text || ""),
                    advanced: skillQuestions.advanced.map((q) => q.text || ""),
                },
            };

            skill_level_conf.push({
                skill_name: skillKey,
                rating: skill.rating,
                profficiency:
                    skill.rating <= 3
                        ? "beginner"
                        : skill.rating <= 7
                        ? "intermediate"
                        : "advanced",
                ratio: { beginner, intermediate, advanced },
            });

            if (skillKey) skillsPayload.push(skillKey);
        });
    }

    // ✅ Default manual questions structure
    const defaultManual = {
        questions: {
            beginner: [],
            intermediate: [],
            advanced: []
        }
    };

    // // ✅ Build time_settings and ALWAYS send manual_questions (even if empty)
    // const timeSettingsPayload = sectionData
    //     .filter((section) => section.checked)
    //     .map((section) => {
    //         if (section.name === "TechSkills") {
    //             // ✅ Add default manual structure to TechSkills
    //             techSkillsSection.manual_questions = defaultManual;
    //             return techSkillsSection;
    //         }

    //         const baseSection = {
    //             section: section.id,
    //             section_name: section.name,
    //             no_of_questions: section.no_of_questions?.toString() || "0",
    //             duration: section.duration || "00:06:00",
    //             total_score: section.total_score?.toString() || "0",
    //             cutoff_score: section.total_score / 2 || 0,
    //             question_type: "DESC",
    //             criticality: criticalityLevel,
    //             category: selectedCategory,
    //             manual_questions: manualQuestions[section.name] || defaultManual // ✅ always present
    //         };

    //         return baseSection;
    //     });

    // // ✅ Prevent duplicate TechSkills
    // if (techSkillsSection && !timeSettingsPayload.some((s) => s.section === 5)) {
    //     timeSettingsPayload.push(techSkillsSection);
    // }
// ✅ Build time_settings and ALWAYS send manual_questions (even if empty)
const timeSettingsPayload = sectionData
    .filter((section) => section.checked)
    .map((section) => {
        if (section.name === "TechSkills") {
            // ✅ Add default manual structure to TechSkills
            techSkillsSection.manual_questions = defaultManual;
            return techSkillsSection;
        }
        const sectionManual = manualQuestions[section.name] || defaultManual;
        const baseSection = {
            section: section.id,
            section_name: section.name,
            no_of_questions: section.no_of_questions?.toString() || "0",
            duration: section.duration || getDurationForQuestionCount(section.no_of_questions, section.name),
            total_score: section.total_score?.toString() || "0",
            cutoff_score: section.total_score / 2 || 0,
            question_type: "DESC",
            criticality: criticalityLevel,
            category: selectedCategory,
            // manual_questions: manualQuestions[section.name] || defaultManual, // ✅ always present
             manual_questions: {
                [section.name]: {
                    no_of_questions: section.no_of_questions?.toString() || "0",
                    questions: sectionManual.questions,
                },
            },
        };

        return baseSection;
    });

// ✅ Prevent duplicate TechSkills
if (techSkillsSection && !timeSettingsPayload.some((s) => s.section_name === "TechSkills")) {
    timeSettingsPayload.push(techSkillsSection);
}

    // ✅ Final payload
    const selectedStateOption = findLocationOption(states, selectedStateId, "state");
    const selectedCityOption = findLocationOption(cities, selectedCityId, "city");
    const selectedStateName =
        getLocationOptionName(selectedStateOption, "state") ||
        data.state ||
        jobData?.state_name ||
        jobData?.state ||
        "";
    const selectedCityName =
        getLocationOptionName(selectedCityOption, "city") ||
        data.location ||
        data.job_location ||
        jobData?.city_name ||
        jobData?.location ||
        jobData?.job_location ||
        "";

    const payload = {
        job_title: data.job_title,
        jd_meta_data: parsedJdMeta ?? undefined,
        job_order_id: data.job_order_id || null,
        department: parseInt(data.job_order_department),
        automate_talent_scan: automateTalentScan,
        screening_percentage: data.screening_percentage ? Number(data.screening_percentage) : null,
        position: parseInt(data.job_order_designation),
        min_exp: parseInt(data.minExperience),
        max_exp: parseInt(data.maxExperience),
        close_date: data.closeDate,
        salary_max: data.budget || null,
        skills: skillsPayload,
        preferred_skills: data.preferred_skills
            ? data.preferred_skills.split(",").map(s => s.trim())
            : [],
        domain: data.domain,
        criticality_level: data.difficultyLevel,
        category: parseInt(selectedCategory),
        category_name: selectedCategoryname,
        // agent: selectedAgent?.label || (typeof getValues("agent") === "object" ? getValues("agent")?.label : getValues("agent")) || null,
        agent: selectedAgent?.value || selectedAgent?.agent_id || (typeof getValues("agent") === "object" ? getValues("agent")?.value || getValues("agent")?.agent_id : null) || null,
        recruiters: selectedContacts,
        skill_level_conf,
        time_settings: timeSettingsPayload,
        category_name: selectedCategoryname,
        permissions:permissionsPayload,
        // post_to_linkedin: postToLinkedIn,
        organisation_id: postToLinkedIn && selectedLinkedInOrg ? selectedLinkedInOrg.id : null,
        first_screening_questions: formatScreeningQuestions(getValues("firstScreeningQuestions") || []),
        // second_screening_questions: Object.entries(fieldsState).reduce((acc, [category, questions]) => {
        //     const filtered = questions.filter((q) => q.trim() !== "");
        //     if (filtered.length > 0) acc[category] = filtered;
        //     return acc;
        // }, {}),
        second_screening_questions: screeningQuestions,
        company_id: companyId,
        generated_questions: generatedQuestions,
        manual_questions: manualQuestions,
        shift: data.shift,         
        location: selectedCityName,
        state: selectedStateName,
        job_description: data.jdDescription,
        post_to_website: postToWebsite,
        post_in: isVitelGlobalCompany && postToWebsite 
        ? (selectedWebsiteDomain === "vitelglobal.com" ? "vg.com" : "vg.in")
        : null,
        openings: parseInt(data.noOfOpenings ),
        roles_responsibility: data.roles_responsibility,
        education_level: data.education_level,
        workplace_types:Number(data.modeOfOperation)
    };
    console.log("generatedQuestions",generatedQuestions)
    console.log(":manualQuestions",manualQuestions)
    console.log("skill_level_conf",skill_level_conf)

    try {
        const config = { headers: { "Content-Type": "application/json" } };
        let response;

        if (id) {
            delete payload.job_order_id;
            response = await axios.patch(`/api/v1/create-job-order/edit/?job_id=${id}`, payload, config);
            console.log("response",response)
            setOnchangeTrue(false);
            setJobFinalized(true);
             setJobData(response.data.local_job || response.data);
             await Swal.fire({
                title: "Success!",
                text: "Job Order updated successfully. You are now moving to Social Media Posting",
                // text: "Job Order updated successfully. You are now moving to social media posting",
                // text :"Job Order updated successfully. You can now proceed to Social Media Posting",
                icon: "success",
                confirmButtonText: "OK",
             })


            await getsingleJobOrderid(id);
             const jobDetails = response.data.local_job;
             const jobTitle=jobDetails.job_title || "N/A"
                const experience = `${jobDetails.min_exp} -${jobDetails.max_exp} years`;
                const budget = jobDetails.salary_max || "N/A";
                const shiftType = jobDetails.shift || "N/A";
                const qualification = jobDetails.education_level || "N/A";
                const location = jobDetails.location || "N/A";
                const modeOfOperation = modeOfOperationTypes.find(type => type.id === jobDetails.workplace_types)?.name || "N/A";
                const numberOfOpenings = jobDetails.openings || "N/A";
                const jobDescription = jobDetails.job_description || "N/A";
                const rolesResponsibility = jobDetails.roles_responsibility || "N/A";
                const requiredKeySkills = jobDetails.skills?.join(", ") || "N/A";
                const applyLink  = jobDetails.website_url || "N/A";
                console.log("jobDetails",jobDetails)

            //  Swal.fire({
            //     title: "Success!",
            //     text: "Job Order updated successfully.",
            //     showCloseButton: true, 
            //     icon: "success",
            //     confirmButtonText: "OK",
            //     html: `
            //         <p>Job Order updated successfully.</p>
            //         <p><a href="${response.data.local_job.jd_document}" target="_blank" style="color: blue; text-decoration: underline;">Open Document</a>.</p>
            //     `,
            // }).then(() => {
            //     navigate("/all-job-orders");
            // });
             setModalTitle("Job Information!");
            setModalMessage("Job Order updated successfully.");
            setModalMessage(`
            <div class="table-responsive">
                <table class="table table-borderless">
                    <tbody>
                        <tr>
                            <td scope="row"><strong>Job Title :</strong> ${jobTitle}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Experience :</strong> ${experience}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Shift Type :</strong> ${shiftType}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Qualification :</strong> ${qualification}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Location :</strong> ${location}</td>
                        </tr>
                         <tr>
                            <td scope="row"><strong>Package/Budget :</strong> ${budget}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Mode of Operation :</strong> ${modeOfOperation}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Number of Openings :</strong> ${numberOfOpenings}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Job Description :</strong> ${jobDescription}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Roles & Responsibilities :</strong> ${rolesResponsibility}</td>
                        </tr>
                        <tr>
                            <td scope="row"><strong>Required Key Skills :</strong> ${requiredKeySkills}</td>
                        </tr>
                          <tr>
                    <td>
                        <strong>Apply Link:</strong>
                        ${applyLink !== "N/A"
                            ? `<a href="${applyLink}" target="_blank" style="color: blue; text-decoration: underline;">${applyLink}</a>`
                            : "N/A"}
                    </td>
                </tr>
                    </tbody>
                </table>
            </div>
        `);
    setJobOrderId(response.data.local_job.job_order_id);
    setJdDocumentUrl(response.data.local_job.jd_document);
    setShowSuccessModal(true);


        } else {
            response = await axios.post("/api/v1/create-job-order/", payload, config);
            setJobData(response.data.local_job || response.data);
            await Swal.fire({
                title: "Success!",
                text: "Job Order created successfully.You are now moving to Social Media Posting",
                icon: "success",
                confirmButtonText: "OK",
            
            })

            // navigate("/all-job-orders");
           // Inside createNewOrder, after the API call succeeds:
// Swal.fire({
//     title: "Success!",
//     text: "Job Order created successfully.",
//     icon: "success",
//     confirmButtonText: "OK",
//     html: `
//         <p>Job Order created successfully.</p>
//         <p>You can download the JD document <a href="${response.data.jd_document}" target="_blank" style="color: blue; text-decoration: underline;">here</a>.</p>
//     `,
// }).then(() => {
//     navigate("/all-job-orders");
// });
    
//  setModalTitle("Success!");
//     setModalMessage("Job Order created successfully.");
//     setJobOrderId(response.data.job_order_id);
//     setJdDocumentUrl(response.data.jd_document);
//     setShowSuccessModal(true);
//             if (!id) setJobIdStr(response.data.job_order_id);
//             setOnchangeTrue(false);
//             setJobFinalized(true);
// Extract details for modal
const experience = `${payload.min_exp}+ years`;
const shiftType = payload.shift || "N/A";
const qualification = payload.education_level || "N/A";
const location = payload.location || "N/A";
const modeOfOperation = modeOfOperationTypes.find(type => type.id === payload.workplace_types)?.name || "N/A";
const numberOfOpenings = payload.openings || "N/A";
const jobDescription = payload.job_description || "N/A";
const rolesResponsibility = payload.roles_responsibility || "N/A";
const requiredKeySkills = payload.skills?.join(", ") || "N/A";
const applyLink  = response.data.website_url || "N/A"
console.log("payload",payload)

// Set modal content
setModalTitle("Job Order Created Successfully");
setModalMessage(`
    <div class="table-responsive">
        <table class="table table-borderless">
            <tbody>
                <tr>
                    <td><strong>Experience :</strong> ${experience}</td>
                </tr>
                <tr>
                    <td><strong>Shift Type :</strong> ${shiftType}</td>
                </tr>
                <tr>
                    <td><strong>Qualification :</strong> ${qualification}</td>
                </tr>
                <tr>
                    <td><strong>Location :</strong> ${location}</td>
                </tr>
                <tr>
                    <td><strong>Mode of Operation :</strong> ${modeOfOperation}</td>
                </tr>
                <tr>
                    <td><strong>Number of Openings :</strong> ${numberOfOpenings}</td>
                </tr>
                <tr>
                    <td><strong>Job Description :</strong> ${jobDescription}</td>
                </tr>
                <tr>
                    <td><strong>Roles & Responsibilities :</strong> ${rolesResponsibility}</td>
                </tr>
                <tr>
                    <td><strong>Required Key Skills :</strong> ${requiredKeySkills}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Apply Link :</strong>
                        ${applyLink !== "N/A"
                            ? `<a href="${applyLink}" target="_blank" style="color: blue; text-decoration: underline;">${applyLink}</a>`
                            : "N/A"}
                    </td>
                </tr>

                <tr>
                    <td><strong>Preferred Qualifications:</strong> Experience working in a US Shift or a 24/7 support environment</td>
                </tr>
            </tbody>
        </table>
    </div>
`);
setJobOrderId(response.data.job_order_id);
setJdDocumentUrl(response.data.jd_document);
setShowSuccessModal(true);
if (!id) setJobIdStr(response.data.job_order_id);
setOnchangeTrue(false);
setJobFinalized(true);

        }
    console.log("ssdsddddd",skill_level_conf)

    } catch (error) {
        console.error("Error creating job order:", error);
         await Swal.fire({
            title: "Error!",
            text: "Failed to create/update job order.",
            icon: "error",
            confirmButtonText: "OK",
        });
        return { status: "error" };
    } finally {
        setIsSaving(false);
    }
    console.log("ssdsddddds",skill_level_conf)
};

    // helper to format firstScreeningQuestions
    const formatScreeningQuestions = (questionsArray) => {
        const formatted = {};
        let count = 1;
        questionsArray.forEach((q) => {
            const trimmed = q?.question?.trim();
            if (trimmed && trimmed !== "") {
                formatted[`Q${count++}`] = trimmed;
            }
        });
        return formatted;
    };

    // ---------------------------
    // JD Upload / Drag & Drop
    // ---------------------------

    const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const allowedExtensions = [".pdf", ".doc", ".docx"];

    const openUploadModal = () => {
        setSelectedFiles([]);
        setErrorJdMessage("");
        setIsUploadModalOpen(true);
    };
    const closeUploadModal = () => {
        setIsUploadModalOpen(false);
        setSelectedFiles([]);
        setErrorJdMessage("");
        setIsSubmittingJd(false);
    };

    // called when files are added via input or drag/drop
    const handleFilesAdded = (filesList) => {
        if (!filesList || !filesList.length) return;
        const files = Array.from(filesList);

        const validFiles = files.filter((file) => {
            const okType = allowedTypes.includes(file.type);
            const okExt = allowedExtensions.some((ext) => file.name.toLowerCase().endsWith(ext));
            return okType || okExt;
        });

        if (validFiles.length === 0) {
            setErrorJdMessage("Please upload a valid file (doc, docx, pdf).");
            return;
        }

        // append new valid files to list (avoid duplicates by name+size)
        setSelectedFiles((prev) => {
            const existing = prev || [];
            const combined = [...existing];
            validFiles.forEach((f) => {
                const exists = existing.some((ex) => ex.name === f.name && ex.size === f.size);
                if (!exists) combined.push(f);
            });
            return combined;
        });
        setErrorJdMessage("");
    };

    const onInputFileChange = (e) => {
        handleFilesAdded(e.target.files);
        e.target.value = null;
    };

    const onDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleFilesAdded(e.dataTransfer.files);
    };

    const onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const removeSelectedFile = (index) => {
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    };
    useEffect(() => {
  if (jobData?.modeOfOperation && modeOfOperationTypes.length > 0) {
    setValue("modeOfOperation", String(jobData.modeOfOperation));
  }
}, [jobData, modeOfOperationTypes, setValue]);


    // Import (parse JD) -> uses first selected file
    const handleImportJd = async () => {
        if (!selectedFiles.length) {
            setErrorJdMessage("Please select at least one JD file to import.");
            return;
        }

        const fileToSend = selectedFiles[0];
        if (!fileToSend) return;

        if (!allowedTypes.includes(fileToSend.type) && !allowedExtensions.some((ext) => fileToSend.name.toLowerCase().endsWith(ext))) {
            setErrorJdMessage("Please upload a valid file (doc, docx, pdf).");
            return;
        }

        setIsSubmittingJd(true);
        setErrorJdMessage("");
        try {
            const formData = new FormData();
            formData.append("job_description", fileToSend);

            const response = await axios.post("/api/v1/parse-jd/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.status === 200) {
                const jdData = response.data.data || {};
                setParsedJdMeta(response.data);
                const parsedLocation = jdData.location || jdData.job_location || "";
                // populate fields, converting numeric experiences to Number where appropriate
                setValue("job_title", jdData.job_title || "");
                setValue("location", parsedLocation, { shouldDirty: true, shouldValidate: true });
                setValue("jdDescription",jdData.job_description || "");
                setValue("designation", jdData?.designation?.[0] || "");
                if (jdData?.experience) {
                    // experience may be [min, max]
                    setValue("minExperience", jdData?.experience?.[0] === 0 ? 0 : Number(jdData?.experience?.[0] ?? ""));
                    setValue("maxExperience", jdData?.experience?.[1] ? Number(jdData?.experience?.[1]) : "");
                } else {
                    if (jdData?.min_exp !== undefined) setValue("minExperience", Number(jdData.min_exp));
                    if (jdData?.max_exp !== undefined) setValue("maxExperience", Number(jdData.max_exp));
                }
                setValue("closeDate", jdData?.close_date || "");
                setValue("primarySkills", jdData?.primary_skills ? jdData?.primary_skills.join(", ") : "");
                setValue("skills", jdData?.skills ? jdData?.skills.join(", ") : "");
                setValue("preferred_skills", jdData?.skills ? jdData.skills.join(",") : "");
                setValue("domain", jdData?.domain || "");
                setDifficultyLevel(jdData?.difficulty || "");
                setValue("difficultyLevel", jdData?.difficulty || "");
                setValue("jdDescription", jdData?.JDtext || "");

                // map category to existing testtypes to find id
                const matchedCategory = (testtypes || []).find(
                    (type) => type.name && jdData?.category && type.name.toLowerCase() === jdData.category.toLowerCase()
                );
                const categoryId = matchedCategory ? matchedCategory.id : "";
                setSelectedCategory(categoryId);
                // setSelectedCategoryName(categoryName);
                setSelectedCategoryName(matchedCategory ? matchedCategory.name : "");
                setValue("category", categoryId);
                if (categoryId) getSectionsFromCategory(categoryId);
                if ((jdData?.category || "").toLowerCase() === "technical") {
                    setHeadingText("Technical");
                } else {
                    setHeadingText("Non-Technical");
                }

                // setup initial skills if primary_skills are present
                if (jdData?.primary_skills?.length) {
                    const difficulty = (jdData?.difficulty || "intermediate").toLowerCase();
                    const defaults = difficultyToSkillDefaults[difficulty] || difficultyToSkillDefaults["intermediate"];

                    const initialSkills = jdData.primary_skills.map((skill) => {
                        const rating = defaults.rating;
                        const proficiency = defaults.proficiency;
                        const ratio = getQuestionRatio(rating, 5);
                        return {
                            name: skill,
                            rating,
                            proficiency,
                            ratio,
                            questions: 5,
                            duration: minutesToDuration(5 * 2),
                        };
                    });

                    setSkillConfig(initialSkills);
                }

                // success feedback
                setIsSubmittingJd(false);
                setSelectedFiles([]);
                closeUploadModal();
                toast("success", "Imported", "Job description parsed and fields populated.");
            } else {
                setErrorJdMessage("Failed to parse JD. Try another file.");
                setIsSubmittingJd(false);
            }
        } catch (err) {
            console.error("Error parsing JD:", err);
            setErrorJdMessage(err.response?.data?.message || "Failed to parse JD. Try again.");
            setIsSubmittingJd(false);
        }
    };

    // removed old resume upload code & duplicates - kept the modal UI & behaviorb

    // field handlers for second screening fields
    const handleAddField = (category) => {
        setFieldsState((prev) => ({ ...prev, [category]: [...prev[category], ""] }));
    };

    const handleRemoveField = (category, index) => {
        setFieldsState((prev) => {
            const newFields = prev[category].filter((_, i) => i !== index);
            return { ...prev, [category]: newFields.length ? newFields : [""] };
        });
    };

    const handleChangeField = (category, index, value) => {
        setFieldsState((prev) => {
            const newFields = [...prev[category]];
            newFields[index] = value;
            return { ...prev, [category]: newFields };
        });
    };

    // skill config handlers
    const handleSkillRatingChange = (index, value) => {
        const updatedSkills = [...skillConfig];
        updatedSkills[index].rating = value;

        if (value >= 1 && value <= 3) {
            updatedSkills[index].proficiency = "Beginner";
        } else if (value >= 4 && value <= 7) {
            updatedSkills[index].proficiency = "Intermediate";
        } else if (value >= 8 && value <= 9) {
            updatedSkills[index].proficiency = "Advanced";
        } else if (value === 10) {
            updatedSkills[index].proficiency = "Expert";
        }

        setSkillConfig(updatedSkills);
    };

    const handleSkillQuestionChange = (index, rawValue) => {
        setOnchangeTrue(true);
        setOnlySaveDone(false);

        const nextValue = rawValue?.target?.value ?? rawValue;
        const questionCount = Math.max(Number(nextValue) || 0, 0);

        setSkillConfig((prevSkills) =>
            prevSkills.map((skill, skillIndex) =>
                skillIndex === index
                    ? {
                        ...skill,
                        questions: questionCount,
                        cutoff: questionCount / 2,
                        duration: minutesToDuration(questionCount * 2),
                    }
                    : skill
            )
        );
    };

    const handleSkillCutoffChange = (index, rawValue) => {
        setOnlySaveDone(false);
        setOnchangeTrue(true);
        const nextValue = rawValue?.target?.value ?? rawValue;

        setSkillConfig((prevSkills) =>
            prevSkills.map((skill, skillIndex) => {
                if (skillIndex !== index) return skill;

                const questionCount = Number(skill.questions) || 0;
                const newVal = Math.max(Number(nextValue) || 0, 0);

                return {
                    ...skill,
                    cutoff: Math.min(newVal, questionCount),
                };
            })
        );
    };

    const handleDeleteSkill = (index) => {
        setOnlySaveDone(false);
        setOnchangeTrue(true);
        const updated = skillConfig.filter((_, i) => i !== index);
        setSkillConfig(updated);
    };

    const handleAddSkill = () => {
        setOnlySaveDone(false);
        setOnchangeTrue(true);
        setSkillLevelConfError("");
        setSkillConfig([...skillConfig, { name: "", rating: 1, proficiency: "Beginner", questions: 5,duration: minutesToDuration(5 * 2), }]);
    };

    // generation helpers & preview (unchanged)
    const getQuestionRatio = (rating, totalQuestions = 5) => {
         if (totalQuestions === 1) {
        if (rating <= 3) {
            return { beginner: 1, intermediate: 0, advanced: 0 };
        } else if (rating >= 4 && rating <= 7) {
            return { beginner: 0, intermediate: 1, advanced: 0 };
        } else {
            return { beginner: 0, intermediate: 0, advanced: 1 };
        }
    }
        let beginner, intermediate, advanced;
        if (rating <= 3) {
            beginner = Math.floor(totalQuestions * 0.7);
            intermediate = Math.floor(totalQuestions * 0.2);
            advanced = totalQuestions - beginner - intermediate;
        } else if (rating >= 4 && rating <= 7) {
            beginner = Math.floor(totalQuestions * 0.2);
            intermediate = Math.floor(totalQuestions * 0.6);
            advanced = totalQuestions - beginner - intermediate;
        } else {
            beginner = Math.floor(totalQuestions * 0.2);
            intermediate = Math.floor(totalQuestions * 0.3);
            advanced = totalQuestions - beginner - intermediate;
        }
        const remaining = totalQuestions - (beginner + intermediate + advanced);
        if (remaining > 0) intermediate += remaining;
        return { beginner, intermediate, advanced };
    };

    const handlePreviewQuestions = async () => {
        clearErrors();

    // Validate all required fields
    let isValid = true;
     const formValid = await trigger();
     if (!formValid) isValid = false;

    if (!getValues("job_title")) {
        setError("job_title", { type: "required", message: "Job Title is required" });
        isValid = false;
    }

    if (!selectedDepartment) {
        setError("job_order_department", { type: "required", message: "Department is required" });
        isValid = false;
    }
    if (!selectedAgent) {
        setError("agent", { type: "required", message: "Agent is required" });
        isValid = false;
    }

    if (!selectedDesignation) {
        setError("job_order_designation", { type: "required", message: "Designation is required" });
        isValid = false;
    }

    if (!getValues("minExperience")) {
        setError("minExperience", { type: "required", message: "Minimum Experience is required" });
        isValid = false;
    }

    if (!getValues("maxExperience")) {
        setError("maxExperience", { type: "required", message: "Maximum Experience is required" });
        isValid = false;
    } else if (getValues("minExperience") && parseInt(getValues("minExperience")) > parseInt(getValues("maxExperience"))) {
        setError("maxExperience", { type: "validate", message: "Must be greater than minimum experience" });
        isValid = false;
    }

    if (!difficultyLevel) {
        setSkillLevelConfError("Difficulty Level is required");
        isValid = false;
    } else {
        setSkillLevelConfError("");
    }

    if (!selectedCategory) {
        setError("category", { type: "required", message: "Category is required" });
        isValid = false;
    }
    if (!getValues("shift")) {
            setError("shift", { type: "required", message: "Shift is required" });
            isValid = false;
        }
        // Add validation for location
        if (!getValues("location")) {
            setError("location", { type: "required", message: "City is required" });
            isValid = false;
        }
         if (!getValues("state")) {
            setError("state", { type: "required", message: "State is required" });
            isValid = false;
        }
    // Check sk
    if (!selectedContacts || selectedContacts.length === 0) {
        setError("selectedContacts", { type: "required", message: "Please select at least one interviewer" });
        isValid = false;
    }
    if (!getValues("closeDate")) {
        setError("closeDate", { type: "required", message: "Close Date is required" });
        isValid = false;
    } else {
        const selectedDate = parseLocalDateOnly(getValues("closeDate"));
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (!selectedDate || selectedDate < today) {
            setError("closeDate", { type: "validate", message: "Close Date must be today or in the future" });
            isValid = false;
        }
    }


    const hasEmptySkill = skillConfig.some((skill) => !skill.name?.trim());
    if (hasEmptySkill) {
        setSkillLevelConfError("Skill Name Cannot be Empty !");
        isValid = false;
    } else if (skillConfig.length === 0) {
        setSkillLevelConfError("Please configure at least one skill");
        isValid = false;
    } else {
        setSkillLevelConfError("");
    }
    if (!validateSections()) {
    isValid = false;
  }

    // if (!isValid) {
    //     return;
    // }
    if (!isValid) {
        // Scroll to the first error field
        const firstErrorField = Object.keys(errors).find((field) => errors[field]);
        console.error("firstErrorField",firstErrorField)
        if (firstErrorField) {
            console.info("firstErrorField",firstErrorField)
            const element = document.querySelector(`[name="${firstErrorField}"]`);
            console.info("firstErrorFieldsasd",element)
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "center" });
                element.focus();
                element.style.border = "2px solid red";
            }
        }
         if (errors.jdDescription && jdDescriptions.current) {
            jdDescriptions.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            });
        }
        if (errors.agent) {
            const element = document.querySelector("#AgentDropdown");
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "center" });
                element.focus();
                // element.style.border = "2px solid red";
            }
        }

         if (errors.roles_responsibility && roles_responsibilitys.current) {
            roles_responsibilitys.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            });
        }
        return;
        
    }
     if (!selectedDepartment) {
        const deptElement = document.querySelector('[name="job_order_department"]');
        if (deptElement) {
            deptElement.scrollIntoView({ behavior: "smooth", block: "center" });
            deptElement.focus();
            deptElement.style.border = "2px solid red";
        }
    }

    // Scroll to Designation if selectedDesignation is missing
    if (!selectedDesignation) {
        const desigElement = document.querySelector('[name="job_order_designation"]');
        if (desigElement) {
            desigElement.scrollIntoView({ behavior: "smooth", block: "center" });
            desigElement.focus();
            desigElement.style.border = "2px solid red";
        }
    }

        if (!skillConfig || skillConfig.length === 0) {
            setSkillLevelConfError("No skills configured to generate questions");
            setGenerationSuccess(false);
            return;
        }
        const hasSelectedRounds = sectionData.some((section) => section.checked);

        if (!hasSelectedRounds) {
            const result = await Swal.fire({
            title: "No Rounds Selected",
            text: "Are you sure you want to finalize without selecting any rounds?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Finalize",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            });
            if (result.isDismissed) {
            return;
            }
        }
       if (jobData?.questions_reviewed) {
            const result = await Swal.fire({
                title: "Questions Already Reviewed",
                html: `Screening questions for this job have already been reviewed.<br/><br/>
                    Regenerating will <strong>replace</strong> existing questions.<br/>
                    Your previous questions will be saved and viewable.`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Regenerate",
                cancelButtonText: "Cancel",
            });
            if (!result.isConfirmed) return;
        }
            if (isEditMode && (hasQuestionContent(generatedQuestions) || hasQuestionContent(manualQuestions))) {
                setPreviousGeneratedQuestions(JSON.parse(JSON.stringify(generatedQuestions)));
                setPreviousManualQuestions(JSON.parse(JSON.stringify(manualQuestions)));
            }
            if (isEditMode && hasQuestionContent(screeningQuestions)) {
                setPreviousScreeningQuestions(JSON.parse(JSON.stringify(screeningQuestions)));
            }
        try {
            setIsGenerating(true);
            setSkillLevelConfError("");
        //      const screeningPayload = {
        //     job_title: getValues("job_title"),
        //     skills: skillConfig.map(skill => skill.name).join(","),
        //     experience_level: difficultyLevel,
        //     num_questions: 3, // or dynamic value
        // };
                    const screeningPayload = {
                job_title: getValues("job_title"),
                skills: skillConfig.map(skill => skill.name).join(","),
                experience_level: getValues("maxExperience"),
                num_questions: 3, // or dynamic value
                };
                const screeningResponse = await axios.post(
            "/api/v1/generate-screening-questions/",
            screeningPayload,
            );

            // Store screening questions in state if needed
            if (screeningResponse.data) {
            console.log("Screening questions generated:", screeningResponse.data);
             setScreeningQuestions(screeningResponse.data);
            // You can store these in state or use them as needed
            }

            const skillsPayload = {};
            skillConfig.forEach((skill) => {
                const totalQuestions = skill.questions || 5;
                const { beginner, intermediate, advanced } = getQuestionRatio(skill.rating, totalQuestions);
                skillsPayload[skill.name.toLowerCase()] = `${beginner} beginner, ${intermediate} intermediate, ${advanced} advanced`;
            });
            const designationId = getValues("job_order_designation");
            const designationName = designationList.find(
                d => String(d.designation_id) === String(designationId)
            )?.name || "";
            const payload = {
                skills: skillsPayload,
                designation: designationName,
                domain: getValues("domain"),
                category: selectedCategory,
                difficulty: difficultyLevel,
            };

            let section_data = {};
            sectionData.forEach((sec) => {
                if (sec.checked) {
                    section_data[sec.name] = sec.no_of_questions;
                }
            });
            payload.section_data = section_data;

            const response = await axios.post("api/v1/generate-section-questions/generate/", { ...payload, sections: section_data });

            if (response.data?.skill_wise_questions) {
                 console.log("Response skill_wise_questions:", response.data)
                const normalizedData = {};
                Object.entries(response.data.skill_wise_questions).forEach(([skill, levels]) => {
                    normalizedData[skill] = {};
                    ["beginner", "intermediate", "advanced"].forEach((level) => {
                        normalizedData[skill][level] = (levels[level] || []).map((q) => (typeof q === "string" ? { text: q } : q));
                    });
                });

                setOnchangeTrue(true);
                setOnlySaveDone(true);
                setGeneratedQuestions(normalizedData);
                setQuestionsGenerated(true); 
                setGenerationSuccess(true);
                setMainTab(1)
            }
                if (response.data?.section_wise_questions) {
                    console.log("Response data:", response.data);
                // Initialize manualQuestions with the correct structure
                const newManualQuestions = {};
                Object.entries(response.data.section_wise_questions).forEach(([sectionName, levels]) => {
                    newManualQuestions[sectionName] = {
                    questions: {
                        beginner: levels.beginner || [],
                        intermediate: levels.intermediate || [],
                        advanced: levels.advanced || [],
                    },
                    };
                });
                setManualQuestions(newManualQuestions);
                
                }

            setMainTab(1)
        } catch (error) {
            console.error(error);
            setSkillLevelConfError("Failed to generate questions");
        } finally {
            setIsGenerating(false);
        }
        return;
    };

    // manual questions & generated question handlers (kept)
    const handleAddManualQuestion = (sectionName, level) => {
  setManualQuestions((prev) => {
    const updated = { ...prev };
    if (!updated[sectionName]) {
      updated[sectionName] = {
        questions: {
          beginner: [],
          intermediate: [],
          advanced: [],
        },
      };
    }
    if (!updated[sectionName].questions[level]) {
      updated[sectionName].questions[level] = [];
    }
    updated[sectionName].questions[level] = [...updated[sectionName].questions[level], ""];
    return updated;
  });
};
// const getUserPermissions = () => {
//   const userId = userInfos?.user_details?.user_id;
//   const userPermission = jobData?.permissions?.find(p => p.user_id === userId);
//   return {
//     canAddQuestions: userPermission?.can_add_questions || false,
//     canDeleteQuestions: userPermission?.can_delete_questions || false,
//     canViewQuestions:userPermission?.can_view_questions || false
//   };
// };
const getUserPermissions = () => {
  const userId = userInfos?.user_details?.user_id;
  const userPermission = jobData?.permissions?.find(p => p.user_id === userId);

  // If we're in create mode (not edit mode), allow viewing questions
  if (!isEditMode) {
    return {
      canEditJob: true,
      canAddQuestions: true,  // Allow adding during creation
      canDeleteQuestions: true,  // Allow deleting during creation
      canViewQuestions: true  // Allow viewing during creation
    };
  }

  // For edit mode, use the actual permissions
  return {
    canEditJob: userPermission?.can_edit_job || false,
    canAddQuestions: userPermission?.can_add_questions || false,
    canDeleteQuestions: userPermission?.can_delete_questions || false,
    canViewQuestions: userPermission?.can_view_questions || false
  };
};


   const handleManualQuestionChange = (sectionName, level, index, value) => {
  setManualQuestions((prev) => {
    const updated = { ...prev };
    if (!updated[sectionName]) {
      updated[sectionName] = {
        questions: {
          beginner: [],
          intermediate: [],
          advanced: [],
        },
      };
    }
    if (!updated[sectionName].questions[level]) {
      updated[sectionName].questions[level] = [];
    }
    updated[sectionName].questions[level][index] = value;
    return updated;
  });
};


  const handleRemoveManualQuestion = (sectionName, level, index) => {
  setManualQuestions((prev) => {
    const updated = { ...prev };
    if (!updated[sectionName]?.questions?.[level]) return prev;
    updated[sectionName].questions[level] = updated[sectionName].questions[level].filter((_, i) => i !== index);
    return updated;
  });
};


    const handleGeneratedQuestionChange = (skill, level, index, value) => {
        setGeneratedQuestions((prev) => {
            const updated = { ...prev };
            if (!updated[skill]) updated[skill] = { beginner: [], intermediate: [], advanced: [] };
            if (!updated[skill][level]) updated[skill][level] = [];
            updated[skill][level] = updated[skill][level].map((q, i) => (i === index ? { text: value } : q));
            return updated;
        });
    };

    const handleAddGeneratedQuestion = (skill, level) => {
        setGeneratedQuestions((prev) => {
            const updated = { ...prev };
            if (!updated[skill]) updated[skill] = { beginner: [], intermediate: [], advanced: [] };
            if (!updated[skill][level]) updated[skill][level] = [];
            updated[skill][level] = [...updated[skill][level], { text: "" }];
            return updated;
        });
    };

    const handleRemoveGeneratedQuestion = (skill, level, index) => {
        setGeneratedQuestions((prev) => {
            const updated = { ...prev };
            if (!updated[skill] || !updated[skill][level]) return updated;
            updated[skill][level] = updated[skill][level].filter((_, i) => i !== index);
            return updated;
        });
    };

    // triggerAutoDifficulty helper
    const triggerAutoDifficulty = (min, max) => {
        const minExp = parseInt(min);
        const maxExp = parseInt(max);

        if (!minExp && !maxExp) return;

        let avg = (minExp + maxExp) / 2;
        let autoDifficulty = "";

        if (avg <= 2) autoDifficulty = "beginner";
        else if (avg <= 5) autoDifficulty = "intermediate";
        else autoDifficulty = "advanced";

        setDifficultyLevel(autoDifficulty);
        setValue("difficultyLevel", autoDifficulty);
        clearErrors("difficultyLevel");
    };
const handleSuggestWithAI = async (sectionName, level) => {
  try {
    setIsGenerating(true);
    const designationId = getValues("job_order_designation");
    const designationName = designationList.find(
      d => String(d.designation_id) === String(designationId)
    )?.name || "";
     console.log("Sending difficulty:", designationName); // Add this line
    const payload = {
      designation:designationName,
      category: selectedCategory,
      difficulty: level,
      generate_type: "section_wise",
      section_data: {
       [sectionName.charAt(0).toUpperCase() + sectionName.slice(1)]: "1"
      },
    };
    const response = await axios.post(
      "api/v1/generate-section-questions/generate/",
      payload,
    );
    const formattedSection =
  sectionName.charAt(0).toUpperCase() + sectionName.slice(1);

    if (response.data?.section_wise_questions) {
      const skillQuestions =  response.data.section_wise_questions?.[formattedSection]?.[level] || [];
      setManualQuestions((prev) => {
        const updated = { ...prev };
        if (!updated[sectionName]) {
          updated[sectionName] = {
            questions: {
              beginner: [],
              intermediate: [],
              advanced: [],
            },
          };
        }
        if (!updated[sectionName].questions[level]) {
          updated[sectionName].questions[level] = [];
        }
        // Append new questions to the existing list
        updated[sectionName].questions[level] = [...updated[sectionName].questions[level], ...skillQuestions];
        return updated;
      });
      toast("success", "AI Suggestions", "Questions generated successfully!");
    } else if (response.data?.section_wise_questions) {
      const newQuestions = response.data.section_wise_questions[sectionName]?.[level] || [];
      setManualQuestions((prev) => {
        const updated = { ...prev };
        if (!updated[sectionName]) {
          updated[sectionName] = {
            questions: {
              beginner: [],
              intermediate: [],
              advanced: [],
            },
          };
        }
        if (!updated[sectionName].questions[level]) {
          updated[sectionName].questions[level] = [];
        }
        updated[sectionName].questions[level] = [...updated[sectionName].questions[level], ...newQuestions];
        return updated;
      });
      toast("success", "AI Suggestions", "Questions generated successfully!");
    } else {
      toast("error", "Error", "No questions were generated.");
    }
  } catch (error) {
    console.error("Error generating AI questions:", error);
    toast("error", "Error", "Failed to generate questions.");
  } finally {
    setIsGenerating(false);
  }
};

const handleSuggestWithAIGenerated = async (skill, level) => {
     const designationId = getValues("job_order_designation");
    const designationName = designationList.find(
      d => String(d.designation_id) === String(designationId)
    )?.name || "";
  try {
    setIsGenerating(true);
     console.log("Sending difficulty2:", difficultyLevel); // Add this line
    const payload = {
      designation: designationName,
      category: selectedCategory,
      difficulty: level,
      generate_type: "skill_wise",
      skills: {
        [skill.toLowerCase()]: "1",
      },
    };
    const response = await axios.post(
      "api/v1/generate-section-questions/generate/",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data?.skill_wise_questions) {
      const skillQuestions = response.data.skill_wise_questions[skill.toLowerCase()]?.[level] || [];
      setGeneratedQuestions((prev) => {
        const updated = { ...prev };
        if (!updated[skill]) {
          updated[skill] = {
            beginner: [],
            intermediate: [],
            advanced: [],
          };
        }
        if (!updated[skill][level]) {
          updated[skill][level] = [];
        }
        updated[skill][level] = [...updated[skill][level], ...skillQuestions.map((q) => ({ text: q }))];
        return updated;
      });
      toast("success", "AI Suggestions", "Questions generated successfully!");
    } else {
      toast("error", "Error", "No questions were generated.");
    }
  } catch (error) {
    console.error("Error generating AI questions:", error);
    toast("error", "Error", "Failed to generate questions.");
  } finally {
    setIsGenerating(false);
  }
};


    // onSubmit
    const onSubmit = async (data,action="") => {
        if (isJobReadOnly) {
            return { status: "error" };
        }
        try {
            const hasEmptySkill = skillConfig.some((skill) => !skill.name?.trim());
            if (hasEmptySkill) {
            setSkillLevelConfError("Skill name cannot be empty.");
            return;
            }
             if (!selectedContacts || selectedContacts.length === 0) {
                setError("selectedContacts", {
                    type: "manual",
                    message: "Please Select Atleast One Interviewer.",
                });
            return;
        }
            if (skillConfig.length === 0) {
                setSkillLevelConfError("Please configure at least one skill with rating and proficiency.");
                return;
            }
             if (!data.shift) {
            setError("shift", { type: "required", message: "Shift is required" });
            return;
            }
            const resolvedLocation = data.location || data.job_location || "";
            if (!resolvedLocation) {
                setError("location", { type: "required", message: "Location is required" });
                return;
            }
            if (!validateSections()) {
                return;
            }
            if (!data.roles_responsibility) {
                setError("roles_responsibility", { type: "required", message: "Roles and Responsibilities are required" });
                isValid = false;
            }

            if (!data.education_level) {
                setError("education_level", { type: "required", message: "Required Education is required" });
                isValid = false;
            }


            setIsSubmittingJob(true);
            const payload = {
                ...data,
                location: resolvedLocation,
                post_to_website: postToWebsite,
                skills: skillConfig.map((skill) => ({
                    name: skill.name,
                    rating: skill.rating,
                    proficiency: skill.proficiency,
                })),
            };

        const response = await createNewOrder(payload);

        // if (response && response.data){
        //     console.log("if (response && response.data){",response && response.data)
            // Swal.fire({
            //     title: "Success!",
            //     text: "Job Order created successfully.",
            //     icon: "success",
            //     confirmButtonText: "OK",
            // })
            // // .then(() => {
            // //     if (action === "goToList") {
            // //         navigate("/all-job-orders");
            // //     } else {
            // //         navigate(`/create-job-orders-view/${response.job_order_id}`);
            // //     }
            // .then(() => {
            //     navigate("/all-job-orders");
            // })}
           if (response && response.data) {
                if (action === "goToSocialMedia") {
                    console.log("response.data",response.data,response.data.local_job)
                    setJobData(response.data.local_job || response.data);
                    setMainTab(4); // Navigate to Social Media Posting tab
                } else {
                    navigateBackToJobOrders();
                }}    
      return response;
    
        }  catch (error) {
            console.error("Error submitting form:", error);
            // Swal.fire({
            //     title: "Error!",
            //     text: "Failed to create/update job order.",
            //     icon: "error",
            //     confirmButtonText: "OK",
            // });
            setModalTitle("Error!");
            setModalMessage("Failed to create/update job order.");
            setShowErrorModal(true);

    }  finally { 
            setIsSubmittingJob(false);
        }
    };

    // Sections DataTable columns (unchanged)
    const sectionsColumns = [
        {
            name: "Round",
            selector: (row) => row.name,
            sortable: false,
            cell: (row) => {
                const idx = sectionData.findIndex((s) => s === row);
                return (
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`SectionNameChecked${row.id}`}
                            onChange={(e) => {
                                changeselectedcheck(e.target.checked, idx);
                                setTimesettingError(false);
                            }}
                            checked={!!row.checked}
                        />
                        <label className="form-check-label" htmlFor={`SectionNameChecked${row.id}`}>
                            {row.name}
                        </label>
                    </div>
                );
            },
            width: "30%",
        },
        {
            name: "No of Questions",
            selector: (row) => row.no_of_questions,
            sortable: false,
            cell: (row) => {
                const idx = sectionData.findIndex((s) => s === row);
                return (
                    <input
                        type="number"
                        className="form-control"
                        id={`NoOfQuestions_${idx}`}
                        value={row.no_of_questions ?? ""}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || (value >= 0 && value <= 20)) {
                                changeselectionValue(value, row.id, idx, "questions");
                            }
                        }}
                        min="0"
                        max="20"
                    />
                );
            },
            width: "15%",
        },
        {
            name: "Duration",
            selector: (row) => row.duration,
            sortable: false,
            cell: (row) => {
                const idx = sectionData.findIndex((s) => s === row);
                return (
                    <>
                        <input
                            type="text"
                            className="form-control"
                            value={row.duration || ""}
                            onInput={(e) => {
                                let value = e.target.value;
                                value = value.replace(/[^0-9:]/g, "");
                                if (value.length > 8) value = value.substring(0, 8);
                                e.target.value = value;
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value && value !== "0") changeselectionValue(value, row.id, idx, "duration");
                            }}
                        />
                        {(!row.duration || row.duration === "0") && <small className="text-danger">This field is required and cannot be zero</small>}
                    </>
                );
            },
            width: "20%",
        },
        {
            name: "Total Score",
            selector: (row) => row.total_score,
            sortable: false,
            cell: (row) => <input type="number" className="form-control" value={row.total_score ?? ""} disabled />,
            width: "15%",
        },
        {
            name: "Cutoff Score",
            selector: (row) => row.cutoff_score,
            sortable: false,
            cell: (row) => {
                const idx = sectionData.findIndex((s) => s === row);
                return (
                    <input
                        type="number"
                        className="form-control"
                        value={row.cutoff_score ?? ""}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value && value !== "0") changeselectionValue(value, row.id, idx, "cutoff_score");
                        }}
                    />
                );
            },
            width: "20%",
        },
    ];

    const paginationComponentOptions = {
        noRowsPerPage: true,
    };

    // ---- UI rendering ----
    const [contacts, setContacts] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
        const filteredContacts = contacts?.filter(contact =>
        contact.name.toLowerCase().includes(filterText.toLowerCase())
    );

    const [loadingContacts,setLoadingContacts] = useState(true)
const TAB_INDEX = {
  BASIC_DETAILS: 1,
  JOB_DETAILS: 2,   // ← Mode of Operation & Close Date here
  FINAL: 3
};


// fetchContacts removed — data is populated from fetchUsers to avoid duplicate API call

const { canEditJob, canAddQuestions, canDeleteQuestions,canViewQuestions  } = getUserPermissions();
const isJobReadOnly = isEditMode && jobData && !canEditJob;
useEffect(() => {
  if (copySuccess) {
    Swal.fire({
      icon: "success",
      title: "Copied!",
      text: "Content copied to clipboard!",
      timer: 1500,
      showConfirmButton: false,
    });
  }
}, [copySuccess]);

const selectedEditJobOption =
    editJobOptions.find((option) => option.value === String(selectedEditJobId)) ||
    normalizeEditJobOption(jobData);
const selectMenuListComponents = useMemo(
    () => ({ MenuList: EditJobOrderMenuList }),
    []
);
const jobOrderTabHeader = isEditMode ? (
    <div
        style={{ minWidth: "240px" }}
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
    >
      <Select
            classNamePrefix="job-order-tab-select"
            value={selectedEditJobOption}
            options={editJobOptions}
            onChange={handleEditJobChange}
            isLoading={editJobsLoading}
            jobOrderSearchFocusedRef={jobOrderSearchFocusedRef}
            isSearchable={false}
            filterOption={() => true}
            components={selectMenuListComponents}
            menuIsOpen={jobOrderMenuOpen}
            onMenuOpen={() => setJobOrderMenuOpen(true)}
            onMenuClose={() => {
                if (jobOrderSearchFocusedRef.current) {
                    setJobOrderMenuOpen(true);
                    return;
                }
                setJobOrderMenuOpen(false);
            }}
            placeholder="Select Job Order"
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            menuPosition="fixed"
            editJobSearchText={editJobSearchText}
            setEditJobSearchText={setEditJobSearchText}
            fetchEditJobOptions={fetchEditJobOptions}
            setJobOrderMenuOpen={setJobOrderMenuOpen}
            companyId={companyId}
            editJobsLoading={editJobsLoading}   
            editJobPage={editJobPage}
            editJobTotalCount={editJobTotalCount}
            styles={{
                control: (base) => ({
                    ...base,
                    minHeight: "34px",
                    borderColor: "#d7dee8",
                    boxShadow: "none",
                    cursor: "pointer",
                }),
                valueContainer: (base) => ({
                    ...base,
                    padding: "0 8px",
                    fontSize: "13px",
                    fontWeight: 600,
                }),
                indicatorsContainer: (base) => ({
                    ...base,
                    height: "32px",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
        />
    </div>
) : (
    "Job Order"
);

    return (
        <>
            {loading ? (
                <div className="p-3">
                  <OrgTableShimmer columns={4} rows={8} titleWidth="230px" />
                </div>
              ) : (
                <div ref={createJobOrderPageRef} className="p-3 create-job-order-page">
                 {/* Page header */}
                <div className="mb-3">
                    <h3 className="btn addBtn">{id ? "Edit Job Order" : "Create Job Order"}</h3>
                 </div>

                 <Toast ref={toastRef} />

                {/* <TabView
                    onTabChange={(e) => {
        console.log("Tab changed to:", e.index);
        setMainTab(e.index);
    }}
                >
                    {/* <TabPanel header="Job Order"/> */}
                {/* </TabView>  */}
              

                {/* MAIN TAB 0 */}
                <TabView id="CreateJobOrderTabs"
                    activeIndex={mainTab}
                    // onTabChange={(e) => {
                    //     console.log("Tab changed to:", e.index);
                    //     setMainTab(e.index);
                    // }}
                     onTabChange={(e) => {
                        // if (isJobReadOnly) {
                        //     setMainTab(0);
                        //     return;
                        // }
                        if (e.index === 0) {
                            setMainTab(e.index);
                            return;
                        }
                        if (e.index === 4 && !isEditMode && !jobFinalized) {
                            Swal.fire({
                                icon: "warning",
                                title: "Finalize Job Order",
                                text: "Please finalize job order before posting on social media.",
                                timer: 3000,
                                showConfirmButton: false,
                                timerProgressBar: true,
                            });
                            return;
                        }
                        if (isEditMode) {
                            setMainTab(e.index);
                            return;
                        }
                    if (questionsGenerated) {
                        setMainTab(e.index);
                    } else {
                        toastRef.current.show({
                            severity: "error",
                            summary: "Error",
                            detail: "Please generate questions first",
                            life: 3000,
                        });
                    }
                    //  if (e.index <= 4 || questionsGenerated) {
                    //         setMainTab(e.index);
                    //         } else {
                    //         toastRef.current.show({
                    //             severity: "error",
                    //             summary: "Error",
                    //             detail: "Please generate questions first",
                    //             life: 3000,
                    //         });
                    //         }
                    // Allow navigation to tab 0 (Job Order) from any tab
                    // if (e.index === 0) {
                    //     setMainTab(e.index);
                    //     return;
                    // }
                    // // For edit mode, allow navigation to all tabs
                    // if (isEditMode) {
                    //     setMainTab(e.index);
                    //     return;
                    // }
                    // For new jobs, only allow navigation if questions are generated
                    // if (questionsGenerated) {
                    //     setMainTab(e.index);
                    // } else {
                    //     toastRef.current.show({
                    //         severity: "error",
                    //         summary: "Error",
                    //         detail: "Please finalize the job order first",
                    //         life: 3000,
                    //     });
                    // }
                }}
                >
                    <TabPanel header={jobOrderTabHeader} id="JobOrder">
                        {isJobReadOnly && (
                        <div className="alert alert-warning mt-2 mb-2 py-2">
                            Note : You do not have edit access for this job order. Fields are read-only.
                        </div>
                        )}
                        {isEditMode && (
                        <div className="text-start mt-2">
                            {/* <strong>Note :</strong>{" "} */}
                            <span className="fw-bold text-muted">
                                {isJobReadOnly
                                    ? ""
                                    : "In edit mode, you can navigate between the tabs without generating the questions"}
                            </span>
                        </div>
                        )}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input
                            type="hidden"
                            {...register("preferred_skills")}
                            />
                        <div className="row mb-2">
                            <div className="col-12 d-flex justify-content-end">
                                <div className="col-4 d-flex justify-content-end">
                                     <label className="me-2 mt-2">Select Company</label>
                                     <div style={{ width: "200px"}}>
                                        {id && !companyId ? (
                                            <Input type="select" disabled>
                                                <option>Loading company...</option>
                                            </Input>
                                        ) : (
                                            <CompanySelector
                                                onCompanyChange={handleCompanyChange}
                                                selectedCompanyId={companyId}
                                            />
                                        )}
                                    </div>
                                </div>
                                <button type="button" className="btn blueBtn" style={{ height: "35px" }} onClick={openUploadModal} disabled={isEditMode || !!id}>
                                    <i className="pi pi-upload"></i> Upload JD
                                </button>
                                <button type="button" className="btn blueBtn" style={{ height: "35px" }} onClick={navigateBackToJobOrders}>
                                     Back
                                </button>
                            </div>
                        </div>

                        <fieldset
                            disabled={isJobReadOnly}
                            style={{
                                border: 0,
                                padding: 0,
                                margin: 0,
                                pointerEvents: isJobReadOnly ? "none" : undefined,
                                opacity: isJobReadOnly ? 0.78 : 1,
                            }}
                        >
                        <Row className="g-3">
                            {/* Job Title */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label htmlFor="jobtitle" className="form-label fw-semibold mb-1">
                                    Job Title <span className="text-danger">*</span>
                                </label>
                                <input
                                    id="jobtitle"
                                    type="text"
                                    {...register("job_title", {
                                        required: "This field is required",
                                        minLength: { value: 3, message: "Please enter at least 3 characters" },
                                    })}
                                    className={`form-control ${errors.job_title ? "is-invalid" : ""}`}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setValue("job_title",value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("job_title")
                                         if (e.target.value.trim() !== "") {
                                                e.target.style.border = "";
                                        }
                                    }}
                                />
                                {errors.job_title && <small className="text-danger">{errors.job_title.message}</small>}
                            </Col>

                            {/* Department */}
                            {/* <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">Department <span className="text-danger">*</span></label>
                                <select
                                    {...register("job_order_department",{ required: "This field is required",})}
                                    value={selectedDepartment}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedDepartment(value);
                                        setValue("job_order_department", value);
                                        clearErrors("job_order_department");
                                        setOnlySaveDone(false);
                                        setOnchangeTrue(true);
                                    }}
                                    className="form-select"
                                >
                                    <option value="">Select Department</option>
                                    {departments.map((d, i) => (
                                        <option key={i} value={d.department_id}>
                                            {d.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.job_order_department && <small className="text-danger">{errors.job_order_department.message}</small>}
                            </Col> */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Department <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="job_order_department"
                                    control={control}
                                    rules={{ required: "Department is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={departmentList.map(dept => ({
                                                value: dept.department_id,
                                                label: dept.name
                                            }))}
                                            // value={departments.find(dept => dept.department_id === selectedDepartment) ? {
                                            //     value: selectedDepartment,
                                            //     label: departments.find(dept => dept.department_id === selectedDepartment)?.name
                                            // } : null}
                                            value={
                                                departmentList.find(
                                                    dept => String(dept.department_id) === String(selectedDepartment)
                                                )
                                                ? {
                                                    value: selectedDepartment,
                                                    label: departmentList.find(
                                                        dept => String(dept.department_id) === String(selectedDepartment)
                                                    )?.name
                                                }
                                                : null
                                            }
                                            onChange={(selectedOption) => {
                                                const value = selectedOption ? String(selectedOption.value) : "";
                                                setSelectedDepartment(value);
                                                setValue("job_order_department", value);
                                                clearErrors("job_order_department");
                                                setOnlySaveDone(false);
                                                setOnchangeTrue(true);
                                                if (value) {
                                                    const element = document.querySelector(`[name="job_order_department"]`);
                                                    if (element) element.style.border = "";
                                                }
                                            }}
                                            className={`react-select-container ${errors.job_order_department ? "is-invalid" : ""}`}
                                            classNamePrefix="react-select"
                                            placeholder="Select Department"
                                            isClearable
                                            components={{
                                    MenuList: ({ children, ...props }) => (
                                        <components.MenuList {...props}>
                                            {children}
                                            <div
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setNewDepartmentName("");
                                                    setAddDeptError("");
                                                    setShowAddDepartmentModal(true);
                                                }}
                                                style={{
                                                    padding: "8px 12px",
                                                    cursor: "pointer",
                                                    color: "#007bff",
                                                    fontWeight: 600,
                                                    borderTop: "1px solid #e0e0e0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    fontSize: "13px",
                                                    backgroundColor: "#f0f7ff",
                                                    position: "sticky",
                                                    bottom: 0,
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f7ff"}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                                            >
                                                <FaPlus size={11} /> Add Department
                                            </div>
                                        </components.MenuList>
                                        )}}
                                        />
                                    )}
                                />
                                {errors.job_order_department && (
                                    <div className="invalid-feedback d-block">
                                        {errors.job_order_department.message}
                                    </div>
                                )}
                            </Col>


                            {/* Designation */}
                            {/* <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">Designation <span className="text-danger">*</span></label>
                                <select
                                    {...register("job_order_designation",{ required: "This field is required",})}
                                    value={selectedDesignation}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedDesignation(value);
                                        setValue("job_order_designation", value);
                                        clearErrors("job_order_designation");
                                        setOnlySaveDone(false);
                                        setOnchangeTrue(true);
                                    }}
                                    className="form-select"
                                >
                                    <option value="">Select Designation</option>
                                    {designation.map((d, i) => (
                                        <option key={i} value={d.designation_id}>
                                            {d.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.job_order_designation && <small className="text-danger">{errors.job_order_designation.message}</small>}
                            </Col> */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Designation <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="job_order_designation"
                                    control={control}
                                    rules={{ required: "Designation is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={designationList.map(desig => ({
                                                value: desig.designation_id,
                                                label: desig.name
                                            }))}
                                            // value={designation.find(desig => desig.designation_id === selectedDesignation) ? {
                                            //     value: selectedDesignation,
                                            //     label: designation.find(desig => desig.designation_id === selectedDesignation)?.name
                                            // } : null}
                                            value={
                                                    designationList.find(
                                                        desig => String(desig.designation_id) === String(selectedDesignation)
                                                    )
                                                    ? {
                                                        value: selectedDesignation,
                                                        label: designationList.find(
                                                            desig => String(desig.designation_id) === String(selectedDesignation)
                                                        )?.name
                                                    }
                                                    : null
                                                }
                                            onChange={(selectedOption) => {
                                                const value = selectedOption ? String(selectedOption.value) : "";
                                                setSelectedDesignation(value);
                                                setValue("job_order_designation", value);
                                                clearErrors("job_order_designation");
                                                setOnlySaveDone(false);
                                                setOnchangeTrue(true);
                                            }}
                                            className={`react-select-container ${errors.job_order_designation ? "is-invalid" : ""}`}
                                            classNamePrefix="react-select"
                                            placeholder="Select Designation"
                                            isClearable
                                            components={{
                                                MenuList: ({ children, ...props }) => (
                                                    <components.MenuList {...props}>
                                                        {children}
                                                        <div
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setNewDesignationName("");
                                                                setAddDesignError("");
                                                                setShowAddDesignationModal(true);
                                                            }}
                                                            style={{
                                                                padding: "8px 12px",
                                                                cursor: "pointer",
                                                                color: "#007bff",
                                                                fontWeight: 600,
                                                                borderTop: "1px solid #e0e0e0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                fontSize: "13px",
                                                                backgroundColor: "#fff",
                                                                position: "sticky",
                                                                bottom: 0,
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f7ff"}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                                                        >
                                                            <FaPlus size={11} /> Add Designation
                                                        </div>
                                                    </components.MenuList>
                                                )
                                            }}
                                        />
                                    )}
                                />
                                {errors.job_order_designation && (
                                    <div className="invalid-feedback d-block">
                                        {errors.job_order_designation.message}
                                    </div>
                                )}
                            </Col>


                            {/* Minimum Experience */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Minimum Experience <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    autoComplete="off"
                                    maxLength={2}
                                    {...register("minExperience", {
                                        required: "This field is required",
                                        pattern: { value: /^[0-9]{1,2}$/, message: "Maximum 2 digits allowed" },
                                        validate: (value) => {
                                            const maxExperience = getValues("maxExperience");
                                            if (maxExperience && parseInt(value) > parseInt(maxExperience)) {
                                                return "Minimum Experience must be less than Maximum Experience";
                                            }
                                            return true;
                                        },
                                        
                                    })}
                                    className={`form-control ${errors.minExperience ? "is-invalid" : ""}`}
                                    onInput={(e) => {
                                        if (e.target.value.length > 2) {
                                        e.target.value = e.target.value.slice(0, 2);
                                        }
                                    }}
                                    onChange={(e) => {
                                        setValue("minExperience", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger(["minExperience", ""])
                                        triggerAutoDifficulty(e.target.value, getValues("maxExperience"));
                                        if (e.target.value) {
                                        e.target.style.border = "";
                                    }  
                                    
                                    }}
                                />
                                {errors.minExperience && <small className="text-danger">{errors.minExperience.message}</small>}
                            </Col>

                            {/* Maximum Experience */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Maximum Experience <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    autoComplete="off"
                                     maxLength={2}
                                    {...register("maxExperience", {
                                        required: "This field is required",
                                        pattern: { value: /^[0-9]{1,2}$/, message: "Maximum 2 digits allowed" },
                                        maxLength: { value: 2, message: "Maximum 2 digits allowed" }
                                    })}
                                    className={`form-control ${errors.maxExperience ? "is-invalid" : ""}`}
                                     onInput={(e) => {
                                        if (e.target.value.length > 2) {
                                        e.target.value = e.target.value.slice(0, 2);
                                        }
                                    }}
                                    onChange={(e) => {
                                        setValue("maxExperience", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger(["minExperience", "maxExperience"])
                                        triggerAutoDifficulty(getValues("minExperience"), e.target.value);
                                        if (e.target.value) {
                                        e.target.style.border = "";
                                    }  
                                    }}
                                />
                                {errors.maxExperience && <small className="text-danger">{errors.maxExperience.message}</small>}
                            </Col>

                            {/* Difficulty Level */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Difficulty Level <span className="text-danger">*</span>
                                </label>
                                <select
                                    {...register("difficultyLevel", { required: "This field is required" })}
                                    value={difficultyLevel}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setDifficultyLevel(value);
                                        // setValue("difficultyLevel", value);
                                        setValue("difficultyLevel", value, {
                                            shouldValidate: true,   // ✅ triggers validation
                                            shouldDirty: true
                                        });
                                        clearErrors("difficultyLevel")
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                         setSkillLevelConfError("")
                                        const defaults = difficultyToSkillDefaults[value?.toLowerCase()] || difficultyToSkillDefaults["intermediate"];
                                        setSkillConfig((prevSkills) =>
                                            prevSkills.map((skill) => {
                                                const rating = defaults.rating;
                                                const proficiency = defaults.proficiency;
                                                const ratio = getQuestionRatio(rating, 5);
                                                return { ...skill, rating, proficiency, ratio };
                                            })
                                        );
                                    }}
                                    className={`form-select ${errors.difficultyLevel ? "is-invalid" : ""}`}
                                >
                                    <option value="">Select Test Criticality</option>
                                    <option value="beginner">Beginner</option>
                                    <option value="intermediate">Intermediate</option>
                                    <option value="advanced">Advanced</option>
                                </select>
                                {errors.difficultyLevel && <small className="text-danger">{errors.difficultyLevel.message}</small>}
                            </Col>

                            {/* Close Date */}
                            {/* <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Close Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    {...register("closeDate", { required: "This field is required" })}
                                    className={`form-control ${errors.closeDate ? "is-invalid" : ""}`}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        setValue("closeDate", e.target.value);
                                        setOnchangeTrue(true);
                                        trigger("closeDate")
                                        setOnlySaveDone(false);
                                    }}
                                />
                                {errors.closeDate && <small className="text-danger">{errors.closeDate.message}</small>}
                            </Col> */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                Close Date <span className="text-danger">*</span>
                            </label>
                            <input
                                type="date"
                                {...register("closeDate", {
                                    required: "Close Date is required",
                                     validate: (value) => {
                                        const selectedDate = parseLocalDateOnly(value);
                                       const today = parseLocalDateOnly(getLocalTodayStr()); 
                                        return (selectedDate && selectedDate >= today) || "Close Date must be today or in the future";
                                    }
                                })}
                                className={`form-control ${errors.closeDate ? "is-invalid" : ""}`}
                                min={getLocalTodayStr()} 
                                onChange={(e) => {
                                    setValue("closeDate", e.target.value);
                                    setOnchangeTrue(true);
                                    trigger("closeDate");
                                    setOnlySaveDone(false);
                                    if (e.target.value) {
                                        e.target.style.border = "";
                                    }   
                                }}
                            />
                            {errors.closeDate && (
                                <div className="invalid-feedback d-block">
                                    {errors.closeDate.message}
                                </div>
                            )}
                        </Col>


                            {/* Category */}
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Category <span className="text-danger">*</span>
                                </label>
                                <select
                                    {...register("category", { required: "This field is required" })}
                                    value={selectedCategory}
                                    onChange={(e) => handleCategoryChange(e.target.value)}
                                    className="form-select"
                                >
                                    <option value="">Select Category</option>
                                    {testtypes.map((t) => (
                                        <option key={t.id} value={t.id}>
                                            {t.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.category && <small className="text-danger">{errors.category.message}</small>}
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Recruiters (For Job Handling)<span className="text-danger">*</span>
                                </label>
                                {/* <MultiSelect
                                value={selectedContacts}
                                    options={contacts}
                                    onChange={(e) => {
                                    setSelectedContacts(e.value);
                                    setValue("selectedContacts", e.value);
                                    setOnchangeTrue(true);
                                    setOnlySaveDone(false);
                                    clearErrors("selectedContacts");
                                    }}
                                    optionLabel="name" 
                                    optionValue="id"  
                                    placeholder="Select Interviewer"
                                    className="w-100"
                                    filter
                                    display="chip"
                                    loading={loadingContacts}

                                        tooltip={
                                            selectedContacts
                                                .map((id) => {
                                                    const c = contacts.find((c) => c.id === id);
                                                    return c?.name;
                                                })
                                                .join(", ")
                                        }
                                        tooltipOptions={{ position: "top" }}
                                    /> */}
                                        <MultiSelect
                value={selectedContacts}
                options={filteredContacts}
                onChange={handleChange}
                optionLabel="name"
                optionValue="id"
                placeholder="Select Recruiters"
                className="w-100"
                display="chip"
                loading={loadingContacts}

                // 🔥 Custom Filter Input
                filter
                filterTemplate={() => (
                    <input
                        type="text"
                        className="p-inputtext p-component w-100"
                        placeholder="Search..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                        appendTo="self"
                        // autoFocus
                        />
                    )}

                tooltip={
                    selectedContacts
                        .map((id) => {
                            const c = contacts.find((c) => c.id === id);
                            return c?.name;
                        })
                        .join(", ")
                }
                tooltipOptions={{ position: "top" }}
            />
                                {errors.selectedContacts && <small className="text-danger">{errors.selectedContacts.message}</small>}
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Shift Timings <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    placeholder="9AM-6PM"
                                    {...register("shift", {
                                    required: "Shift is required",
                                    pattern: {
                                        value: /^[a-zA-Z0-9\-:\s]+$/, // allows letters, numbers, dash, colon, spaces
                                        message: "Shift must contain only letters, numbers, dash, colon or spaces",
                                    },
                                    })}
                                    className={`form-control ${errors.shift ? "is-invalid" : ""}`}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        const cleanedValue = e.target.value.replace(/[^A-Za-z0-9\-:\s]/g, "");
                                        e.target.value = cleanedValue;
                                        setValue("shift", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("shift");
                                         if (e.target.value) {
                                        e.target.style.border = "";
                                    } 
                                    }}
                                />
                                {errors.shift && <small className="text-danger">{errors.shift.message}</small>}
                            </Col>
                            {/* <Col xxl={4} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    State <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter State"
                                    {...register("state", {
                                        required: "State is required",
                                    })}
                                    className={`form-control ${errors.state ? "is-invalid" : ""}`}
                                    onChange={(e) => {
                                        setValue("state", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("state");
                                    }}
                                />
                                {errors.state && (
                                    <small className="text-danger">{errors.state.message}</small>
                                )}
                            </Col> */}

                        <Col xxl={4} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                State <span className="text-danger">*</span>
                            </label>

                            {hasVgus ? (
                               <select
                                    value={selectedStateId}
                                    className={`form-control form-select ${errors.state ? "is-invalid" : ""}`}
                                    // {...register("state", { required: "State is required" })}
                                    onChange={(e) => {
                                        const stateId = e.target.value;
                                        setSelectedStateId(stateId);
                                        setValue("state", String(stateId), { 
                                            shouldValidate: true,
                                            shouldDirty: true 
                                        });
                                        fetchCities(stateId);
                                        setSelectedCityId("");
                                        setValue("location", "", { shouldValidate: true });
                                        setCities([]);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        clearErrors(["state", "location"]);
                                    }}
                                    >
                                <option value="">Select State</option>
                                {states.map((s) => (
                                    <option key={getLocationOptionId(s, "state")} value={getLocationOptionId(s, "state")}>
                                    {getLocationOptionName(s, "state")}
                                    </option>
                                ))}
                                </select>
                            ) : (
                            <input
                                type="text"
                                placeholder="Enter State"
                                {...register("state", {
                                required: "State is required",
                                pattern: {
                                    value: /^[a-zA-Z\s]+$/, // allows only letters and spaces
                                    message: "State must contain only letters",
                                },
                                })}
                                className={`form-control ${errors.state ? "is-invalid" : ""}`}
                                autoComplete="off"
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                    setValue("state", cleanedValue);
                                    setOnchangeTrue(true);
                                    setOnlySaveDone(false);
                                    trigger("state");
                                     if (e.target.value) {
                                        e.target.style.border = "";
                                    } 
                                }}
                            />
                            )}
                            {errors.state && (
                                <small className="text-danger">{errors.state.message}</small>
                            )}
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                City <span className="text-danger">*</span>
                            </label>
                            {hasVgus ? (
                            <select
                                value={selectedCityId}
                                className={`form-control form-select ${errors.location ? "is-invalid" : ""}`}
                                // {...register("location", { required: "City is required" })}
                                onChange={(e) => {
                                    const cityId = e.target.value;
                                    setSelectedCityId(cityId);
                                    setValue("location", String(cityId), { 
                                        shouldValidate: true,
                                        shouldDirty: true,
                                        shouldTouch: true
                                    });
                                    setOnchangeTrue(true);
                                    setOnlySaveDone(false);
                                    clearErrors("location");
                                }}
                            >
                                <option value="">Select City</option>
                                {cities.map((c) => (
                                    <option key={getLocationOptionId(c, "city")} value={getLocationOptionId(c, "city")}>
                                    {getLocationOptionName(c, "city")}
                                    </option>
                                ))}
                                </select>
                            ) : (
                                <input
                                    type="text"
                                    placeholder="Enter City"
                                    {...register("location", {
                                        required: "City  is required",
                                    })}
                                    className={`form-control ${errors.location ? "is-invalid" : ""}`}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        setValue("location", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("location");
                                         if (e.target.value) {
                                        e.target.style.border = "";
                                    } 
                                    }}
                                />
                            )}
                            {errors.location && (
                                <small className="text-danger">{errors.location.message}</small>
                            )}
                            </Col>
                            <Col xxl={2} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Work Type <span className="text-danger">*</span>
                                </label>
                                <select
                                    {...register("modeOfOperation", {
                                        required: "Mode of Operation is required",
                                    })}
                                    className={`form-select ${errors.modeOfOperation ? "is-invalid" : ""}`}
                                    value={getValues("modeOfOperation")}
                                    onChange={(e) => {
                                        setValue("modeOfOperation", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("modeOfOperation");
                                        if (e.target.value) {
                                        e.target.style.border = "";
                                    }  
                                    }}
                                >
                                    <option value="">Select Work Type</option>
                                    {modeOfOperationTypes.map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.modeOfOperation && (
                                    <small className="text-danger">{errors.modeOfOperation.message}</small>
                                )}
                            </Col>

                            <Col xxl={2} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Number of Openings <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    step="1"
                                    min="1"
                                    max="999"
                                    placeholder="Enter number of openings"
                                    autoComplete="off"
                                    {...register("noOfOpenings", {
                                        required: "Number of Openings is required",
                                        min: { value: 1, message: "Must be at least 1" },
                                        max: { value: 999, message: "Maximum 3 digits allowed" },
                                        valueAsNumber: true,
                                    })}
                                    className={`form-control ${errors.noOfOpenings ? "is-invalid" : ""}`}
                                    onKeyDown={(e) => {
                                        // Block e, +, -, .
                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                        e.preventDefault();
                                        }
                                    }}
                                    onInput={(e) => {
                                        if (e.target.value.length > 3) {
                                        e.target.value = e.target.value.slice(0, 3);
                                        }

                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                    }}
                                    onChange={(e) => {
                                        setValue("noOfOpenings", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                        trigger("noOfOpenings");
                                         if (e.target.value) {
                                        e.target.style.border = "";
                                    } 
                                      if (e.target.value.includes(".")) {
                                        e.target.value = Math.floor(e.target.value);
                                    }
                                    }}
                                />
                                {errors.noOfOpenings && (
                                    <small className="text-danger">{errors.noOfOpenings.message}</small>
                                )}
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                Required Education <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter required education"
                                autoComplete="off"
                                {...register("education_level", {
                                    required: "Required Education is required",
                                     pattern: {
                                        value: /^[a-zA-Z\s]+$/,
                                        message: "Special characters are not allowed",
                                        },
                                    validate: (value) => value.trim() !== "" || "Required Education cannot be empty",
                                })}
                                className={`form-control ${errors.education_level ? "is-invalid" : ""}`}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                    setValue("education_level", cleanedValue);
                                    setOnchangeTrue(true);
                                    setOnlySaveDone(false);
                                    trigger("education_level");
                                     if (e.target.value) {
                                        e.target.style.border = "";
                                    } 
                                }}
                            />
                            {errors.education_level && (
                                <small className="text-danger">{errors.education_level.message}</small>
                            )}
                        </Col>
                        
                         <Col xxl={2} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                Select Agent <span className="text-danger">*</span>
                            </label>
                            <Select
                                name="agent"
                                options={agentOptions}
                                id="AgentDropdown"
                                value={selectedAgent}
                                classNamePrefix="react-select"  
                                onChange={(option) => {
                                    setSelectedAgent(option);
                                    setValue("agent", option);
                                    setOnchangeTrue(true);
                                    setOnlySaveDone(false);
                                    clearErrors("agent");
                                    const element = document.querySelector("#AgentDropdown");
                                            if (element) {
                                                element.style.border = "";
                                            }
                                }}
                                onBlur={() => trigger("agent")}
                                placeholder={loadingAgents ? "Loading agents..." : "Select Agent"}
                                isClearable
                                isLoading={loadingAgents}
                            />
                            {errors.agent && (
                                <small className="text-danger">{errors.agent.message}</small>
                            )}
                        </Col>
                        <Col xxl={2} xl={4} lg={4} md={4}>
                        <label className="form-label fw-semibold mb-1">
                            Package/Budget
                        </label>

                        <input
                            type="text"
                            placeholder="Enter Package/Budget"
                            autoComplete="off"
                            
                            {...register("budget")} // ✅ no validation

                            className="form-control"

                            onChange={(e) => {
                            setValue("budget", e.target.value);
                            setOnchangeTrue(true);
                            setOnlySaveDone(false);
                            }}
                        />
                        </Col>
                        
                            <Col xxl={6} xl={4} lg={4} md={4}>
                            <label className="form-label fw-semibold mb-1">
                                Job Description <span className="text-danger">*</span>
                            </label>

                            <Controller
                                name="jdDescription"
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        const plainText = value
                                            ?.replace(/<[^>]*>/g, "")
                                            ?.replace(/&nbsp;/g, "")
                                            ?.trim();

                                        return plainText?.length > 0 || "Job Description is required";
                                    },
                                }}
                                render={({ field }) => (
                                    <div
                                            ref={jdDescriptions}
                                            className={`sun-editor-wrapper ${
                                                errors.jdDescription ? "sun-error" : ""
                                            }`}
                                            >
                                    <SunEditor
                                        setContents={field.value || ""}
                                        onChange={(content) => {
                                            field.onChange(content);
                                            setOnchangeTrue(true);
                                            setOnlySaveDone(false);
                                        }}
                                        setOptions={{
                                            height: 150,
                                             buttonList: [
                // default
                                            ['undo', 'redo'],
                                            ['font', 'fontSize', 'formatBlock'],
                                            ['paragraphStyle', 'blockquote'],
                                            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                            ['fontColor', 'hiliteColor', 'textStyle'],
                                            ['removeFormat'],
                                            ['outdent', 'indent'],
                                            ['align', 'horizontalRule', 'list', 'lineHeight'],
                                            ['table', 'link', 'image', 'video'],
                                            ['fullScreen', 'showBlocks', 'codeView'],
                                            ['preview'],
                                            ['save'],
                                            // responsive
                                            ['%1161', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                ['fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                                ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                            ]],
                                            ['%893', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                ['bold', 'underline', 'italic', 'strike'],
                                                [':t-Fonts-default.more_text', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                                ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                            ]],
                                            ['%855', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]],
                                            ['%563', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                [':e-List&Line-default.more_horizontal', 'align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]],
                                            ['%458', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
                                                [':e-List&Line-default.more_horizontal', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]]
                                        ]
                                        }}
                                        />
                                        </div>
                                    )}
                            />

                            {errors.jdDescription && (
                                <small className="text-danger">{errors.jdDescription.message}</small>
                            )}
                        </Col>

                          <Col xxl={6} xl={4} lg={4} md={4}>
                                <label className="form-label fw-semibold mb-1">
                                    Roles and Responsibilities <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="roles_responsibility"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            const plainText = value
                                                ?.replace(/<[^>]*>/g, "")
                                                ?.replace(/&nbsp;/g, "")
                                                ?.trim();

                                            return (
                                                plainText?.length > 0 ||
                                                "Roles and Responsibilities are required"
                                            );
                                        },
                                    }}
                                    render={({ field }) => (
                                        <div
                                            ref={roles_responsibilitys}
                                            className={`sun-editor-wrapper ${
                                                errors.roles_responsibility ? "sun-error" : ""
                                            }`}
                                            >
                                        <SunEditor
                                            setContents={field.value || ""}
                                            onChange={(content) => {
                                                field.onChange(content);
                                                setOnchangeTrue(true);
                                                setOnlySaveDone(false);
                                            }}
                                            setOptions={{
                                                height: 150,
                                                 buttonList: [
                                            // default
                                            ['undo', 'redo'],
                                            ['font', 'fontSize', 'formatBlock'],
                                            ['paragraphStyle', 'blockquote'],
                                            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                            ['fontColor', 'hiliteColor', 'textStyle'],
                                            ['removeFormat'],
                                            ['outdent', 'indent'],
                                            ['align', 'horizontalRule', 'list', 'lineHeight'],
                                            ['table', 'link', 'image', 'video'],
                                            ['fullScreen', 'showBlocks', 'codeView'],
                                            ['preview'],
                                            ['save'],
                                            // responsive
                                            ['%1161', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                ['fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                                ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                            ]],
                                            ['%893', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                ['bold', 'underline', 'italic', 'strike'],
                                                [':t-Fonts-default.more_text', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                                ['-right', ':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                            ]],
                                            ['%855', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]],
                                            ['%563', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle'],
                                                ['removeFormat'],
                                                ['outdent', 'indent'],
                                                [':e-List&Line-default.more_horizontal', 'align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]],
                                            ['%458', [
                                                ['undo', 'redo'],
                                                [':p-Formats-default.more_paragraph', 'font', 'fontSize', 'formatBlock', 'paragraphStyle', 'blockquote'],
                                                [':t-Fonts-default.more_text', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'fontColor', 'hiliteColor', 'textStyle', 'removeFormat'],
                                                [':e-List&Line-default.more_horizontal', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'lineHeight'],
                                                [':r-Table&Media-default.more_plus', 'table', 'link', 'image', 'video'],
                                                ['-right', 'save'],
                                                ['-right', ':i-Etc-default.more_vertical', 'fullScreen', 'showBlocks', 'codeView', 'preview'],
                                            ]]
                                        ]
                                            }}
                                        />
                                        </div>
                                    )}
                                    
                                />
                                {errors.roles_responsibility && (
                                    <small className="text-danger">
                                        {errors.roles_responsibility.message}
                                    </small>
                                )}
                            </Col>
                        </Row>
                        {console.log("selectedCategory",selectedCategory)}
                        {/* {selectedCategory && (
                            <div className="mt-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 style={{ fontWeight: 600 }}>Skill-Level Configuration *</h5>
                                    <button type="button" className="btn addBtn" onClick={handleAddSkill}><FaPlus /> Add Skill</button>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div style={{ display: "grid", gridTemplateColumns: "0.5fr repeat(6, 1fr)", gap: 12, alignItems: "center", marginBottom: 12, padding: 8 }}>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>S No.</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>Skill Name</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>Rating(1-10) & Proficiency</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>No. of Questions</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>Cutoff Score</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>Questions Ratio</div>
                                        <div style={{ fontWeight: 600, textAlign: "center" }}>Actions</div>
                                    </div>

                                    {skillConfig.map((skill, index) => {
                                        const { beginner, intermediate, advanced } = getQuestionRatio(skill.rating || 1, skill.questions || 5);
                                        return (
                                            <div key={index} style={{ display: "grid", gridTemplateColumns: "0.5fr repeat(6, 1fr)", gap: 12, alignItems: "center", marginBottom: 12, padding: 12, borderRadius: 6, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}>
                                                <div style={{ textAlign: "center" }}>{index + 1}</div>

                                                <div>
                                                    <InputText
                                                        value={skill.name}
                                                        title={skill.name}
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            const cleanedValue = newValue.replace(/[^a-zA-Z\s]/g, "");
                                                            const capitalizedValue = cleanedValue.charAt(0).toUpperCase() + cleanedValue.slice(1);
                                                            setOnchangeTrue(true);
                                                            setOnlySaveDone(false);
                                                            const updated = [...skillConfig];
                                                            updated[index].name = capitalizedValue;
                                                            setSkillConfig(updated);
                                                            if (skill_level_conferror && capitalizedValue.trim() !== "") {
                                                            setSkillLevelConfError("");
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            const trimmed = e.target.value.trim();
                                                            const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
                                                            const updated = [...skillConfig];
                                                            updated[index].name = capitalized;
                                                            setSkillConfig(updated);
                                                        }}
                                                        />
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                                                    <Slider value={skill.rating} min={1} max={10} step={1} onChange={(e) => { handleSkillRatingChange(index, e.value); setOnchangeTrue(true); setOnlySaveDone(false); }} style={{ width: 140 }} />
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        <strong style={{ color: skill.rating <= 3 ? "#1e88e5" : skill.rating <= 7 ? "#fbc02d" : "#43a047", minWidth: 24 }}>{skill.rating}</strong>
                                                        <span style={{ fontWeight: 500, color: skill.rating <= 3 ? "#1e88e5" : skill.rating <= 7 ? "#fbc02d" : "#43a047" }}>
                                                            {skill.rating <= 3 ? "Beginner" : skill.rating <= 7 ? "Intermediate" : "Advanced"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <InputNumber
                                                        value={skill.questions ?? 5}
                                                        onValueChange={(e) => handleSkillQuestionChange(index, e.value)}
                                                        onChange={(e) => handleSkillQuestionChange(index, e.value)}
                                                        showButtons
                                                        min={1}
                                                        className="w-50"
                                                    />
                                                </div>

                                                <div>
                                                    <InputNumber
                                                        value={skill.cutoff !== undefined ? skill.cutoff : (skill.questions ?? 5) / 2}
                                                        onValueChange={(e) => handleSkillCutoffChange(index, e.value)}
                                                        onChange={(e) => handleSkillCutoffChange(index, e.value)}
                                                        className="w-50"
                                                    />
                                                </div>

                                                <div style={{ textAlign: "center" }}>
                                                    <div>Beginner: {beginner} | Intermediate: {intermediate} | Advanced: {advanced}</div>
                                                </div>

                                                <div style={{ textAlign: "center" }}>
                                                    <Button icon="pi pi-trash" className="p-button-sm p-button-danger" onClick={() => handleDeleteSkill(index)} />
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {skill_level_conferror && <div className="p-error">{skill_level_conferror}</div>}
                                </div>
                            </div>
                        // )} */}
                         {/*old code  */}
                        {selectedCategory && (
                                <div className="mt-4">
                                    <div
                                        className="d-flex justify-content-between align-items-center mb-3 p-3"
                                        style={{
                                            background: "linear-gradient(135deg, #eef2ff 0%, #f5f8ff 100%)",
                                            borderRadius: 10,
                                            border: "1px solid #e0e7ff",
                                        }}
                                    >
                                        <div>
                                            <h5 style={{ fontWeight: 700, margin: 0, color: "#1e293b" }}>
                                                Skill-Level Configuration <span className="text-danger">*</span>
                                            </h5>
                                            <small className="text-muted">
                                                Configure rating, question count, and duration per skill. Duration auto-scales at 2 minutes per question.
                                            </small>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn addBtn"
                                            style={{ borderRadius: 8, fontWeight: 600 }}
                                            onClick={handleAddSkill}
                                        >
                                            <FaPlus className="me-1" /> Add Skill
                                        </button>
                                    </div>

                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "0.4fr 1.3fr 1.4fr 0.9fr 0.9fr 0.9fr 1.3fr 0.6fr",
                                                gap: 10,
                                                alignItems: "center",
                                                marginBottom: 8,
                                                padding: "10px 12px",
                                                background: "#f8fafc",
                                                borderRadius: 8,
                                                border: "1px solid #e2e8f0",
                                            }}
                                        >
                                            {["S No.", "Skill Name", "Rating & Proficiency", "Questions", "Duration", "Cutoff", "Questions Ratio", "Actions"].map((label) => (
                                                <div key={label} style={{ fontWeight: 700, textAlign: "center", fontSize: 12, color: "#475569", textTransform: "uppercase", letterSpacing: 0.3 }}>
                                                    {label}
                                                </div>
                                            ))}
                                        </div>

                                        {skillConfig.map((skill, index) => {
                                            const { beginner, intermediate, advanced } = getQuestionRatio(skill.rating || 1, skill.questions || 5);
                                            const durationMinutes = Math.round((skill.questions || 5) * 2);
                                            const proficiencyColor = skill.rating <= 3 ? "#1e88e5" : skill.rating <= 7 ? "#f59e0b" : "#16a34a";

                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "0.4fr 1.3fr 1.4fr 0.9fr 0.9fr 0.9fr 1.3fr 0.6fr",
                                                        gap: 10,
                                                        alignItems: "center",
                                                        marginBottom: 10,
                                                        padding: "14px 12px",
                                                        borderRadius: 10,
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #e2e8f0",
                                                        boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
                                                        transition: "box-shadow 0.15s ease",
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 4px 12px rgba(15,23,42,0.08)")}
                                                    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "0 1px 2px rgba(15,23,42,0.04)")}
                                                >
                                                    <div style={{ textAlign: "center", fontWeight: 600, color: "#64748b" }}>{index + 1}</div>

                                                    <div>
                                                        <InputText
                                                            value={skill.name}
                                                            title={skill.name}
                                                            autoComplete="off"
                                                            placeholder="Skill name"
                                                            onChange={(e) => {
                                                                const newValue = e.target.value;
                                                                const cleanedValue = newValue.replace(/[^a-zA-Z\s]/g, "");
                                                                const capitalizedValue = cleanedValue.charAt(0).toUpperCase() + cleanedValue.slice(1);
                                                                setOnchangeTrue(true);
                                                                setOnlySaveDone(false);
                                                                const updated = [...skillConfig];
                                                                updated[index].name = capitalizedValue;
                                                                setSkillConfig(updated);
                                                                if (skill_level_conferror && capitalizedValue.trim() !== "") {
                                                                    setSkillLevelConfError("");
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                const trimmed = e.target.value.trim();
                                                                const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
                                                                const updated = [...skillConfig];
                                                                updated[index].name = capitalized;
                                                                setSkillConfig(updated);
                                                            }}
                                                            style={{ width: "100%" }}
                                                        />
                                                    </div>

                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                                                        <Slider
                                                            value={skill.rating}
                                                            min={1}
                                                            max={10}
                                                            step={1}
                                                            onChange={(e) => {
                                                                handleSkillRatingChange(index, e.value);
                                                                setOnchangeTrue(true);
                                                                setOnlySaveDone(false);
                                                            }}
                                                            style={{ width: 140 }}
                                                        />
                                                        <span
                                                            style={{
                                                                fontSize: 12,
                                                                fontWeight: 700,
                                                                padding: "2px 10px",
                                                                borderRadius: 999,
                                                                color: "#fff",
                                                                background: proficiencyColor,
                                                            }}
                                                        >
                                                            {skill.rating} · {skill.rating <= 3 ? "Beginner" : skill.rating <= 7 ? "Intermediate" : "Advanced"}
                                                        </span>
                                                    </div>

                                                    <div>
                                                        <InputNumber
                                                            value={skill.questions ?? 5}
                                                            onValueChange={(e) => handleSkillQuestionChange(index, e.value)}
                                                            onChange={(e) => handleSkillQuestionChange(index, e.value)}
                                                            showButtons
                                                            min={1}
                                                            className="w-100"
                                                            inputStyle={{ textAlign: "center" }}
                                                        />
                                                    </div>

                                                    <div style={{ textAlign: "center" }}>
                                                        <div
                                                            style={{
                                                                fontWeight: 700,
                                                                fontSize: 13,
                                                                color: "#334155",
                                                                background: "#f1f5f9",
                                                                borderRadius: 8,
                                                                padding: "6px 8px",
                                                            }}
                                                            title={skill.duration || minutesToDuration(durationMinutes)}
                                                        >
                                                            ⏱ {durationMinutes} min
                                                        </div>
                                                        <small className="text-muted" style={{ fontSize: 10 }}>
                                                            {skill.duration || minutesToDuration(durationMinutes)}
                                                        </small>
                                                    </div>

                                                    <div>
                                                        <InputNumber
                                                            value={skill.cutoff !== undefined ? skill.cutoff : (skill.questions ?? 5) / 2}
                                                            onValueChange={(e) => handleSkillCutoffChange(index, e.value)}
                                                            onChange={(e) => handleSkillCutoffChange(index, e.value)}
                                                            className="w-100"
                                                            inputStyle={{ textAlign: "center" }}
                                                        />
                                                    </div>

                                                    <div style={{ textAlign: "center", fontSize: 12 }}>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                                            <span style={{ color: "#1e88e5" }}>Beginner: <strong>{beginner}</strong></span>
                                                            <span style={{ color: "#f59e0b" }}>Intermediate: <strong>{intermediate}</strong></span>
                                                            <span style={{ color: "#16a34a" }}>Advanced: <strong>{advanced}</strong></span>
                                                        </div>
                                                    </div>

                                                    <div style={{ textAlign: "center" }}>
                                                        <Button
                                                            icon="pi pi-trash"
                                                            className="p-button-sm p-button-danger p-button-rounded"
                                                            onClick={() => handleDeleteSkill(index)}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {skill_level_conferror && <div className="p-error mt-1">{skill_level_conferror}</div>}

                                        {skillConfig.length > 0 && (
                                            <div
                                                className="d-flex justify-content-end align-items-center gap-2 mt-2 p-2"
                                                style={{ fontSize: 13, color: "#475569" }}
                                            >
                                                <strong>Total Duration :</strong>
                                                <span
                                                    style={{
                                                        background: "#eef2ff",
                                                        border: "1px solid #c7d2fe",
                                                        borderRadius: 999,
                                                        padding: "4px 12px",
                                                        fontWeight: 700,
                                                        color: "#4338ca",
                                                    }}
                                                >
                                                    ⏱ {skillConfig.reduce((sum, s) => sum + (Number(s.questions) || 0), 0) * 2} min
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                        {/* Sections table */}
                        <div className="p-3">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h3 style={{ color: "#182286", fontWeight: "bold" }}>{headingText}</h3>
                                </div>
                            </div>

                            {selectedCategory && (
                                <div className="table-responsive" id="SkillLevelConfiguration_TableView">
                                    <DataTable
                                        data={sectionData}
                                        columns={sectionsColumns}
                                        noHeader={false}
                                        dense
                                        pagination={false}
                                        persistTableHead
                                        highlightOnHover
                                    />
                                </div>
                            )}

                            {TimesettingError ? <small className="text-danger">Please select at least one round</small> : null}
                        </div>

                        {/* Buttons */}
                        {/* <div className="d-flex justify-content-center gap-3 mt-3  mb-5">
                            <button className="btn blueBtn" onClick={navigateBackToJobOrders}>Cancel</button>
                             {isEditMode && (
                                <button
                                    type="button"
                                    className="btn addBtn mt-2"
                                    style={{ height: "40px" }}
                                    onClick={handlePreviewQuestions}
                                    disabled={isGenerating}
                                >
                                    {isGenerating ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Generating...
                                        </>
                                    ) : "Generate Questions"}
                                </button>
                            )}
{/*  */}
                            {/* <button className="btn addBtn mt-2" style={{ height: "40px" }} type="submit" >{id ? "Update Job Order" : "Finalize Job Order"}</button> */}
                            {/* <button type="submit" className="btn addBtn mt-2"   style={{ height: "40px" }}  disabled={isSubmittingJob}>
                                {isSubmittingJob ? (
                                    <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                        style={{ width: "1rem", height: "1rem" }}
                                    ></span>
                                    {id ? "Updating..." : "Finalizing..."}
                                    </>
                                ) : (
                                    <>
                                    {id ? "Update Job Order" : "Finalize Job Order"}
                                    </>
                                )}
                            </button> */}
                             {/* {!isEditMode && (
                                <button
                                    type="submit"
                                    className="btn addBtn mt-2"
                                    style={{ height: "40px" }}
                                    disabled={isSubmittingJob}
                                >
                                    {isSubmittingJob ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Finalizing...
                                        </>
                                    ) : "Finalize Job Order"}
                                </button>
                            )} */}

                        {/* </div>  */}

                       <div className="my-3">
                            <div className="row">
                                <div className="col-3"></div>
                                <div className="col-6 d-flex justify-content-center">
                                    {/* <div className="card-body text-center">
                                        <p className="fw-semibold mb-2">
                                            Do you want to post this job on your website?
                                        </p>
                                        <div className="d-flex justify-content-center gap-3">
                                            {[
                                                { id: "yes", label: "Yes", value: true },
                                                { id: "no", label: "No", value: false },
                                            ].map((portal) => (
                                                <div key={portal.id} className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="jobPortal"
                                                        id={portal.id}
                                                        value={portal.value}
                                                        checked={postToWebsite === portal.value}
                                                        onChange={() => setPostToWebsite(portal.value)}
                                                        // disabled={isPostedToWebsite}
                                                    />
                                                    <label className="form-check-label" htmlFor={portal.id}>
                                                        {portal.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div> */}
                                    <div className="card-body text-center">
                                        <p className="fw-semibold mb-2">
                                            Do you want to post this job on your website?
                                        </p>
                                        <div className="d-flex justify-content-center gap-3">
                                            {[
                                                { id: "yes", label: "Yes", value: true },
                                                { id: "no", label: "No", value: false },
                                            ].map((portal) => (
                                                <div key={portal.id} className="form-check">
                                                    <input
                                                        type="radio"
                                                        className="form-check-input"
                                                        name="jobPortal"
                                                        id={portal.id}
                                                        value={portal.value}
                                                        checked={postToWebsite === portal.value}
                                                        onChange={() => {
                                                            if (portal.value === true && isVitelGlobalCompany) {
                                                                setShowWebsiteDomainModal(true);
                                                            } else {
                                                                setPostToWebsite(portal.value);
                                                                if (portal.value === false) {
                                                                    setSelectedWebsiteDomain("vitelglobal.com");
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor={portal.id}>
                                                        {portal.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Show selected domain */}
                                        {postToWebsite && isVitelGlobalCompany && (
                                            <div className="mt-3 text-success fw-bold">
                                                {isPostedToWebsite || jobData?.post_to_website ? "Posted to" : "Posting to"}:{" "}
                                                <span className="text-primary">
                                                    {getPostedWebsiteDomain()}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                   <div className="card-body text-center d-none">
                                <p className="fw-semibold mb-2">
                                    Do you want to post this job on your LinkedIn?
                                </p>
                                <div className="d-flex justify-content-center gap-3">
                                    {[
                                    { id: "yes", label: "Yes", value: true },
                                    { id: "no", label: "No", value: false },
                                    ].map((portal) => (
                                    <div key={portal.id} className="form-check">
                                        <input
                                        type="radio"
                                        className="form-check-input"
                                        name="linkedinPortal"
                                        id={portal.id}
                                        value={portal.value}
                                        checked={postToLinkedIn === portal.value}
                                        onChange={() => {
                                             setPostToLinkedIn(portal.value);
                                            if (portal.value) {
                                            fetchLinkedInOrgs();
                                            setShowLinkedInModal(true);
                                            } else {
                                            // setPostToLinkedIn(portal.value);
                                            setSelectedLinkedInOrg(null);
                                            }
                                        }}
                                        disabled={jobData?.post_to_linkedin}
                                        />
                                        <label className="form-check-label" htmlFor={portal.id}>
                                        {portal.label}
                                        </label>
                                    </div>
                                    ))}
                                </div>
                                </div>


                                </div>
                                
                            </div>
                            <div className="card border-0">
                                
                                
                            </div>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-2 mb-5">
                                <button className="btn blueBtn" onClick={navigateBackToJobOrders}>Cancel</button>
                                {/* Removing In Edit JOb */}
                                {isEditMode && (
                                    <button
                                        type="button"
                                        className="btn addBtn mt-2"
                                        style={{ height: "40px" }}
                                        onClick={handlePreviewQuestions}
                                        disabled={isGenerating}
                                    >
                                        {isGenerating ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Generating...
                                            </>
                                        ) : "Generate Questions"}
                                    </button>
                                )}
                                {!isEditMode && (
                                    <button
                                        type="button"
                                        className="btn addBtn mt-2"
                                        style={{ height: "40px" }}
                                        onClick={handlePreviewQuestions}
                                        // disabled={isGenerating}
                                        disabled={
                                            isGenerating 
                                            // skillConfig.some(skill => !skill.name?.trim()) || // Add this line
                                            // skillConfig.length === 0
                                        }
                                    >
                                        {isGenerating ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Generating...
                                            </>
                                        ) : "Generate Questions"}
                                    </button>
                                    
                                )}
                                {/* <button
                                    type="button"
                                    className="btn blueBtn mt-2"
                                    style={{ height: "40px" }}
                                    onClick={() => setShowReviewModal(true)}
                                >
                                    Review Job Order
                                </button> */}
                            </div>

                        </fieldset>
                    </form>
                    </TabPanel>
                    <TabPanel header="Screening Agent" id="ScreeningConfigTab" >
                        <div className="row mb-3">
                        <Col xxl={2} xl={6} lg={6} md={12}>
                            <label className="form-label fw-semibold mb-1">
                                Automate Talent Scan
                            </label>
                            <div className="d-flex align-items-center mt-2">
                                <div
                                    className="form-check form-switch"
                                    style={{ paddingLeft: "2.5rem" }}
                                >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="automateTalentScan"
                                        checked={automateTalentScan}
                                        onChange={(e) => {
                                            setAutomateTalentScan(e.target.checked);
                                            setOnchangeTrue(true);
                                            setOnlySaveDone(false);
                                        }}
                                        style={{
                                            width: "3rem",
                                            height: "1.5rem",
                                            cursor: "pointer",
                                        }}
                                    />
                                    <label
                                        className="form-check-label ms-2 mt-1"
                                        htmlFor="automateTalentScan"
                                        style={{
                                            fontWeight: 500,
                                            color: automateTalentScan
                                                ? "#198754"
                                                : "#6c757d",
                                        }}
                                    >
                                        {automateTalentScan ? "Yes" : "No"}
                                    </label>
                                </div>
                            </div>
                        </Col>

                        {automateTalentScan && (
                            <Col xxl={2} xl={6} lg={6} md={12}>
                                <label className="form-label fw-semibold mb-1">
                                    Screening Percentage
                                </label>
                                <input
                                    type="number"
                                    step="0.1"
                                    min="0"
                                    max="100"
                                    placeholder="e.g. 75.5"
                                    autoComplete="off"
                                    {...register("screening_percentage")}
                                    className="form-control"
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onInput={(e) => {
                                        const val = parseFloat(e.target.value);

                                        if (!isNaN(val) && val > 100) {
                                            e.target.value = "100";
                                        }
                                    }}
                                    onChange={(e) => {
                                        setValue("screening_percentage", e.target.value);
                                        setOnchangeTrue(true);
                                        setOnlySaveDone(false);
                                    }}
                                />
                            </Col>)}
                                    <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                                    <TabPanel>
                                        <h4 style={{ textDecoration: "underline" }}>Screening Call Questions</h4>
                                        <div className="row">
                                        <div className="col-12 col-sm-6">
                                            {hasQuestionContent(screeningQuestions) ? (
                                            Object.entries(screeningQuestions)
                                            .filter(([, questions]) => hasQuestionContent(questions))
                                            .map(([category, questions]) => (
                                            <div
                                                key={category}
                                                className="p-2 mb-2"
                                                style={{ border: "1px solid #eee", borderRadius: 6 }}
                                            >
                                                <h6 className="text-capitalize">{category.replace(/_/g, " ")} ({questions.length})</h6>

                                                {questions.map((question, index) => (
                                                <div key={index} className="d-flex gap-2 align-items-center mb-2">
                                                    <textarea
                                                    rows={2}
                                                    value={question}
                                                    title={question}
                                                    onChange={(e) =>
                                                        canAddQuestions || !isEditMode
                                                        ? handleEditScreeningQuestion(category, index, e.target.value)
                                                        : null
                                                    }
                                                    className="w-100 form-control"
                                                    // disabled={canViewQuestions && !canAddQuestions}
                                                    />

                                                    {(canDeleteQuestions || !isEditMode) && (
                                                    <Button
                                                        icon="pi pi-trash"
                                                        className="rounded bg-danger text-white"
                                                        onClick={() => {
                                                        Swal.fire({
                                                            title: "Are you sure?",
                                                            text: "Do you really want to delete this screening question?",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonText: "Yes, delete it!",
                                                            cancelButtonText: "Cancel",
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                            handleRemoveScreeningQuestion(category, index);

                                                            Swal.fire({
                                                                title: "Deleted!",
                                                                text: "Screening question deleted successfully.",
                                                                icon: "success",
                                                                timer: 1500,
                                                                showConfirmButton: false,
                                                            });
                                                            }
                                                        });
                                                        }}
                                                    />
                                                    )}
                                                </div>
                                                ))}

                                                {(canAddQuestions || !isEditMode) && (
                                                <Button
                                                    label="Add Question"
                                                    icon="pi pi-plus"
                                                    className="blueBtn"
                                                    onClick={() => handleAddScreeningQuestion(category)}
                                                />
                                                )}
                                            </div>
                                            ))
                                            ) : (
                                                <div className="text-muted py-3">
                                                    No screening questions generated yet.
                                                </div>
                                            )}
                                        </div>
                                        </div>
                                    </TabPanel>
                                    </TabView>

                                    <div className="d-flex justify-content-center mb-5">
                                    <Button
                                        label="Back"
                                        icon="pi pi-arrow-left"
                                        className="btn blueBtn"
                                        onClick={() => setMainTab(0)}
                                    />
                                    <Button
                                        label="Save and Continue"
                                        icon="pi pi-arrow-right"
                                        className="btn addBtn mt-2"
                                        style={{ height: "40px" }}
                                        onClick={async () => {
                                        setMainTab(2);
                                        setOnchangeTrue(true);
                                        }}
                                        disabled={isSaving || isGenerating || isJobReadOnly}
                                    />
                                    {hasQuestionContent(screeningQuestions) && (
                                        <>
                                            <Button
                                                label="Download Screening Questions"
                                                icon="pi pi-download"
                                                className="blueBtn"
                                                title="Download screening questions as Word document"
                                                onClick={() =>
                                                    downloadScreeningDocx({
                                                        currentScreeningQuestions: screeningQuestions,
                                                        previousScreeningQuestions: {},
                                                        jobTitle: getValues("job_title") || "Job",
                                                    })
                                                }
                                            />
                                            <Button
                                                label="View All Screening Questions"
                                                icon="pi pi-eye"
                                                className="blueBtn"
                                                onClick={() => setShowAllScreeningModal(true)}
                                            />
                                        </>
                                    )}
                                        {isEditMode && hasQuestionContent(screeningQuestions) && hasQuestionContent(previousScreeningQuestions) && (
                                            <>
                                                <Button
                                                    label="View Previous Screening Questions"
                                                    icon="pi pi-history"
                                                    className="blueBtn"
                                                    onClick={() => setPreviousScreeningModal(true)}
                                                />

                                                <Button
                                                    label="Download All Screening (Current + Previous)"
                                                    icon="pi pi-download"
                                                    className="btn blueBtn"
                                                    // style={{ background: "#fd7e14", border: "none", color: "#fff" }}
                                                    onClick={() =>
                                                        downloadScreeningDocx({
                                                            currentScreeningQuestions: screeningQuestions,
                                                            previousScreeningQuestions,
                                                            jobTitle: getValues("job_title") || "Job",
                                                        })
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                    </div>
                            </TabPanel>

                {/* MAIN TAB 1 */}
                <TabPanel header="Talent Scan Agent" id="SkillsAndQuestionsBlock" >
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <h5 style={{ fontWeight: "bold", color: "#f47f22" }}>Section-wise Manual Questions</h5>

                          {Array.isArray(sectionData) && sectionData.length > 0 ? (
                            sectionData
                                .filter((section) => section.checked)
                                .map((section, idx) => (
                                <Accordion key={section.id || section.name || idx} activeIndex={[]}>
                                    <AccordionTab  header={`${section.name} (${
                                            (manualQuestions[section.name]?.questions?.beginner?.length || 0) +
                                            (manualQuestions[section.name]?.questions?.intermediate?.length || 0) +
                                            (manualQuestions[section.name]?.questions?.advanced?.length || 0)
                                        })`} className="border border-light mb-2">
                                    {["beginner", "intermediate", "advanced"].map((level) => (
                                        <Accordion key={level} activeIndex={[]} className=" shadow-sm mb-3">
                                        <AccordionTab header={`${level.charAt(0).toUpperCase() + level.slice(1)} (${
                                                    manualQuestions[section.name]?.questions?.[level]?.length || 0
                                                })`}>
                                            {(manualQuestions[section.name]?.questions?.[level] || []).map((question, qIdx) => (
                                                <div key={qIdx} className="mb-2">
                                                    {canViewQuestions || !isEditMode  ? (
                                                        <div className="d-flex gap-2 align-items-center vertical-align-start">
                                                            {/* <InputText */}
                                                            <textarea rows={2}
                                                            value={question}
                                                            title={question}
                                                            // disabled={canViewQuestions}
                                                            onChange={(e) => {
                                                                handleManualQuestionChange(section.name, level, qIdx, e.target.value)}}
                                                            className="w-100 form-control"
                                                            />
                                                            <div>
                                                               {(canDeleteQuestions || !isEditMode) && (
                                                                        <Button
                                                                            icon="pi pi-trash"
                                                                            className="rounded bg-danger text-white"
                                                                            onClick={() => {
                                                                            Swal.fire({
                                                                                title: "Are you sure?",
                                                                                text: "Do you really want to delete this question?",
                                                                                icon: "warning",
                                                                                showCancelButton: true,
                                                                                confirmButtonText: "Yes, delete it!",
                                                                                cancelButtonText: "Cancel",
                                                                            }).then((result) => {
                                                                                if (result.isConfirmed) {
                                                                                handleRemoveManualQuestion(section.name, level, qIdx);

                                                                                Swal.fire({
                                                                                    title: "Deleted!",
                                                                                    text: "Question deleted successfully.",
                                                                                    icon: "success",
                                                                                    timer: 1500,
                                                                                    showConfirmButton: false,
                                                                                });
                                                                                }
                                                                            });
                                                                            }}
                                                                        />
                                                                        )}

                                                            </div>
                                                        </div>)
                                                    :""}
                                                </div>
                                            ))}
                                            {(canAddQuestions|| !isEditMode) && (
                                            <Button
                                            label="Add Question"
                                            icon="pi pi-plus"
                                            onClick={() => handleAddManualQuestion(section.name, level)}
                                            className="blueBtn"
                                            />)}
                                            {(canAddQuestions|| !isEditMode) && (
                                             <Button
                                            label="Suggest With AI"
                                            icon="pi pi-plus"
                                            onClick={() => {
                                                handleSuggestWithAI(section.name, level)}}
                                            className="blueBtn"
                                            />)}
                                        </AccordionTab>
                                        </Accordion>
                                    ))}
                                    </AccordionTab>
                                </Accordion>
                                ))
                            ) : (
                            <div>No selected sections available for this category.</div>
                            )}

                        </div>

                        <div className="col-12 col-md-6">
                            <h5 style={{ fontWeight: "bold", color: "#f47f22" }}>Generated Questions</h5>

                            {Object.keys(generatedQuestions).length > 0 ? (
                                Object.entries(generatedQuestions).map(([skill, levels], idx) => (
                                    <Accordion key={skill || idx} activeIndex={[]}>
                                        <AccordionTab
                                            header={`${skill.charAt(0).toUpperCase() + skill.slice(1)} (${
                                                (levels.beginner?.length || 0) +
                                                (levels.intermediate?.length || 0) +
                                                (levels.advanced?.length || 0)
                                            })`}
                                            className="shadow-sm mb-2"
                                            > 
                                            {["beginner", "intermediate", "advanced"].map((level) => (
                                                <Accordion key={level} activeIndex={[]} className="shadow-sm mb-3">
                                                    <AccordionTab  header={`${level.charAt(0).toUpperCase() + level.slice(1)} (${
                                                                levels[level]?.length || 0
                                                            })`}>
                                                        {(levels[level] || []).map((qObj, qIdx) => (
                                                           <div key={qIdx}>
                                                                {canViewQuestions || !isEditMode ? (
                                                                    <div className="d-flex gap-2 align-items-center mb-2">
                                                                    {/* <InputText  */}
                                                                    <textarea rows={2}
                                                                        value={qObj.text} 
                                                                        // disabled={canViewQuestions}
                                                                        title={qObj.text}
                                                                        onChange={(e) => handleGeneratedQuestionChange(skill, level, qIdx, e.target.value)} 
                                                                        className="w-100 form-control" 
                                                                    />
                                                                    {/* {(canDeleteQuestions || !isEditMode) && (
                                                                        <Button 
                                                                        icon="pi pi-trash" 
                                                                        className="rounded bg-danger text-white" 
                                                                        onClick={() => handleRemoveGeneratedQuestion(skill, level, qIdx)} 
                                                                        />
                                                                    )} */}
                                                                    {(canDeleteQuestions || !isEditMode) && (
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="rounded bg-danger text-white"
                                                                    onClick={() => {
                                                                    Swal.fire({
                                                                        title: "Are you sure?",
                                                                        text: "Do you really want to delete this question?",
                                                                        icon: "warning",
                                                                        showCancelButton: true,
                                                                        confirmButtonText: "Yes, delete it!",
                                                                        cancelButtonText: "Cancel",
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                        handleRemoveGeneratedQuestion(skill, level, qIdx);

                                                                        Swal.fire({
                                                                            title: "Deleted!",
                                                                            text: "Question deleted successfully.",
                                                                            icon: "success",
                                                                            timer: 1500,
                                                                            showConfirmButton: false,
                                                                        });
                                                                        }
                                                                    });
                                                                    }}
                                                                />
                                                                )}
                                                                    </div>
                                                                ) : ""}
                                                                </div>

                                                        ))}
                                                        {(canAddQuestions || !isEditMode) && (<Button label="Add Question" icon="pi pi-plus" className="blueBtn" onClick={() => handleAddGeneratedQuestion(skill, level)} />)}
                                                        {(canAddQuestions || !isEditMode) && (<Button label="Suggest With AI" icon="pi pi-plus" className="blueBtn" onClick={() => handleSuggestWithAIGenerated(skill, level)} />)}
                                                    </AccordionTab>
                                                </Accordion>
                                            ))}
                                        </AccordionTab>
                                    </Accordion>
                                ))
                            ) : (
                                <div>No generated questions yet.</div>
                            )}
                        </div>

                        <div className="d-flex justify-content-center gap-2 mt-3">
                            <Button label="Back" icon="pi pi-arrow-left" className="btn blueBtn"  onClick={() => {
                                console.log("Back button clicked, setting mainTab to 0");
                                setMainTab(1);
                            }} />
                            {/* <Button label="Save and Continue" icon="pi pi-arrow-right" className="btn addBtn mt-2" style={{ height: "40px" }} onClick={async () => { setMainTab(2); setOnchangeTrue(true); }} disabled={isSaving || isGenerating} /> */}
                        <Button
                            label="Save and Continue"
                            icon="pi pi-arrow-right"
                            className="btn addBtn mt-2"
                            style={{ height: "40px" }}
                            onClick={async () => {
                                if (!questionsGenerated && !isEditMode) {
                                    toastRef.current.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'Please generate questions first',
                                        life: 3000
                                    });
                                    return;
                                }
                                setMainTab(3);
                                setOnchangeTrue(true);
                            }}
                            disabled={isSaving || isGenerating || isJobReadOnly}
                        />
                          <Button
                            label="Check All Questions"
                            icon="pi pi-eye"
                            className="blueBtn"
                            onClick={() => setShowAllQuestionsModal(true)}
                        />
                        <Button
                        label="Download Questions"
                        icon="pi pi-download"
                        className="blueBtn"
                        title="Download current questions as Word document"
                        onClick={() =>
                            downloadQuestionsDocx({
                                currentGeneratedQuestions: generatedQuestions,
                                currentManualQuestions: manualQuestions,
                                sectionData,
                                previousGeneratedQuestions: {},
                                previousManualQuestions: {},
                                jobTitle: getValues("job_title") || "Job",
                            })
                        }
                    />
                       {(hasQuestionContent(previousGeneratedQuestions) || hasQuestionContent(previousManualQuestions)) && (
                                <>
                                    <Button
                                        label="View Previous Questions"
                                        icon="pi pi-history"
                                        className="blueBtn"
                                        onClick={() => setPreviousQuestionsModal(true)}
                                    />
                                    {/* ✅ NEW: Download All Questions (current + previous) */}
                                    <Button
                                        label="Download All (Current + Previous)"
                                        icon="pi pi-download"
                                        className="btn blueBtn"
                                        title="Download current AND previous questions as Word document"
                                        // style={{ background: "#fd7e14", border: "none", color: "#fff" }}
                                        onClick={() =>
                                            downloadQuestionsDocx({
                                                currentGeneratedQuestions: generatedQuestions,
                                                currentManualQuestions: manualQuestions,
                                                sectionData,
                                                previousGeneratedQuestions,
                                                previousManualQuestions,
                                                jobTitle: getValues("job_title") || "Job",
                                            })
                                        }
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    </TabPanel>

               {/* <TabPanel header="Screening Configuration">
                    <div id="ScreeningConfigTab">
                        <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                        <TabPanel>
                            <h4  style={{ textDecoration: "underline"}}>Screening Call Questions</h4>
                            <div className="row">
                            <div className="col-12 col-sm-6">
                                {Object.keys(screeningQuestions).length > 0 ? (
                                Object.entries(screeningQuestions).map(([category, questions]) => (
                                    <div key={category} className="p-2 mb-2" style={{ border: "1px solid #eee", borderRadius: 6 }}>
                                    <h6>{category.replace(/_/g, ' ')}</h6>
                                    {questions.map((question, index) => (
                                        <div key={index} className="d-flex gap-2 align-items-center mb-2">
                                        <InputText
                                            value={question}
                                            onChange={(e) => {
                                            // Handle question edit if needed
                                            }}
                                            className="w-100"
                                        />
                                        <Button
                                            icon="pi pi-trash"
                                            className="p-button-danger p-button-sm"
                                            onClick={() => handleRemoveScreeningQuestion(category, index)}
                                        />
                                        </div>
                                    ))}
                                    </div>
                                ))
                                ) : (
                                <div>No screening questions generated yet.</div>
                                )}
                            </div>
                            </div>
                        </TabPanel>
                        </TabView>
                        <div className="d-flex justify-content-center mb-5">
                        <Button
                            label="Back"
                            icon="pi pi-arrow-left"
                            className="btn blueBtn"
                            onClick={() => {
                            setMainTab(1);
                            }}
                        />
                        <Button
                            label="Save and Continue"
                            icon="pi pi-arrow-right"
                            className="btn addBtn mt-2"
                            style={{ height: "40px" }}
                            onClick={async () => {
                            setMainTab(3);
                            setOnchangeTrue(true);
                            }}
                            disabled={isSaving || isGenerating}
                        />
                        </div>
                    </div>
                    </TabPanel> */}
                    {/* <TabPanel header="Screening Configuration">
                            <div id="ScreeningConfigTab">
                                <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                                <TabPanel>
                                    <h4 style={{ textDecoration: "underline" }}>Screening Call Questions</h4>
                                    <div className="row">
                                    <div className="col-12 col-sm-6">
                                        {Object.entries(screeningQuestions).map(([category, questions]) => (
                                        <div key={category} className="p-2 mb-2" style={{ border: "1px solid #eee", borderRadius: 6 }}>
                                            <h6 className="text-capitalize">{category.replace(/_/g, ' ')}</h6>
                                            {questions.map((question, index) => (
                                            <div key={index} className="d-flex gap-2 align-items-center mb-2">
                                                {/* <InputText */}
                                                {/* <textarea rows={2}
                                                value={question}
                                                title={question}
                                                onChange={(e) => handleEditScreeningQuestion(category, index, e.target.value)}
                                                className="w-100 form-control"
                                                />
                                               <Button
                                                icon="pi pi-trash"
                                                className="rounded bg-danger text-white"
                                                onClick={() => {
                                                    Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "Do you really want to delete this screening question?",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonText: "Yes, delete it!",
                                                    cancelButtonText: "Cancel",
                                                    }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        handleRemoveScreeningQuestion(category, index);

                                                        Swal.fire({
                                                        title: "Deleted!",
                                                        text: "Screening question deleted successfully.",
                                                        icon: "success",
                                                        timer: 1500,
                                                        showConfirmButton: false,
                                                        });
                                                    }
                                                    });
                                                }}
                                                />
                                            </div>
                                            ))}
                                            <Button
                                            label="Add Question"
                                            icon="pi pi-plus"
                                            className="blueBtn"
                                            onClick={() => handleAddScreeningQuestion(category)}
                                            />
                                        </div>
                                        ))}
                                    </div>
                                    </div>
                                </TabPanel>
                                </TabView>
                                <div className="d-flex justify-content-center mb-5">
                                <Button
                                    label="Back"
                                    icon="pi pi-arrow-left"
                                    className="btn blueBtn"
                                    onClick={() => setMainTab(1)}
                                />
                                <Button
                                    label="Save and Continue"
                                    icon="pi pi-arrow-right"
                                    className="btn addBtn mt-2"
                                    style={{ height: "40px" }}
                                    onClick={async () => {
                                    setMainTab(3);
                                    setOnchangeTrue(true);
                                    }}
                                    disabled={isSaving || isGenerating}
                                />
                                </div>
                            </div>
                            </TabPanel> */} 
                            

                           

                <TabPanel header="Access Privileges" >
                    <div id="ScreeningConfigTab">
                        <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                        <TabPanel id="access-privileges-tab">
                            <div className="row">
                                <div className="xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                    <h4 style={{ textDecoration: "underline" }}>Access Privileges</h4>
                                </div>
                                <div className="xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div style={{ width: "220px" }} className="d-flex justify-content-end ms-auto mb-1">
                                        <InputGroup>
                                            {/* SEARCH INPUT */}
                                            <Input
                                            placeholder="Search Employees..."
                                            value={userSearchText}
                                            className=""
                                            disabled={isJobReadOnly}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setUserSearchText(value);

                                                // If search becomes empty → call API
                                                if (value.trim() === "") {
                                                fetchUsers("");  
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                fetchUsers(userSearchText);
                                                }
                                            }}
                                            />

                                            {/* CLEAR ICON (X) */}
                                            {userSearchText && (
                                            <InputGroupText
                                            className=""
                                                style={{ cursor: "pointer", background: "transparent", borderLeft: "none" }}
                                                disabled={isJobReadOnly}
                                                onClick={() => {
                                                setUserSearchText("");
                                                fetchUsers(""); // call API again with empty search
                                                }}
                                            >
                                                <FaTimes style={{ fontSize: "14px", color: "#6c757d" }} />
                                            </InputGroupText>
                                            )}

                                            {/* SEARCH ICON */}
                                            <Button
                                            className="btn searchIconBtn import-res-btn"
                                            onClick={() => fetchUsers(userSearchText)}
                                            disabled={isJobReadOnly}
                                            >
                                            <i className="fa fa-search" />
                                            </Button>
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                            <div className="card">
                               {isUsersLoading ? (
                                <div className="text-center py-2">
                                    <ProgressSpinner/>
                                </div>):(
                                    <div id="AccessPrivileges_UserTable">
                                <DataTable
                                    columns={columns}
                                    data={users}
                                    pagination
                                    paginationPerPage={10}
                                    fixedHeader
                                    fixedHeaderScrollHeight="500px"
                                    paginationComponentOptions={paginationOptions}
                                />
                                </div>
                                )}
                                <div className="d-flex justify-content-end mt-3">
                                {/* <Button label="Save Job Order" className="p-button-primary" /> */}
                                </div>
                            </div>
                            {/* <div className="d-flex justify-content-center mt-3">
                                {isEditMode && (
                                <Button
                                    label={isSaving ? "Updating..." : "Update Job Order"}
                                    className="btn addBtn"
                                    onClick={handleSubmit((formData) => onSubmit(formData, "goToList"))}
                                    disabled={isSaving}
                                />
                                )}
                            </div> */}
                            {/* <div className="d-flex justify-content-center mt-3">
                                {isEditMode ? (
                                    <Button
                                        label={isSaving ? "Updating..." : "Update Job Order"}
                                        className="btn addBtn"
                                        onClick={handleSubmit((formData) => onSubmit(formData, "goToList"))}
                                        disabled={isSaving}
                                    />
                                ) : (
                                    <Button
                                        label={isSaving ? "Finalizing..." : "Finalize Job Order"}
                                        className="btn addBtn"
                                        onClick={handleSubmit((formData) => onSubmit(formData, "goToList"))}
                                        disabled={isSaving}
                                    />
                                )}
                            </div> */}
                             <div className="d-flex justify-content-center mt-0">
                                    <Button
                                        label="Back"
                                        icon="pi pi-arrow-left"
                                        className="btn blueBtn"
                                        // disabled={isSaving || isJobReadOnly}
                                        onClick={() =>{
                                             setMainTab((prev) => prev - 1);
                                            }}
                                    />
                                    <Button
                                        label={isEditMode ? (isSaving ? "Updating..." : "Update Job Order") : (isSaving ? "Finalizing..." : "Finalize Job Order")}
                                        className="btn btn-success blueBtn"
                                        title={isEditMode ? (isSaving ? "Updating..." : "Update Job Order") : (isSaving ? "Finalizing..." : "Finalize Job Order")}
                                        // onClick={handleSubmit(async (formData) => {
                                        // const response = await onSubmit(formData, "goToSocialMedia");
                                        // if (response?.status !== "error") {
                                        //     // Show success modal
                                        //     setShowSuccessModal(true);
                                        // }
                                        // })}
                                        onClick={async () => {                                        
                                            const isValid = await trigger([
                                            "modeOfOperation",
                                            "closeDate",
                                            "job_title",
                                            "minExperience",
                                            "maxExperience",
                                            "difficultyLevel",
                                            "category",
                                            "location",
                                            "noOfOpenings",
                                            "roles_responsibility",
                                            "education_level",
                                            "state",
                                            "jdDescription"
                                            ]);                      
                                            if (!isValid) {
                                            setMainTab(0); 
                                            return;
                                            }                                          
                                            handleSubmit(async (formData) => {
                                            const response = await onSubmit(formData, "goToSocialMedia");
                                            if (response?.status !== "error") {
                                                setShowSuccessModal(true);
                                            }
                                            })();
                                        }}
                                        disabled={isSaving || isJobReadOnly}
                                    /> 
                                    {/* <Button
                                        // label={
                                        //     isEditMode
                                        //     ? isSaving
                                        //         ? "Updating..."
                                        //         : "Update Job Order"
                                        //     : isSaving
                                        //         ? "Finalizing..."
                                        //         : "Finalize Job Order"
                                        // }
                                        // className="btn btn-success blueBtn"
                                        // disabled={isSaving}
                                        onClick={async () => {

                                            // 🔴 Validate fields from FIRST TAB
                                            const isValid = await trigger([
                                            "modeOfOperation",
                                            "closeDate",
                                            ]);

                                            // ❌ If invalid → go to FIRST TAB
                                            if (!isValid) {
                                            setMainTab(0); // 👈 First tab
                                            return;
                                            }

                                            // ✅ If valid → submit
                                            handleSubmit(async (formData) => {
                                            const response = await onSubmit(formData, "goToSocialMedia");
                                            if (response?.status !== "error") {
                                                setShowSuccessModal(true);
                                            }
                                            })();
                                        }}
                                        />
 */}

                                    </div>

                            </div>
                        </TabPanel>
                        </TabView>
                    </div>
                </TabPanel>
                <TabPanel header="Social Media Posting">
                    <SocialMediaPost2
                    setJobData={setJobData}
                    jobData={jobData}
                    postToLinkedIn={postToLinkedIn}
                    setPostToLinkedIn={setPostToLinkedIn}
                    selectedLinkedInOrg={selectedLinkedInOrg}
                    setSelectedLinkedInOrg={setSelectedLinkedInOrg}
                    fetchLinkedInOrgs={fetchLinkedInOrgs}
                    getsingleJobOrderid={getsingleJobOrderid}
                     setSelectedTemplateContent={setSelectedTemplateContent}
                     setSelectedPreviewId={setSelectedPreviewId}
                     selectedPreviewId={selectedPreviewId}
                     disabledPreview={isJobReadOnly}
                    />
                    <div className="d-flex justify-content-center gap-2">
                        {postToLinkedIn && (
                            <Button
                            color="primary"
                            className="btn btn-primary blueBtn mt-2"
                            disabled={isPosting || isJobReadOnly}
                            onClick={handlePostToLinkedIn}
                            >
                            {isPosting ? "Posting..." : "Post to LinkedIn"}
                            </Button>
                        )}

                        <Button
                            color="primary"
                            className="btn btn-primary blueBtn mt-2"
                            onClick={navigateBackToJobOrders}
                        >
                            Go to Job Orders
                        </Button>

                        </div>
                    {/* <div className="d-flex justify-content-center mt-3">
                    {isEditMode ? (
                        <Button
                        label={isSaving ? "Updating..." : "Update Job Order"}
                        className="btn addBtn"
                        onClick={handleSubmit((formData) => onSubmit(formData, "goToList"))}
                        disabled={isSaving}
                        />
                    ) : (
                        <Button
                        label={isSaving ? "Finalizing..." : "Finalize Job Order"}
                        className="btn addBtn"
                        onClick={handleSubmit((formData) => onSubmit(formData, "goToList"))}
                        disabled={isSaving}
                        />
                    )} */}
                    {/* <Button
                        color="primary"
                        className="blueBtn  mt-3"
                        disabled={isPosting}
                        onClick={handlePostToLinkedIn}
                        >
                        {isPosting ? "Posting..." : "Post to LinkedIn"}
                        </Button>
                      

                    </div> */}
                </TabPanel>
                {(jobCandidates.length > 0 || totalCandidates > 0) && (
                    <TabPanel header={`Candidates (${totalCandidates})`}>
                       <Row className="">
                        <Col md={4}>
                            <span className="mb-1 d-block" style={{ fontWeight: 700, fontSize: "15px", color: "#212529" }}>
                                Job Title : {jobData?.job_title || "-"}
                            </span>
                        </Col>
                        <Col md={8}>
                        <div className="CreateJobOrderFooter text-end">
                            <button onClick={() => navigate("/all-job-orders")} className="btn blueBtn mt-0">
                                Back
                            </button>
                        </div>
                        </Col>
                       </Row>
                       <Row className="mb-3 g-2">
                           <Col md={12}>
                               <div className="d-flex align-items-center gap-2 flex-wrap">
                                <Input
                                    type="date"
                                    bsSize="sm"
                                    value={fromDateMap[jobDataId]}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        const newFromDate = e.target.value;
                                        setFromDateMap(prev => ({
                                        ...prev,
                                        [jobDataId]: newFromDate
                                        }));
                                          if (!newFromDate) {
                                                setFilterHasNoResults(false);
                                            }
                                    }}
                                    style={{
                                        width: 140,
                                        height: 34,
                                        fontSize: 12
                                    }}
                                    />
                                    <Input
                                    type="date"
                                    bsSize="sm"
                                    min={fromDateMap[jobDataId]}
                                    value={toDateMap[jobDataId]}
                                    onChange={(e) => {
                                        const newToDate = e.target.value;
                                        const startDate = fromDateMap[jobDataId];

                                        if (startDate && newToDate && new Date(newToDate) < new Date(startDate)) {
                                        Swal.fire({
                                            icon: "warning",
                                            title: "Invalid Date",
                                            text: "End date cannot be before start date",
                                        });
                                        return;
                                        }
                                        setToDateMap(prev => ({
                                        ...prev,
                                        [jobDataId]: newToDate
                                        }));
                                        if (!newToDate) {
                                                setFilterHasNoResults(false);
                                            }
                                    }}
                                    style={{
                                        width: 140,
                                        height: 34,
                                        fontSize: 12
                                    }}
                                    />
                                    {(fromDateMap[jobDataId] || toDateMap[jobDataId]) && (
                                        <Button
                                        title="Clear Dates"
                                        style={{
                                            height: 34,
                                            width: 34,
                                            padding: 0,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "1px solid #ccc",
                                            background: "#fff",
                                            borderRadius: 6,
                                            fontSize: 16
                                        }}
                                        onClick={() => {
                                            setFromDateMap(prev => ({ ...prev, [jobDataId]: "" }));
                                            setToDateMap(prev => ({ ...prev, [jobDataId]: "" }));
                                            setFilterHasNoResults(false);
                                        }}
                                        >
                                        ❌
                                        </Button>
                                    )}
                                   <span style={{ display: "inline-block" }}>
                                       <EmailAC
                                           selectedData={filteredJobCandidates.filter(c =>
                                               (selectedCandidateRows[jobDataId] || []).includes(c.job_candidate_id)
                                           )}
                                           jobData={jobData}
                                           showDropdown={false}
                                           buttonLabel="Send Mail "
                                           buttonTitle="Click to send mail to selected candidates"
                                           buttonClassName="btn btn-outline-primary"
                                           buttonStyle={{
                                               display: "inline-flex",
                                               alignItems: "center",
                                               gap: 6,
                                               background: "#fff",
                                               color: "#1a5fa8",
                                               border: "1px solid #1a5fa8",
                                               borderRadius: 6,
                                               padding: "6px 14px",
                                               fontSize: 13,
                                               fontWeight: 500,
                                               whiteSpace: "nowrap",
                                           }}
                                       />
                                   </span>
                                   <span  style={{ display: "inline-block" }} className="d-none">
                                       <button
                                           style={{
                                               display: "inline-flex", alignItems: "center", gap: 6,
                                               background: "#fff", color: "#1a5fa8",
                                               borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500,
                                               whiteSpace: "nowrap",
                                               border: "1px solid #1a5fa8",
                                            //    cursor: jobData?.questions_reviewed ? "pointer" : "not-allowed",
                                            //    opacity: jobData?.questions_reviewed ? 1 : 0.5
                                           }}
                                        //    disabled={!jobData?.questions_reviewed}
                                           onClick={() => {
                                               if ((selectedCandidateRows[jobDataId] || []).length === 0) {
                                                   Swal.fire({
                                                       icon: "warning",
                                                       title: "No Candidates Selected",
                                                       text: "Please select at least one candidate to configure the call.",
                                                       confirmButtonText: "OK",
                                                   });
                                                   return;
                                               }
                                               handleConfigureCallOpen(jobData);
                                           }}
                                       >
                                           <FaCog style={{ fontSize: 12 }} /> Schedule Agent Call
                                       </button>
                                   </span>
                                   <span  style={{ display: "inline-block" }}>
                                       <button
                                           style={{
                                               display: "inline-flex", alignItems: "center", gap: 6,
                                               background: "#fff", color: "#1a5fa8",
                                               border: "1px solid #1a5fa8",
                                               borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500,
                                               whiteSpace: "nowrap",
                                            //    cursor: jobData?.questions_reviewed ? "pointer" : "not-allowed",
                                            //    opacity: jobData?.questions_reviewed ? 1 : 0.5
                                           }}
                                           onClick={() => {
                                               if ((selectedCandidateRows[jobDataId] || []).length === 0) {
                                                   Swal.fire({
                                                       icon: "warning",
                                                       title: "No Candidates Selected",
                                                       text: "Please select at least one candidate to configure bulk outreach.",
                                                       confirmButtonText: "OK",
                                                   });
                                                   return;
                                               }
                                               console.info("jobData",jobData)
                                               const companyName = jobData?.company_name || jobData?.client_name || "-";
                                            //    const companyDescription = jobData?.company_description 
                                            //         || jobData?.company?.description 
                                            //         || jobData?.company?.company_description
                                            //         || jobData?.client_description
                                            //         || "-";
                                               const jobTitle = jobData?.job_title || "";
                                               const location = Array.isArray(jobData?.location) ? jobData?.location.join(", ") : jobData?.location || "";
                                               const minExp = jobData?.min_exp ? `${jobData.min_exp}` : "—";
                                               const maxExp = jobData?.max_exp ? `${jobData.max_exp}years` : "—";
                                               const companyDescription = jobData.company_description || "-";
                                               const companyLogo = jobData?.company_logo || "";

                                               setConfigureCallJob(jobData);
                                               setOutreachSubject(`Opportunity: ${jobTitle} — Bharat ATS`);
                                                  setOutreachBody(`Dear {candidate_name},
                                                        Thank you for your interest in the ${jobTitle} position at ${companyName}.
                                                        
                                                        We have successfully received your application and resume.
                                                        
                                                        ${companyName} is a U.S.-based technology company delivering cloud communications, AI-powered business solutions, SaaS platforms, and enterprise technologies to organizations across multiple industries. As we continue to grow, we are seeking talented professionals who are passionate about innovation and helping build the next generation of business technology solutions.
                                                        
                                                        As the next step in our hiring process, we invite you to complete an initial screening interview with our AI Recruiter.
                                                        
                                                        Schedule Your Interview:
                                                        📅 Book Your Screening Call
                                                        🔗 {screening_link}
                                                        
                                                        The interview will take approximately 15–20 minutes and will help us better understand your experience, skills, and career goals.
                                                        📎 Attached: Job Description for your review.

                                                        Following the interview, our hiring team will evaluate your qualifications and contact selected candidates regarding the next stage of the recruitment process.

                                                        Thank you again for your interest in ${companyName}. We look forward to speaking with you.
                                                        
                                                        Thank you and best regards,
                                                        Talent Acquisition Team
                                                        ${companyName}`);

                                                    setOutreachPayloadBody(`
                                                        <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%; margin:0; padding:0; background-color:#f3f4f6; font-family:Arial, sans-serif; color:#222222;">
                                                        <tr>
                                                            <td align="center" style="padding:24px 12px;">
                                                            <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="700" style="width:700px; max-width:700px; background-color:#ffffff; border:1px solid #d9e1ea;">
                                                                <tr>
                                                                <td align="center" style="background-color:#145b84; color:#ffffff; font-size:18px; line-height:24px; font-weight:700; padding:18px 20px;">
                                                                    Your Profile Matches an Opportunity!
                                                                </td>
                                                                </tr>

                                                                <tr>
                                                                <td style="padding:18px 20px 10px 20px; font-size:14px; line-height:22px; color:#111111;">
                                                                    Dear <strong>{candidate_name}</strong>,
                                                                </td>
                                                                </tr>

                                                                <tr>
                                                                <td style="padding:8px 20px 6px 20px; font-size:14px; line-height:22px; color:#111111; border-bottom:1px solid #edf2f7;">
                                                                    We reviewed your profile and it closely matches an exciting opportunity we have. Below are the details:
                                                                </td>
                                                                </tr>

                                                                <tr>
                                                                <td style="padding:22px 34px 34px 34px; font-size:14px; line-height:24px; color:#111111;">
                                                                    <ul style="margin:0; padding-left:18px;">
                                                                    <li><strong>Company Name :</strong> ${companyName}</li>
                                                                    <li><strong>Company Description :</strong> ${companyDescription}</li>
                                                                    <li><strong>Role :</strong> ${jobTitle}</li>
                                                                    <li><strong>Location :</strong> ${location}</li>
                                                                    <li><strong>Experience :</strong> ${minExp} - ${maxExp}</li>
                                                                    
                                                                    </ul>
                                                                </td>
                                                                </tr>

                                                                <tr>
                                                                <td style="padding:10px 20px 16px 20px; font-size:16px; line-height:24px; font-weight:700; color:#111111;">
                                                                    Are you interested in exploring this opportunity?
                                                                </td>
                                                                </tr>

                                                                <tr>
                                                                <td style="padding:16px 20px 22px 20px;">
                                                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                                                                    <tr>
                                                                        <td align="center" style="background-color:#145b84;">
                                                                        <a href="{consent_url}"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style="
                                                                                display:inline-block;
                                                                                background-color:#145b84;
                                                                                color:#ffffff;
                                                                                text-decoration:none;
                                                                                font-size:14px;
                                                                                line-height:18px;
                                                                                font-weight:700;
                                                                                padding:10px 16px;
                                                                                border:1px solid #145b84;
                                                                                border-radius:6px;
                                                                            ">
                                                                            Click to give Consent
                                                                        </a>
                                                                        </td>
                                                                        <td style="margin-left: 5px;">
                                                                            <a href="{unsubscribe_url}"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style="
                                                                                display:inline-block;
                                                                                background-color:#ffffff;
                                                                                color:#6b7280;
                                                                                text-decoration:none;
                                                                                font-size:14px;
                                                                                line-height:18px;
                                                                                font-weight:700;
                                                                                padding:10px 16px;
                                                                                border:1px solid #6b7280;
                                                                                border-radius:6px;
                                                                            ">
                                                                            Unsubscribe
                                                                        </a>
                                                                        </td>
                                                                    </tr>
                                                                    </table>
                                                                </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="padding:0 20px 20px 20px; font-size:14px; line-height:22px; color:#111111;">

                                                                        <div style="margin-top:10px">
                                                                    <img src=${companyLogo} width="200"     ;                   
                                                                    style="width:200px;" />

                                                                    <div style="margin-top:8px;">Thanks and Regards,</div>

                                                                    <div style="font-weight:700; margin:0;">
                                                                        ${companyName},
                                                                    </div>

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                <td style="padding:0 20px 18px 20px; border-top:1px solid #edf2f7; font-size:12px; line-height:18px; color:#6b7280;">
                                                                    <div style="padding-top:12px;">&copy; 2026 ${companyName}. All rights reserved.</div>
                                                                    <div>This is an automated message — please do not reply to this email.</div>
                                                                </td>
                                                                </tr>
                                                            </table>
                                                            </td>
                                                        </tr>
                                                        </table>
                                                    `);
                                               setOutreachTab("compose");
                                               setShowBulkOutreachModal(true);
                                           }}
                                        //    disabled={!jobData?.questions_reviewed}
                                       >
                                           <FaEnvelopeOpenText style={{ fontSize: 12 }} /> Schedule Bulk Email / WhatsApp
                                       </button>
                                   </span>
                                   {/* <span style={{ position: "relative", display: "inline-flex" }}>
                                       <Button
                                           title="AI Result Filters"
                                           style={{
                                               display: "inline-flex",
                                               alignItems: "center",
                                               gap: 6,
                                               height: 34,
                                               padding: "0 14px",
                                               border: "1px solid #1a5fa8",
                                               borderRadius: 6,
                                               fontSize: 13,
                                               fontWeight: 500,
                                               color: activeAiResultFilterCount ? "#fff" : "#1a5fa8",
                                               background: activeAiResultFilterCount ? "#1a5fa8" : "#fff",
                                               whiteSpace: "nowrap",
                                           }}
                                           onClick={() => setAiResultFilterOpen(prev => !prev)}
                                       >
                                           AI Result{activeAiResultFilterCount ? ` (${activeAiResultFilterCount})` : ""} <span>▾</span>
                                       </Button>
                                       {aiResultFilterOpen && (
                                           <div
                                               style={{
                                                   position: "absolute",
                                                   top: "calc(100% + 6px)",
                                                   right: 0,
                                                   zIndex: 20,
                                                   minWidth: 230,
                                                   padding: 12,
                                                   background: "#fff",
                                                   border: "1px solid #dbeafe",
                                                   borderRadius: 8,
                                                   boxShadow: "0 10px 24px rgba(15, 23, 42, 0.14)",
                                               }}
                                           >
                                               <label className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: 13 }}>
                                                   <input
                                                       type="checkbox"
                                                       checked={!!emailSentFilterMap[jobDataId]}
                                                       onChange={(e) => {
                                                           setPage(1);
                                                           setEmailSentFilterMap(prev => ({ ...prev, [jobDataId]: e.target.checked }));
                                                           if (!e.target.checked) setFilterHasNoResults(false);
                                                       }}
                                                   />
                                                   Email Sent
                                               </label>
                                               <label className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: 13 }}>
                                                   <input
                                                       type="checkbox"
                                                       checked={!!sendTestFilterMap[jobDataId]}
                                                       onChange={(e) => {
                                                           setPage(1);
                                                           setSendTestFilterMap(prev => ({ ...prev, [jobDataId]: e.target.checked }));
                                                           if (!e.target.checked) setFilterHasNoResults(false);
                                                       }}
                                                   />
                                                   Tests Sent
                                               </label>
                                                <label className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: 13 }}>
                                                   <input
                                                       type="checkbox"
                                                    //    checked={!!sendTestFilterMap[jobDataId]}
                                                       onChange={(e) => {
                                                           setPage(1);
                                                           setSendTestFilterMap(prev => ({ ...prev, [jobDataId]: e.target.checked }));
                                                           if (!e.target.checked) setFilterHasNoResults(false);
                                                       }}
                                                   />
                                                   AI Screening 
                                               </label>
                                               {/* <Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Consent Status</Label>
                                               <select
                                                   className="form-select form-select-sm"
                                                   value={consentStatusFilterMap[jobDataId] || ""}
                                                   onChange={(e) => {
                                                       const val = e.target.value;
                                                       setPage(1);
                                                       setConsentStatusFilterMap(prev => ({ ...prev, [jobDataId]: val }));
                                                       if (!val) setFilterHasNoResults(false);
                                                   }}
                                               >
                                                   <option value="">All Consent Status</option>
                                                   <option value="not_sent">Not Sent</option>
                                                   <option value="pending">Pending</option>
                                                   <option value="accepted">Approved</option>
                                                   <option value="rejected">Rejected</option>
                                               </select> */}
                                               {/* {activeAiResultFilterCount > 0 && (
                                                   <button
                                                       type="button"
                                                       className="btn btn-link btn-sm p-0 mt-2"
                                                       onClick={() => {
                                                           setPage(1);
                                                           setEmailSentFilterMap(prev => ({ ...prev, [jobDataId]: false }));
                                                           setSendTestFilterMap(prev => ({ ...prev, [jobDataId]: false }));
                                                           setConsentStatusFilterMap(prev => ({ ...prev, [jobDataId]: "" }));
                                                           setFilterHasNoResults(false);
                                                       }}
                                                   >
                                                       Clear AI Result filters
                                                   </button>
                                               )}
                                           </div>
                                       )}
                                   </span> */} 
                                   <Button
                                    title="Email Sent"
                                    style={{
                                    // display: "none",
                                    alignItems: "center",
                                    gap: 6,
                                    height: 34,
                                    padding: "0 14px",
                                    border: "1px solid #1a5fa8",
                                    borderRadius: 6,
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: emailSentFilterMap[jobDataId] ? "#fff" : "#1a5fa8",
                                    background: emailSentFilterMap[jobDataId] ? "#1a5fa8" : "#fff",
                                    whiteSpace: "nowrap",
                                    }}
                                            onClick={() => {
                                            const newVal = !emailSentFilterMap[jobDataId];

                                            setEmailSentFilterMap(prev => ({
                                                ...prev,
                                                [jobDataId]: newVal
                                            }));
                                            if (!newVal) setFilterHasNoResults(false);
                                            }}
                                            >
                                                📧 Email Sent
                                            </Button>
                                            <Button
                                            title="Send Test"
                                            style={{
                                                // display: "none",
                                                alignItems: "center",
                                                gap: 6,
                                                height: 34,
                                                padding: "0 14px",
                                                border: "1px solid #1a5fa8",
                                                borderRadius: 6,
                                                fontSize: 13,
                                                fontWeight: 500,
                                                color: sendTestFilterMap[jobDataId] ? "#fff" : "#1a5fa8",
                                                background: sendTestFilterMap[jobDataId] ? "#1a5fa8" : "#fff",
                                                whiteSpace: "nowrap",
                                            }}
                                            onClick={() => {
                                                    const newVal = !sendTestFilterMap[jobDataId];
                                                    setSendTestFilterMap(prev => ({
                                                        ...prev,
                                                        [jobDataId]: newVal
                                                    }));
                                                    if (!newVal) setFilterHasNoResults(false);
                                                    }}
                                                    
                                            >
                                            🧪 Tests Sent
                                            </Button>
                                            {/* <Button
                                                title="AI Result"
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    height: 34,
                                                    padding: "0 14px",
                                                    border: "1px solid #1a5fa8",
                                                    borderRadius: 6,
                                                    fontSize: 13,
                                                    fontWeight: 500,
                                                    color: aiScreeningFilterMap[jobDataId] ? "#fff" : "#1a5fa8",
                                                    background: aiScreeningFilterMap[jobDataId] ? "#1a5fa8" : "#fff",
                                                    whiteSpace: "nowrap",
                                                }}
                                                onClick={() => {
                                                    const newVal = !aiScreeningFilterMap[jobDataId];
                                                    setPage(1);
                                                    setAiScreeningFilterMap(prev => ({
                                                        ...prev,
                                                        [jobDataId]: newVal
                                                    }));
                                                    if (!newVal) setFilterHasNoResults(false);
                                                }}
                                            >
                                                AI Screening Result
                                            </Button> */}
                                           {/* <select
                                            title="Filter by Folder"
                                            className="form-select form-select-sm"
                                            value={folderFilterMap[jobDataId] || ""}
                                            onChange={e => {
                                                const folderId = e.target.value;
                                                setPage(1);
                                                setFolderFilterMap(prev => ({ ...prev, [jobDataId]: folderId }));
                                                if (!folderId) setFilterHasNoResults(false);
                                            }}
                                            disabled={candidateFoldersLoading}
                                            style={{
                                                width: 190,
                                                height: 34,
                                                border: "1px solid #f59e0b",
                                                borderRadius: 6,
                                                fontSize: 13,
                                                fontWeight: 500,
                                                color: "#f59e0b",
                                                background: "#fff",
                                                whiteSpace: "nowrap",
                                            }}
                                            >
                                            <option value="">
                                                {candidateFoldersLoading ? "Loading folders..." : "Filter by Folder"}
                                            </option>
                                            {candidateFolders.map(folder => {
                                                const folderId = getFolderId(folder);
                                                return (
                                                <option key={folderId} value={folderId}>
                                                    {getFolderName(folder)}
                                                </option>
                                                );
                                            })}
                                            </select> */}
                                            {/* <select
                                    value={consentStatusFilterMap[jobDataId] || ""}
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        setConsentStatusFilterMap(prev => ({
                                            ...prev,
                                            [jobDataId]: val
                                        }));
                                        if (!val) setFilterHasNoResults(false);
                                        }}
                                            style={{
                                            display: "none",
                                            alignItems: "center",
                                            height: 34,
                                            padding: "0 10px",
                                            border: "1px solid #1a5fa8",
                                            borderRadius: 6,
                                            fontSize: 13,
                                            fontWeight: 500,
                                            color: consentStatusFilterMap[jobDataId] ? "#fff" : "#1a5fa8",
                                            background: consentStatusFilterMap[jobDataId] ? "#1a5fa8" : "#fff",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            outline: "none",
                                            }}
                                        >
                                            <option value="">Consent Status</option>
                                            <option value="not_sent">Not Sent</option>
                                            <option value="pending">Pending</option>
                                            <option value="accepted">Approved</option>
                                            <option value="rejected">Rejected</option>
                                        </select> */}
                               </div>
                           </Col>
                       </Row>
                        <Row className="g-3">
                            <Col md={4}>
                                <div className="create-job-candidate-panel">
                                    
                                   <div className="create-job-candidate-header">
                                        <div>
                                            <h6 className="mb-1 fw-bold">Candidates List</h6>
                                            <small className="text-muted">
                                                Click a candidate to view resume and profile details.
                                            </small>
                                        </div>
                                        <span className="create-job-candidate-count">{totalCandidates}</span>
                                    </div>

                                    <InputGroup className="create-job-candidate-search">
                                        <div className="d-flex align-items-center gap-4 me-2">
                                            <input
                                                type="checkbox"
                                                title="Select all visible candidates"
                                                checked={
                                                    filteredJobCandidates.length > 0 &&
                                                    filteredJobCandidates.every(c =>
                                                        (selectedCandidateRows[jobDataId] || []).includes(
                                                            c.job_candidate_id || c.candidate_id
                                                        )
                                                    )
                                                }
                                                onChange={(e) => {
                                                    const ids = filteredJobCandidates.map(
                                                        c => c.job_candidate_id || c.candidate_id
                                                    );
                                                    setSelectedCandidateRows(prev => ({
                                                        ...prev,
                                                        [jobDataId]: e.target.checked ? ids : [],
                                                    }));
                                                }}
                                                style={{ width: 16, height: 16, cursor: "pointer" }}
                                            />
                                        </div>
                                        <InputGroupText>
                                            <FaSearch />
                                        </InputGroupText>
                                        <Input
                                            value={jobCandidateSearch}
                                            onChange={(event) => setJobCandidateSearch(event.target.value)}
                                            placeholder="Search by name, email, phone, company"
                                        />
                                         {jobCandidateSearch && (
                                            <InputGroupText
                                                style={{ cursor: "pointer", background: "#fff", borderLeft: "none" }}
                                                onClick={() => setJobCandidateSearch("")}
                                                title="Clear search"
                                            >
                                                <FaTimes style={{ fontSize: "13px", color: "#6c757d" }} />
                                            </InputGroupText>
                                        )}
                                    </InputGroup>

                                    <div className="d-flex align-items-center gap-2 mb-2 mt-2">
                                        <select
                                            className="form-select form-select-sm ml-2"
                                            style={{ width: "180px" }}
                                            value={folderFilterMap[jobDataId] || ""}
                                            onChange={e => {
                                                const folderId = e.target.value;
                                                setPage(1);
                                                setFolderFilterMap(prev => ({ ...prev, [jobDataId]: folderId }));
                                               if (!folderId) {
                                                    setFilterHasNoResults(false);
                                                }
                                            }}
                                            disabled={candidateFoldersLoading}
                                        >
                                            <option value="">
                                                {candidateFoldersLoading ? "Loading folders..." : "Filter by Folder"}
                                            </option>
                                            {candidateFolders.map(folder => {
                                                const folderId = getFolderId(folder);
                                                return (
                                                    <option key={folderId} value={folderId}>
                                                        {getFolderName(folder)}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                         <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() => setShowCreateFolderModal(true)}
                                        >
                                            Create Folder
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            title="Delete selected folder"
                                            style={{ whiteSpace: "nowrap" }}
                                            disabled={!folderFilterMap[jobDataId] || deletingCandidateFolder}
                                            onClick={() => handleDeleteCandidateFolder(folderFilterMap[jobDataId])}
                                        >
                                            {deletingCandidateFolder ? (
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                            ) : (
                                               "Delete Folder"
                                            )}
                                        </button>
                                       
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-success"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() => {
                                                const selected = selectedCandidateRows[jobDataId] || [];
                                                if (selected.length === 0) {
                                                    Swal.fire({
                                                        icon: "warning",
                                                        title: "No Candidates Selected",
                                                        text: "Please select at least one candidate to add to a folder.",
                                                        confirmButtonText: "OK",
                                                    });
                                                    return;
                                                }
                                                setAddToFolderId(candidateFolders.length === 1 ? String(getFolderId(candidateFolders[0])) : "");
                                                setShowAddToFolderModal(true);
                                            }}
                                        >
                                            Add to Folder
                                        </button>
                                    </div>

                                    <div className="create-job-candidate-list">
                                    {/* {jobCandidatesLoading ? (
                                        <div className="text-center p-4">
                                            <ProgressSpinner style={{ width: "36px", height: "36px" }} />
                                        </div>
                                    ) : (
                                        jobCandidatesLoading ? null : filteredJobCandidates.length ? (
                                        filteredJobCandidates.map(candidate => {
                                            const candidateKey = candidate.job_candidate_id || candidate.candidate_id;
                                            const selectedKey = selectedJobCandidate?.job_candidate_id || selectedJobCandidate?.candidate_id;
                                            const isSelected = (selectedCandidateRows[jobDataId] || []).includes(candidateKey);
                                            return (
                                                <div
                                                    key={candidateKey}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: 8,
                                                        padding: "8px 12px",
                                                        borderBottom: "1px solid #e2e8f0",
                                                        borderRadius: 6,
                                                        backgroundColor: candidateKey === selectedKey ? "#e3f2fd" : "transparent",
                                                        marginBottom: 4
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <div className="elementItem me-2">
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelected}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedCandidateRows(prev => {
                                                                        const current = prev[jobDataId] || [];   // ✅ correct key
                                                                        if (isSelected) {
                                                                            return {
                                                                                ...prev,
                                                                                [jobDataId]: current.filter(cid => cid !== candidateKey)  // ✅ correct key
                                                                            };
                                                                        } else {
                                                                            return {
                                                                                ...prev,
                                                                                [jobDataId]: [...current, candidateKey]  // ✅ correct key
                                                                            };
                                                                        }
                                                                    });
                                                                }}
                                                                style={{ cursor: "pointer", width: 16, height: 16, minWidth: 16, flexShrink: 0 }}
                                                            />
                                                        </div>
                                                        <div className="elementItem">
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    flex: 1,
                                                                    border: "none",
                                                                    background: "transparent",
                                                                    padding: 0,
                                                                    textAlign: "left",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 8
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedJobCandidate(candidate);
                                                                    setJobCandidateViewTab("resume");
                                                                }}
                                                            >
                                                                <span className="create-job-candidate-avatar">
                                                                    {getCandidateName(candidate).charAt(0).toUpperCase()}
                                                                </span>
                                                                <span className="create-job-candidate-summary">
                                                                    <span className="create-job-candidate-name">{getCandidateName(candidate)}</span>
                                                                    <span className="create-job-candidate-meta">{candidate.email || "-"}</span>
                                                                    <span className="create-job-candidate-meta">
                                                                        {[candidate.mobile_phone, candidate.current_company].filter(Boolean).join(" | ") || "-"}
                                                                    </span>
                                                                    
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="elementItem">
                                                        <button>Clik to call</button>
                                                    </div>
                                                </div>
                                            );
                                        })
                                        ) : (
                                        <div className="text-center text-muted p-4">
                                            {emailSentFilterMap[jobDataId] || sendTestFilterMap[jobDataId] || consentStatusFilterMap[jobDataId]
                                                ? "No candidates found for the selected filters."
                                                : "No candidates match your search."
                                            }
                                        </div>
                                    )
                                    )} */}
                                    {jobCandidatesLoading  ? (
                                        <div className="text-center p-4">
                                            <ProgressSpinner style={{ width: "36px", height: "36px" }} />
                                        </div>
                                    ) : filterHasNoResults ? (
                                        <div className="text-center text-muted p-5">
                                            <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
                                            <div style={{ fontWeight: 600, marginBottom: 6, color: "#374151" }}>No Candidates Found</div>
                                            <div style={{ fontSize: 13 }}>No candidates match the selected filters.</div>
                                            <div style={{ fontSize: 12, marginTop: 8, color: "#94a3b8" }}>
                                                Try clearing or changing the active filters.
                                            </div>
                                        </div>
                                    ) : displayCandidates.length ? (
                                        displayCandidates.map(candidate => {
                                            const candidateKey = candidate.job_candidate_id || candidate.candidate_id;
                                            const selectedKey = selectedJobCandidate?.job_candidate_id || selectedJobCandidate?.candidate_id;
                                            const isSelected = (selectedCandidateRows[jobDataId] || []).includes(candidateKey);
                                            return (
                                                <div
                                                    className="row"
                                                    key={candidateKey}
                                                    style={{
                                                        // display: "flex",
                                                        // alignItems: "center",
                                                        // justifyContent: "space-between",
                                                        // gap: 8,
                                                        padding: "8px 12px",
                                                        borderBottom: "1px solid #e2e8f0",
                                                        borderRadius: 6,
                                                        backgroundColor: candidateKey === selectedKey ? "#e3f2fd" : "transparent",
                                                        marginBottom: 4
                                                    }}
                                                >
                                                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-7 col-12">
                                                        <div className="d-flex align-items-center">
                                                            <div className="elementItem pe-2">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isSelected}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedCandidateRows(prev => {
                                                                            const current = prev[jobDataId] || [];
                                                                            if (isSelected) {
                                                                                return {
                                                                                    ...prev,
                                                                                    [jobDataId]: current.filter(cid => cid !== candidateKey)
                                                                                };
                                                                            } else {
                                                                                return {
                                                                                    ...prev,
                                                                                    [jobDataId]: [...current, candidateKey]
                                                                                };
                                                                            }
                                                                        });
                                                                    }}
                                                                    style={{ cursor: "pointer", width: 16, height: 16, minWidth: 16, flexShrink: 0 }}
                                                                />
                                                            </div>
                                                           <div className="elementItem" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    flex: 1,
                                                                    border: "none",
                                                                    background: "transparent",
                                                                    padding: 0,
                                                                    textAlign: "left",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 8
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedJobCandidate(candidate);
                                                                    setJobCandidateViewTab("resume");
                                                                }}
                                                            >
                                                                <span className="create-job-candidate-avatar">
                                                                    {getCandidateName(candidate).charAt(0).toUpperCase()}
                                                                </span>
                                                                <span className="create-job-candidate-summary">
                                                                    <span style={{ display: "flex", alignItems: "center", gap: 18 }} >
                                                                        <span className="create-job-candidate-name">{getCandidateName(candidate)}</span>
                                                                    </span>
                                                                    <span className="create-job-candidate-meta">{candidate.email || "-"}</span>
                                                                    <span className="create-job-candidate-meta">
                                                                        {[candidate.mobile_phone, candidate.current_company].filter(Boolean).join(" | ") || "-"}
                                                                    </span>
                                                                </span>
                                                            </button>
                                                           
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-5 col-12">
                                                         <div 
                                                            className="elementItem d-flex align-items-center justify-content-end gap-1" 
                                                            style={{ flexWrap: "nowrap" }}
                                                        >
                                                            <button
                                                                className="btn btn-sm blueBtn"
                                                                style={{ padding: "4px 6px" }}
                                                                onClick={() => handlePhoneCallOpen(candidate)}
                                                                >
                                                                <FaPhoneAlt/>
                                                                </button>
                                                                {(() => {
                                                            const isTestSent =
                                                                candidate?.test_sent === true ||
                                                                candidate?.test_sent === 1 ||
                                                                String(candidate?.test_sent || "").toLowerCase() === "true";

                                                            const handleSendOrResend = () => {
                                                                const missingFields = [];
                                                                if (!candidate?.email) missingFields.push("Email");
                                                                if (!candidate?.mobile_phone && !candidate?.candidate_phone) missingFields.push("Phone Number");

                                                                if (missingFields.length > 0) {
                                                                    Swal.fire({
                                                                        icon: "warning",
                                                                        title: "Missing Contact Details",
                                                                        html: `Cannot send test — <strong>${candidate?.first_name || ""} ${candidate?.last_name || ""}</strong> is missing: <b>${missingFields.join(", ")}</b>`,
                                                                        confirmButtonText: "OK",
                                                                    });
                                                                    return;
                                                                }

                                                                Swal.fire({
                                                                    title: isTestSent ? "Confirm Resend Test" : "Confirm Send Test",
                                                                    html: `${isTestSent ? "Resend" : "Send"} test to <strong>${getCandidateName(candidate)}</strong>?<br/><br/>
                                                                        <strong>Email:</strong> ${candidate?.email || "N/A"}<br/>
                                                                        <strong>Phone:</strong> ${candidate?.mobile_phone || candidate?.candidate_phone || "N/A"}<br/><br/>
                                                                        <small>Please verify candidate details before sending.</small>`,
                                                                    icon: "question",
                                                                    showCancelButton: true,
                                                                    confirmButtonText: isTestSent ? "Resend" : "Send",
                                                                    cancelButtonText: "Cancel",
                                                                }).then(async (result) => {
                                                                    if (!result.isConfirmed) return;

                                                                    try {
                                                                        const payload = {
                                                                            job_id: jobDataId,
                                                                            candidate_id: candidate.job_candidate_id,
                                                                        };
                                                                        const response = await axios.post(`/api/v1/screen/`, payload);
                                                                        Swal.fire({
                                                                            icon: "success",
                                                                            title: isTestSent ? "Test Resent" : "Test Sent",
                                                                            text: response?.data?.msg || (isTestSent ? "Test resent successfully." : "Test sent successfully."),
                                                                            timer: 1800,
                                                                            showConfirmButton: false,
                                                                        });

                                                                        const currentJobId = jobData?.job_id || jobOrderId || id;
                                                                        if (currentJobId) {
                                                                            const refreshRes = await axios.get(
                                                                                "/api/v1/candidates/candidates-by-job/",
                                                                                { params: { company_id: companyId, job_id: currentJobId, page, size: pageSize } }
                                                                            );
                                                                            const refreshed = refreshRes?.data?.results?.candidates || [];
                                                                            const normalized = refreshed.map((c, idx) => ({
                                                                                ...c,
                                                                                job_candidate_id: c.job_candidate_id ?? c.candidate_id ?? c.id ?? idx + 1,
                                                                            }));
                                                                            setJobCandidates(normalized);
                                                                            setCandidateDataMap(prev => ({ ...prev, [currentJobId]: normalized }));
                                                                        }
                                                                    } catch (err) {
                                                                        Swal.fire({
                                                                            icon: "error",
                                                                            title: isTestSent ? "Resend Failed" : "Send Test Failed",
                                                                            text: err?.response?.data?.error || err?.response?.data?.message || "Failed to send test.",
                                                                        });
                                                                    }
                                                                });
                                                            };

                                                            return isTestSent ? (
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary blueBtn"
                                                                    title="Resend Test"
                                                                     style={{ padding: "4px 6px" }}
                                                                    onClick={handleSendOrResend}
                                                                >
                                                                    Resend
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm blueBtn"
                                                                    title="Send Test"
                                                                    style={{ padding: "4px 6px" }}
                                                                    onClick={handleSendOrResend}
                                                                >
                                                                    <IoIosSend />
                                                                </button>
                                                            );
                                                        })()}
                                                          {folderFilterMap[jobDataId] && (
                                                            <button
                                                                className="btn btn-sm btn-outline-danger"
                                                                title="Remove from folder"
                                                                style={{ padding: "4px 6px" }}
                                                                onClick={() => handleRemoveCandidateFromFolder(
                                                                    candidate.job_candidate_id || candidate.candidate_id
                                                                )}
                                                            >
                                                                <FaRegTrashAlt />
                                                            </button>
                                                        )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="text-center text-muted p-4">
                                            No candidates match your search.
                                        </div>
                                    )}
                                </div>
                            <div className="d-flex justify-content-between align-items-center p-2 border-top bg-light">
                                <small className="text-muted">
                                    {/* Showing {filteredJobCandidates.length} of {jobCandidates.length} on this page */}
                                </small>

                                <div className="d-flex gap-2">
                                    <select
                                        className="form-select form-select-sm"
                                        value={pageSize}
                                        onChange={(e) => {
                                            const nextSize = Number(e.target.value);
                                            setPage(1);
                                            setPageSize(nextSize);
                                        }}
                                        style={{ width: 92 }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={Math.max(totalCandidates, 1)}>All</option>
                                    </select>
                                    <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={page === 1}
                                    onClick={() => setPage(prev => prev - 1)}
                                    >
                                    Prev
                                    </button>

                                    <span className="px-2 small align-self-center">
                                    {page}
                                    </span>

                                    <button
                                    className="btn btn-sm btn-outline-primary"
                                    disabled={page * pageSize >= totalCandidates}
                                    onClick={() => setPage(prev => prev + 1)}
                                    >
                                    Next
                                    </button>
                                </div>
                                </div>
                                </div>
                            </Col>
                            <Col md={8}>
                                <div className="create-job-candidate-preview">
                                    <div className="create-job-candidate-preview-header">
                                        <div className="d-flex align-items-center gap-3">
                                            <span className="create-job-candidate-preview-avatar">
                                                {getCandidateName(selectedJobCandidate).charAt(0).toUpperCase()}
                                            </span>
                                            <div>
                                                <h6 className="mb-1 fw-bold">{getCandidateName(selectedJobCandidate)}</h6>
                                                <div className="create-job-candidate-preview-meta">
                                                    {[selectedJobCandidate?.email, selectedJobCandidate?.mobile_phone, selectedJobCandidate?.current_company]
                                                    .filter(Boolean)
                                                    .join(" | ") || "-"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {renderCreateJobCandidateDetails()}
                                </div>
                            </Col>
                        </Row>
                    </TabPanel>
                )}
                </TabView>

                {/* Generating Modal */}
                <Modal isOpen={isGenerating} toggle={() => { }} size="md" backdrop="static">
                    <ModalHeader>Generating...</ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-column justify-content-center gap-3">
                            <div className="text-center">
                                <ProgressSpinner />
                            </div>
                            <div className="text-center">Generating questions, please wait...</div>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Generation Success */}
                <Modal isOpen={generationSuccess} toggle={() => setGenerationSuccess(false)} size="md">
                    <ModalHeader toggle={() => setGenerationSuccess(false)} className='modal-header_box blueBtn d-flex justify-content-between m-0 modal-header'>
                        Questions Generated
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            Questions have been successfully generated!
                        </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                        <div className="">
                            <Button
                                color="primary"
                                onClick={() => {
                                    setGenerationSuccess(false);
                                    setMainTab(1);
                                }}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                {/* Upload JD Modal (refactored) */}
                <Modal isOpen={isUploadModalOpen} toggle={closeUploadModal} className="">
                    <ModalHeader toggle={!isSubmittingJd ? closeUploadModal : undefined} className='modal-header_box blueBtn d-flex justify-content-between m-0 modal-header'>Upload JD</ModalHeader>
                    <form onSubmit={(e) => { e.preventDefault(); handleImportJd(); }}>
                        <ModalBody>
                            <div
                                className={`uploadFileClass ${isSubmittingJd ? "disabled" : ""}`}
                                onClick={!isSubmittingJd ? () => document.getElementById("uploadJdFile").click() : undefined}
                                onDragOver={onDragOver}
                                onDrop={!isSubmittingJd ? onDrop : undefined}
                                style={{
                                    border: "2px dashed #ccc",
                                    borderRadius: "10px",
                                    padding: "30px",
                                    textAlign: "center",
                                    cursor: isSubmittingJd ? "not-allowed" : "pointer",
                                    background: isSubmittingJd ? "#f8f9fa" : "white",
                                }}
                            >
                                <input
                                    type="file"
                                    id="uploadJdFile"
                                    accept=".doc,.docx,.pdf"
                                    onChange={onInputFileChange}
                                    style={{ display: "none" }}
                                    disabled={isSubmittingJd}
                                />

                                <p className="chooseFileSpan">
                                    Drag & drop or{" "}
                                    <span style={{ color: "#007bff", textDecoration: "underline" }}>
                                        Choose file
                                    </span>{" "}
                                    to upload
                                </p>
                                <p className="hintText">PDF or Word files only</p>
                            </div>

                            {errorJdMessage && <small className="text-danger d-block mt-2">{errorJdMessage}</small>}

                            {selectedFiles.length > 0 && (
                                <div style={{ marginTop: "20px" }}>
                                    {selectedFiles.map((item, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                background: "#f8f9fa",
                                                borderRadius: "8px",
                                                padding: "10px 15px",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <img src={documentIcon} alt="document" height="30" width="30" />
                                                <div>
                                                    <p style={{ margin: 0, fontWeight: 500 }}>{item.name}</p>
                                                    <p style={{ margin: 0, fontSize: "12px", color: "#6c757d" }}>
                                                        {(item.size / 1024).toFixed(2)} KB
                                                    </p>
                                                </div>
                                            </div>

                                            {!isSubmittingJd ? (
                                                <img
                                                    src={deleteIcon}
                                                    alt="delete"
                                                    height="20"
                                                    width="20"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => removeSelectedFile(index)}
                                                />
                                            ) : (
                                                <img src={deleteIcon} alt="delete" height="20" width="20" />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter className="justify-content-center">
                            <button className="btn border blueBtn" onClick={closeUploadModal} disabled={isSubmittingJd}>Cancel</button>{' '}
                            <button  className="btn border addBtn" onClick={handleImportJd} disabled={isSubmittingJd}>
                                {isSubmittingJd ? "Importing..." : "Import"}
                            </button>
                        </ModalFooter>
                    </form>
                </Modal>
            </div>
        )}
<Modal isOpen={showSuccessModal}  centered size="lg" id="JObInfoModal"  backdrop="static" >
    <ModalHeader toggle={() => setShowSuccessModal(false)}>{modalTitle}</ModalHeader>
    <ModalBody>
        <div className="" style={{ height: "70vh", overflow: "auto"}}>
            {/* {copySuccess && (
                <div className="alert alert-success" role="alert">
                    Content copied to clipboard!
                </div>
            )} */}
            <div dangerouslySetInnerHTML={{ __html: modalMessage }} />
            {jdDocumentUrl && (
                <p className="mt-3 fw-500">
                    You can download the JD document{" "}
                    <a href={jdDocumentUrl} target="_blank" rel="noopener noreferrer" style={{ color: "blue" }} className="border p-2 rounded">
                        here
                    </a>
                </p>
            )}
        </div>
    </ModalBody>
    <ModalFooter className="justify-content-center">
        <Button
            color="secondary"
            className="btn btn-primary blueBtn"
            onClick={handleCopyContent}
        >
            Copy Content
        </Button>
        <Button
            color="primary"
            className="btn btn-primary blueBtn"
            onClick={() => {
                setShowSuccessModal(false);
                setMainTab(4);
            }}
        >
            Go To Social Media Posting
        </Button>
    </ModalFooter>
</Modal>
<Modal isOpen={showReviewModal} toggle={() => setShowReviewModal(false)} centered size="lg">
    <ModalHeader toggle={() => setShowReviewModal(false)}>Review Job Order</ModalHeader>
    <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <div className="table-responsive">
            <table className="table table-borderless">
                <tbody>
                    <tr>
                        <td><strong>Job Title:</strong> {getValues("job_title")}</td>
                    </tr>
                    <tr>
                        <td><strong>Department:</strong> {departmentList.find(d => String(d.department_id) === String(selectedDepartment))?.name || "N/A"}</td>
                    </tr>
                    <tr>
                        <td><strong>Designation:</strong> {designationList.find(d => String(d.designation_id) === String(selectedDesignation))?.name || "N/A"}</td>
                    </tr>
                    <tr>
                        <td><strong>Minimum Experience:</strong> {getValues("minExperience")} years</td>
                    </tr>
                    <tr>
                        <td><strong>Maximum Experience:</strong> {getValues("maxExperience")} years</td>
                    </tr>
                    <tr>
                        <td><strong>Difficulty Level:</strong> {difficultyLevel}</td>
                    </tr>
                    <tr>
                        <td><strong>Close Date:</strong> {getValues("closeDate")}</td>
                    </tr>
                    <tr>
                        <td><strong>Category:</strong> {selectedCategoryname}</td>
                    </tr>
                    <tr>
                        <td><strong>Shift:</strong> {getValues("shift")}</td>
                    </tr>
                    <tr>
                        <td><strong>Location:</strong> {getValues("location")}</td>
                    </tr>
                    <tr>
                        <td><strong>Mode of Operation:</strong> {modeOfOperationTypes.find(type => type.id === getValues("modeOfOperation"))?.name || "N/A"}</td>
                    </tr>
                    <tr>
                        <td><strong>Number of Openings:</strong> {getValues("noOfOpenings")}</td>
                    </tr>
                    <tr>
                        <td><strong>Required Education:</strong> {getValues("education_level")}</td>
                    </tr>
                    <tr>
                        <td><strong>State:</strong> {getValues("state")}</td>
                    </tr>
                    <tr>
                        <td><strong>Job Description:</strong></td>
                    </tr>
                    <tr>
                        <td dangerouslySetInnerHTML={{ __html: getValues("jdDescription") }}></td>
                    </tr>
                    <tr>
                        <td><strong>Roles & Responsibilities:</strong></td>
                    </tr>
                    <tr>
                        <td dangerouslySetInnerHTML={{ __html: getValues("roles_responsibility") }}></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ModalBody>
   <ModalFooter className="justify-content-center">
    <Button
        color="secondary"
        onClick={() => setShowReviewModal(false)}
        className="btn blueBtn"
    >
        Close
    </Button>
    <Button
        color="primary"
        className="btn blueBtn d-none"
        onClick={() => {
            setShowReviewModal(false);
            handlePreviewQuestions();
        }}
    >
        Generate Questions
    </Button>
</ModalFooter>

</Modal>


<Modal isOpen={showErrorModal} toggle={() => setShowErrorModal(false)} centered>
    <ModalHeader toggle={() => setShowErrorModal(false)}>{modalTitle}</ModalHeader>
    <ModalBody>
        <p>{modalMessage}</p>
    </ModalBody>
    <ModalFooter>
        <Button color="primary" onClick={() => setShowErrorModal(false)}>
            OK
        </Button>
    </ModalFooter>
</Modal>
    <Modal
  isOpen={showLinkedInModal}
  toggle={() => {
    setShowLinkedInModal(false);
    setSelectedLinkedInOrg(null);
     setPostToLinkedIn(false);
  }}
  centered
  size="md"
>
  <ModalHeader toggle={() => setShowLinkedInModal(false)}>
    Select Organization
  </ModalHeader>
  <ModalBody>
    {linkedInOrgs.length > 0 ? (
      linkedInOrgs.map((org) => (
        <div key={org.id} className="form-check mb-2">
          <input
            type="radio"
            className="form-check-input"
            id={`linkedinOrg_${org.id}`}
            name="linkedinOrg"
            checked={selectedLinkedInOrg?.id === org.id}
            onChange={() => setSelectedLinkedInOrg(org)}
          />
          <label className="form-check-label" htmlFor={`linkedinOrg_${org.id}`}>
            {org.organisation_name}
          </label>
        </div>
      ))
    ) : (
      <p>No LinkedIn organizations found.</p>
    )}
  </ModalBody>
  <ModalFooter className="d-flex justify-content-center">
    <Button
      className="btn btn-primary blueBtn"
      onClick={() => {
        setShowLinkedInModal(false);
        setSelectedLinkedInOrg(null);
        setPostToLinkedIn(false);
      }}
    >
      Cancel
    </Button>
    <Button
      className="primary btn btn-primary blueBtn"
      onClick={() => {
        setShowLinkedInModal(false);
        // No need to reset selectedLinkedInOrg here
      }}
    >
      Confirm
    </Button>
  </ModalFooter>
</Modal>
{/* Vitel Global Domain Selection Modal */}
<Modal 
    isOpen={showWebsiteDomainModal} 
    toggle={() => setShowWebsiteDomainModal(false)} 
    centered 
    size="md"
>
    <ModalHeader toggle={() => setShowWebsiteDomainModal(false)}>
        Select Website
    </ModalHeader>
    <ModalBody>
        <p className="mb-4">Where do you want to post this job?</p>

        <div className="d-flex align-items-center gap-4 flex-wrap">
            <div className="form-check d-flex align-items-center gap-2 mb-0">
                <input
                    type="radio"
                    className="form-check-input mt-0"
                    id="vitel_com"
                    name="websiteDomain"
                    checked={selectedWebsiteDomain === "vitelglobal.com"}
                    onChange={() => setSelectedWebsiteDomain("vitelglobal.com")}
                />
                <label className="form-check-label fs-6 text-nowrap" htmlFor="vitel_com">
                    vitelglobal.com
                </label>
            </div>

            <div className="form-check d-flex align-items-center gap-2 mb-0">
                <input
                    type="radio"
                    className="form-check-input mt-0"
                    id="vitel_in"
                    name="websiteDomain"
                    checked={selectedWebsiteDomain === "vitelglobal.in"}
                    onChange={() => setSelectedWebsiteDomain("vitelglobal.in")}
                />
                <label className="form-check-label fs-6 text-nowrap" htmlFor="vitel_in">
                    vitelglobal.in
                </label>
            </div>
        </div>
    </ModalBody>
    <ModalFooter className="justify-content-center">
        <Button 
            color="secondary" 
            onClick={() => {
                setShowWebsiteDomainModal(false);
                setPostToWebsite(false);
            }}
        >
            Cancel
        </Button>
        <Button 
            color="primary" 
            className="blueBtn"
            onClick={() => {
                setPostToWebsite(true);
                setShowWebsiteDomainModal(false);
            }}
        >
            Confirm
        </Button>
    </ModalFooter>
</Modal>

<Dialog
  header="All Questions Overview"
  visible={showAllQuestionsModal}
  style={{ width: "85vw" }}
  contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
  onHide={() => setShowAllQuestionsModal(false)}
>
  <div className="container-fluid">
    {Array.isArray(sectionData) &&
      sectionData
        .filter((section) => section.checked)
        .map((section, idx) => (
          <div
            key={idx}
            className="mb-4 p-3 shadow-sm"
            style={{
              borderRadius: "10px",
              background: "#ffffff",
              border: "1px solid #e0e0e0"
            }}
          >
            <h5 style={{ color: "#f47f22" }}>{section.name}</h5>

            {["beginner", "intermediate", "advanced"].map((level) => {
              const manualQs =
                manualQuestions[section.name]?.questions?.[level] || [];

              const levelColor = {
                beginner: "#28a745",
                intermediate: "#ffc107",
                advanced: "#dc3545"
              };

              return (
                <div
                  key={level}
                  className="mb-3 p-2"
                  style={{
                    borderRadius: "8px",
                    background: "#f8f9fa"
                  }}
                >
                  <div className="d-flex align-items-center mb-2">
                    <span
                      style={{
                        background: levelColor[level],
                        color: "#fff",
                        padding: "3px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        marginRight: "10px"
                      }}
                    >
                      {level.toUpperCase()}
                    </span>

                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                      {manualQs.length} Questions
                    </span>
                  </div>

                  {/* Questions */}
                  {manualQs.length > 0 ? (
                    <ul style={{ paddingLeft: 0 }}>
                      {manualQs.map((q, i) => (
                        <li
                          key={i}
                          style={{
                            display: "flex",
                            gap: "8px",
                            marginBottom: "5px"
                          }}
                        >
                          <span style={{ minWidth: "20px", fontWeight: 600 }}>
                            {i + 1}.
                          </span>
                          <span>{q}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#999",
                        fontStyle: "italic"
                      }}
                    >
                      {/* No questions available */}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}

<div
  className="mb-4 p-3 shadow-sm"
  style={{
    borderRadius: "10px",
    background: "#eef6ff",
    border: "1px solid #cfe2ff"
  }}
>
  <h5 style={{ color: "#007bff" }}>🤖 AI Generated Questions</h5>

  {Object.keys(generatedQuestions).length > 0 ? (
    Object.entries(generatedQuestions).map(([skill, levels], idx) => (
      <div
        key={idx}
        className="mb-3 p-3 shadow-sm"
        style={{
          borderRadius: "10px",
          background: "#ffffff",
          border: "1px solid #dce8fb"
        }}
      >
        <h6 style={{ color: "#333", marginBottom: "10px" }}>  {skill} (
                    {(levels.beginner?.length || 0) +
                    (levels.intermediate?.length || 0) +
                    (levels.advanced?.length || 0)}
                    )</h6>

        {["beginner", "intermediate", "advanced"].map((level) => {
          const questions = levels[level] || [];
          if (questions.length === 0) return null; 

          return (
            <div key={level} className="mb-2">
              <strong className="text-capitalize">{level}</strong>

              <ul style={{ paddingLeft: 0, marginTop: "4px" }}>
                {questions.map((qObj, i) => (
                  <li
                    key={i}
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginBottom: "5px"
                    }}
                  >
                    <span style={{ minWidth: "20px", fontWeight: 600 }}>
                      {i + 1}.
                    </span>
                    <span>{qObj.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    ))
  ) : (
    <div className="text-muted">No AI generated questions available</div>
  )}
</div>

  </div>

  {/* 🔻 Footer */}
  <div
    style={{
    //   position: "sticky",
      bottom: 0,
      background: "#fff",
      padding: "10px",
      borderTop: "1px solid #eee",
      display: "flex",
      justifyContent: "center"
    }}
  >
    <button
      className="btn btn-secondary blueBtn px-4"
      onClick={() => setShowAllQuestionsModal(false)}
    >
      Close
    </button>
  </div>
</Dialog>
<Modal isOpen={showCreateFolderModal} toggle={() => setShowCreateFolderModal(false)} centered>
    <ModalHeader toggle={() => setShowCreateFolderModal(false)}>
        Create Folder
    </ModalHeader>
    <ModalBody>
        <div className="mb-3">
            <label className="form-label fw-semibold">
                Folder Name <span className="text-danger">*</span>
            </label>
            <input
                type="text"
                className="form-control"
                placeholder="Enter folder name"
                value={newFolderName}
                onChange={e => setNewFolderName(e.target.value)}
                onKeyDown={e => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleCreateCandidateFolder();
                    }
                }}
                autoFocus
            />
        </div>
    </ModalBody>
    <ModalFooter className="justify-content-center">
        <button
            type="button"
            className="btn blueBtn"
            onClick={() => {
                setShowCreateFolderModal(false);
                setNewFolderName("");
            }}
            disabled={creatingCandidateFolder}
        >
            Cancel
        </button>
        <button
            type="button"
            className="btn addBtn"
            onClick={handleCreateCandidateFolder}
            disabled={creatingCandidateFolder}
        >
            {creatingCandidateFolder ? (
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Creating...
                </>
            ) : "Create"}
        </button>
    </ModalFooter>
</Modal>
<Modal isOpen={showAddDepartmentModal} toggle={() => setShowAddDepartmentModal(false)} centered>
    <ModalHeader toggle={() => setShowAddDepartmentModal(false)}>
        Add Department
    </ModalHeader>
    <ModalBody>
        <div className="mb-3">
            <label className="form-label fw-semibold">
                Department Name <span className="text-danger">*</span>
            </label>
            <input
                type="text"
                className="form-control"
                placeholder="Enter department name"
                value={newDepartmentName}
                onChange={(e) => {
                    setNewDepartmentName(e.target.value);
                    if (addDeptError) setAddDeptError("");
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddDepartment();
                    }
                }}
                autoFocus
            />
            {addDeptError && (
                <small className="text-danger">{addDeptError}</small>
            )}
        </div>
    </ModalBody>
    <ModalFooter className="justify-content-center">
        <button
            type="button"
            className="btn blueBtn"
            onClick={() => {
                setShowAddDepartmentModal(false);
                setNewDepartmentName("");
                setAddDeptError("");
            }}
            disabled={addDeptLoading}
        >
            Cancel
        </button>
        <button
            type="button"
            className="btn addBtn"
            onClick={handleAddDepartment}
            disabled={addDeptLoading}
        >
            {addDeptLoading ? (
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Adding...
                </>
            ) : "Add Department"}
        </button>
    </ModalFooter>
</Modal>
<Modal isOpen={showAddDesignationModal} toggle={() => setShowAddDesignationModal(false)} centered>
    <ModalHeader toggle={() => setShowAddDesignationModal(false)}>
        Add Designation
    </ModalHeader>
    <ModalBody>
        <div className="mb-3">
            <label className="form-label fw-semibold">
                Designation Name <span className="text-danger">*</span>
            </label>
            <input
                type="text"
                className="form-control"
                placeholder="Enter designation name"
                value={newDesignationName}
                onChange={(e) => {
                    setNewDesignationName(e.target.value);
                    if (addDesignError) setAddDesignError("");
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddDesignation();
                    }
                }}
                autoFocus
            />
            {addDesignError && (
                <small className="text-danger">{addDesignError}</small>
            )}
        </div>
    </ModalBody>
    <ModalFooter className="justify-content-center">
        <button
            type="button"
            className="btn blueBtn"
            onClick={() => {
                setShowAddDesignationModal(false);
                setNewDesignationName("");
                setAddDesignError("");
            }}
            disabled={addDesignLoading}
        >
            Cancel
        </button>
        <button
            type="button"
            className="btn addBtn"
            onClick={handleAddDesignation}
            disabled={addDesignLoading}
        >
            {addDesignLoading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    />
                    Adding...
                </>
            ) : "Add Designation"}
        </button>
    </ModalFooter>
</Modal>
<Modal
  isOpen={showBulkOutreachModal}
  toggle={() => { setShowBulkOutreachModal(false); setOutreachTab("compose"); }}
  size="lg"
  centered
  className="bo-modal"
>
  <ModalHeader
    toggle={() => { setShowBulkOutreachModal(false); setOutreachTab("compose"); }}
    style={{ paddingBottom: 0, border: "none" }}
  >
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 20 }}>📨</span>
        <span style={{ fontWeight: 700, fontSize: 18 }}>Bulk Outreach</span>
      </div>
      <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
        {configureCallJob?.job_title || "Job"} ·{" "}
        <span style={{ color: "#2563eb", fontWeight: 600 }}>
          {(selectedCandidateRows[configureCallJob?.job_id || configureCallJob?.id] || []).length} candidates

        </span>
      </div>
    </div>
  </ModalHeader>

  <ModalBody>

    <div className="bo-tabs">
      {[
        { id: "compose", label: "Compose" },
        { id: "followup", label: "Follow-up" },
        { id: "review", label: "Review" },
      ].map((t) => {
        const isDone =
          (t.id === "compose" && ["followup", "review"].includes(outreachTab)) ||
          (t.id === "followup" && outreachTab === "review");

        return (
          <div
            key={t.id}
            className={`bo-tab ${outreachTab === t.id ? "active" : ""} ${isDone ? "done" : ""}`}
            onClick={() => setOutreachTab(t.id)}
          >
            {isDone ? `✓ ${t.label}` : t.label}
          </div>
        );
      })}
    </div>

    {outreachTab === "compose" && (
      <div className="bo-panel">

        <div className="bo-section-head">
          <span className="bo-section-icon"><FaEnvelopeOpenText /></span>
          <div>
            <div className="bo-section-title">Compose Outreach</div>
            <div className="bo-section-subtitle">
              Choose channels and craft the message candidates will receive first.
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <button
            className={`bo-channel-btn ${outreachChannels.email ? "active" : ""}`}
            onClick={() => setOutreachChannels(p => ({ ...p, email: !p.email }))}
          >
            <input type="checkbox" checked={outreachChannels.email} readOnly style={{ pointerEvents: "none" }} />
            <FaRegEnvelope /> 📧 Email
          </button>

          <button
            className={`bo-channel-btn wp ${outreachChannels.whatsapp ? "active" : ""}`}
            onClick={() => setOutreachChannels(p => ({ ...p, whatsapp: !p.whatsapp }))}
          >
            <input type="checkbox" checked={outreachChannels.whatsapp} readOnly style={{ pointerEvents: "none" }} />
            <FaWhatsapp /> 💬 WhatsApp
          </button>
        </div>
         {outreachChannels.email && (
          <>
            <div className="bo-label">Email Subject</div>
        <input
          className="bo-input bo-input-subject"
          style={{ marginBottom: 16 }}
          placeholder="Opportunity : Full Stack Engineer — Bharat ATS"
          value={outreachSubject}
          onChange={e => setOutreachSubject(e.target.value)}
        />

          </>
        )}
        <div className="bo-label">Message Body</div>
        <textarea
          className="bo-input bo-textarea"
          value={outreachBody}
          onChange={(e) => setOutreachBody(e.target.value)}
        />

       <div className="bo-hint">
          <span>⚠️</span>
          <span><strong>One-time blast:</strong> Initial message sent once per candidate. Follow-up reminders go to non-responders.</span>
        </div>
      </div>
    )}
    {outreachTab === "followup" && (
      <div className="bo-panel">

        <div className="bo-section-head">
          <span className="bo-section-icon"><FaHistory /></span>
          <div>
            <div className="bo-section-title">Reminder Settings</div>
            <div className="bo-section-subtitle">
              Configure how often reminders go out and when they stop.
            </div>
          </div>
        </div>

        <div className="bo-alert">
          🔔 Auto-reminders only go to non-responders.
        </div>
        <div className="bo-label">Reminder Frequency</div>
        <select
          className="bo-input"
          value={outreachFrequency}
          onChange={(e) => setOutreachFrequency(e.target.value)}
        >
          <option value="daily">Daily</option>
          <option value="12h">Every 12 hours</option>
          <option value="48h">Every 48 hours</option>
          <option value="weekly">Weekly</option>
        </select>
        <div className="bo-label" style={{ marginTop: 10 }}>Max Reminders</div>
        <input
          type="number"
          className="bo-input"
          value={outreachMaxReminders}
          onChange={(e) => setOutreachMaxReminders(Number(e.target.value))}
        />
        <div className="bo-label" style={{ marginTop: 10 }}>Reminder Channels</div>
        {["email", "whatsapp"].map(ch => (
          <label key={ch} className="bo-check-row">
            <input
              type="checkbox"
              checked={outreachChannels[ch] || false}
              onChange={() => setOutreachChannels(p => ({ ...p, [ch]: !p[ch] }))}
            />
            {ch}
          </label>
        ))}
        <div className="bo-label" style={{ marginTop: 10 }}>Auto Stop Conditions</div>

        <label className="bo-check-row">
          <input
            type="checkbox"
            checked={outreachAutoStop.accept}
            onChange={() => setOutreachAutoStop(p => ({ ...p, accept: !p.accept }))}
          />
          Candidate Accepts
        </label>

        <label className="bo-check-row">
          <input
            type="checkbox"
            checked={outreachAutoStop.decline}
            onChange={() => setOutreachAutoStop(p => ({ ...p, decline: !p.decline }))}
          />
          Candidate Declines
        </label>

        <label className="bo-check-row">
          <input
            type="checkbox"
            checked={outreachAutoStop.max}
            onChange={() => setOutreachAutoStop(p => ({ ...p, max: !p.max }))}
          />
          Max reminders reached
        </label>

      </div>
    )}

    {outreachTab === "review" && (() => {
  const jobId = configureCallJob?.job_id;
    const mapKey = configureCallJob?.job_id || configureCallJob?.id || jobOrderId || id;

  const selectedIds = selectedCandidateRows[jobId] || [];
  const allCandidates = candidateDataMap[mapKey] || [];

  const selectedCandidates = allCandidates.filter(c =>
    selectedIds.includes(c.job_candidate_id)
  );

  const channels = [
    outreachChannels.email && "Email",
    outreachChannels.whatsapp && "WhatsApp",
  ].filter(Boolean).join(" + ");

  const freqLabel = {
    daily: "daily",
    "12h": "every 12 hours",
    "48h": "every 48 hours",
    weekly: "weekly"
  }[outreachFrequency];

  const avatarColors = ["#2563eb","#7c3aed","#db2777","#059669","#d97706"];

  return (
    <div className="bo-panel">

      {/* SUMMARY CARD */}
      <div className="bo-card-1" style={{ marginBottom: 16 }}>
        <div style={{
          fontWeight: 700,
          marginBottom: 12,
          display: "flex",
          alignItems: "center",
          gap: 8
        }}>
          <FaRegEye style={{ color: "#2563eb" }} />
          <span>Review Summary</span>
        </div>

        {[
          { label: "Job", value: configureCallJob?.job_title || "--" },
          { label: "Recipients", value: `${selectedCandidates.length} candidates` },
          { label: "Channels", value: channels || "--" },
          { label: "Follow-up", value: `${freqLabel} · max ${outreachMaxReminders} reminders` },
        ].map(r => (
          <div key={r.label} className="bo-info-row">
            <span className="bo-info-label">{r.label}</span>
            <span style={{ color: "#1e293b", fontWeight: 500 }}>{r.value}</span>
          </div>
        ))}
      </div>

      {/* CANDIDATE LIST */}
      <div className="bo-card bo-review-list">

        <div style={{
          fontWeight: 700,
          color: "#2563eb",
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 8
        }}>
          <FaCopy />
          <span>Candidate List</span>
        </div>

        {selectedCandidates.length === 0 ? (
          <p className="text-muted mb-0" style={{ fontSize: 13 }}>
            No candidates selected.
          </p>
        ) : (
          selectedCandidates.map((c, i) => {
            const name = getCandidateName(c);
            
            return (
              <div key={c.job_candidate_id} className="bo-candidate-item">
                <div
                  className="bo-avatar"
                  style={{ background: avatarColors[i % avatarColors.length] }}
                >
                  {name.charAt(0).toUpperCase()}
                </div>

                <div>
                  <div style={{ fontWeight: 600 }}>{name}</div>
                  <div style={{ color: "#94a3b8", fontSize: 12 }}>
                    {c.email || "--"}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

    </div>
  );
})()}

  </ModalBody>

  <ModalFooter style={{ justifyContent: "space-between" }}>
    {outreachTab !== "compose" && (
      <button
        className="bo-btn-secondary"
        onClick={() => {
          if (outreachTab === "review") setOutreachTab("followup");
          else setOutreachTab("compose");
        }}
      >
        ← Back
      </button>
    )}

    <div style={{ display: "flex",justifyContent:"end" ,gap: 10 }}>
      <button
        className="bo-btn-secondary"
        onClick={() => {
          setShowBulkOutreachModal(false);
          setOutreachTab("compose");
        }}
      >
        Cancel
      </button>

      {outreachTab !== "review" ? (
        <button
          className="bo-btn-primary"
          onClick={() => {
            if (outreachTab === "compose") setOutreachTab("followup");
            else setOutreachTab("review");
          }}
        >
          Next →
        </button>
      ) : (
        <button
          className="bo-btn-primary"
          disabled={isSendingOutreach}
          onClick={async () => {

            const jobKey = configureCallJob?.job_id || configureCallJob?.id;
            const selectedIds = selectedCandidateRows[jobKey] || [];

            if (!selectedIds.length) {
              Swal.fire("Warning", "No candidates selected.", "warning");
              return;
            }

            if ((outreachChannels.email && !outreachSubject.trim()) || !outreachBody.trim()) {
              Swal.fire("Warning", "Subject & Body required", "warning");
              return;
            }

            setIsSendingOutreach(true);

            try {
              let channel = "email";
              if (outreachChannels.email && outreachChannels.whatsapp) channel = "both";
              else if (outreachChannels.whatsapp) channel = "whatsapp";

              const freqMap = { daily: 24, "12h": 12, "48h": 48, weekly: 168 };

              await axios.post("/api/v1/send-bulk-notifications/", {
                channel,
                subject: outreachSubject,
                body_template: outreachPayloadBody || outreachBody,
                job_id: jobKey,
                job_candidate_ids: selectedIds,
                consent_url: buildConsentScheduleUrl(configureCallJob),
                unsubscribe_url: buildConsentUnsubscribeUrl(configureCallJob),
                reminder_freq_hours: freqMap[outreachFrequency],
                max_reminders: outreachMaxReminders,
              });

              Swal.fire("Message Sent", "Message Sent SuccessFully!", "success");

              setShowBulkOutreachModal(false);
              setOutreachTab("compose");

            } catch (err) {
              Swal.fire("Error", "Failed to send message", "error");
            } finally {
              setIsSendingOutreach(false);
            }

          }}
        >
          {isSendingOutreach
            ? <><span className="spinner-border spinner-border-sm me-2" role="status" /><span>Sending...</span></>
            : <><span>🚀</span> Send Outreach</>}
        </button>
      )}
    </div>

  </ModalFooter>
</Modal>
<Modal isOpen={configureCallModal} toggle={handleConfigureCallClose} centered size="xl" className="configure-call-modal">
        <ModalBody style={{  padding: 0 }}>

          <Nav tabs style={{ paddingLeft: 16, paddingTop: 8 }}>
            <NavItem>
              {/* <NavLink
                className={configureCallStep === "first" ? "active fw-bold" : ""}
                onClick={() => setConfigureCallStep("first")}
                style={{ cursor: "pointer" }}
              >
                First Screening
              </NavLink> */}
            </NavItem>
           <NavItem className="mt-3 mb-1">
                <NavLink
                    style={{ paddingLeft: "12px", paddingTop: "6px", paddingBottom: "6px" }}
                >
                    Screening Questions
                </NavLink>
                </NavItem>
            <div className="ms-auto me-3 d-flex align-items-center">
              <button type="button" className="btn-close" onClick={handleConfigureCallClose} />
            </div>
          </Nav>

          <div style={{ padding: 20 }}>
            <TabContent activeTab={configureCallStep}>
{/* 
              <TabPane tabId="first">
                <Row className="mb-1">
                  <Col md={6} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Agent <span className="text-danger">*</span></Label>
                    <Select
                      placeholder="Select Agent"
                      options={agentOptions}
                      value={configureCallData.agent}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, agent: val }))}
                      getOptionLabel={o => o.label}
                      getOptionValue={o => o.value}
                      isClearable
                    />
                  </Col>
                  <Col md={6} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Source</Label>
                    <Select
                      placeholder="Select Source"
                      options={sourceOptions}
                      value={configureCallData.source}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, source: val }))}
                      isClearable
                    />
                  </Col>
                </Row>

                <Label className="fw-bold mb-1">Screening Questions</Label>
                {configureCallData?.firstScreeningQuestions?.map((val, idx) => (
                  <div key={idx} className="d-flex align-items-center gap-2 mb-1">
                    <Input
                      type="text"
                      placeholder={`Enter question`}
                      value={val}
                      onChange={e => handleEditFirstSQ(idx, e.target.value)}
                      style={{ width: "90%"}}
                    />
                    {idx === 0 ? (
                      <Button className="btn blueBtn btn-primary" title="Add" onClick={handleAddFirstSQ} style={{ width: "70px", marginLeft: "10px", marginRight: "initial"}}>
                        Add
                      </Button>
                    ) : (
                      <Button className="btn btn-danger" title="Remove" onClick={() => handleRemoveFirstSQ(idx)} style={{ width: "70px", marginLeft: "10px"}}>
                        <FaRegTrashAlt />
                      </Button>
                      // <button
                      //   className="text-danger border-0 p-0 bg-white"
                      //   title="Remove"
                      //   onClick={() => handleRemoveFirstSQ(idx)}
                      // >
                      //   <FaRegTrashAlt />
                      // </button>
                    )}
                  </div>
                ))}
                <div className="d-flex justify-content-center gap-2 mt-1">
                  <Button color="secondary" className="btn btn-primary blueBtn" onClick={handleConfigureCallClose}>
                    Cancel
                  </Button>
                  <Button className="btn blueBtn" onClick={handleInitiateFirstScreening} disabled={loadingInitiateCall}>
                    {loadingInitiateCall ? (
                      <><Spinner size="sm" className="me-1" /> Initiating...</>
                    ) : (
                      "Initiate Call"
                    )}
                  </Button>
                </div>
              </TabPane> */}

              <TabPane tabId="second">
                <Row className="mb-3">
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Test Type</Label>
                    <Select
                      placeholder="Select Test Type"
                      options={testTypeOptions}
                      value={configureCallData.testType}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, testType: val }))}
                    />
                  </Col>
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Agent <span className="text-danger">*</span></Label>
                    <Select
                      placeholder="Select Agent"
                      options={agentOptions}
                      value={configureCallData.agent}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, agent: val }))}
                      getOptionLabel={o => o.label}
                      getOptionValue={o => o.value}
                      isClearable
                    />
                  </Col>
                  {/* <Col md={3} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1 ">Schedule Date & Time</Label>
                    <DatePicker
                      selected={configureCallData.scheduleDate}
                      onChange={date =>
                        setConfigureCallData(prev => ({ ...prev, scheduleDate: date }))
                      }
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="dd/MM/yyyy h:mm aa"
                      placeholderText="Select Date & Time"
                      className="form-control"
                      minDate={new Date()}
                      minTime={
                        configureCallData.scheduleDate &&
                        configureCallData.scheduleDate.toDateString() === new Date().toDateString()
                          ? currentTime
                          : new Date(0, 0, 0, 0, 0)
                      }
                      maxTime={new Date(0, 0, 0, 23, 59)}
                    />
                  </Col> */}
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Source</Label>
                    <Select
                      placeholder="Select Source"
                      options={sourceOptions}
                      value={configureCallData.source}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, source: val }))}
                      isClearable
                    />
                  </Col>
                </Row>
                <div className="" id="SecondScreeningContainer">
                  <Row>
                    <Col className="pe-4">
                {Object.entries(configureCallData.secondScreeningQuestions).map(([category, questions]) => (
                  <div className="mb-3" key={category}>
                    <Label className="fw-bold mb-1">{category.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</Label>
                    {questions.map((val, idx) => (
                      <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                        <Input
                          type="text"
                          placeholder={`Enter ${category.replace(/_/g, " ").toLowerCase()} question`}
                          value={val}
                          title={val}
                          onChange={e => handleEditSecondSQ(category, idx, e.target.value)}
                          style={{ width: "90%"}}
                        />
                        {idx > 0 ? (
                          // <button
                          //   className="text-danger border-0 p-0 bg-white"
                          //   title="Remove"
                          //   onClick={() => handleRemoveSecondSQ(category, idx)}
                          // >
                          //   <FaRegTrashAlt />
                          // </button>
                          <Button title="Remove" className="btn btn-danger" onClick={() => handleRemoveSecondSQ(category, idx)} style={{ width: "70px", marginLeft: "10px"}}><FaRegTrashAlt /></Button>
                        ) : (
                          <Button className="btn blueBtn btn-primary" onClick={() => handleAddSecondSQ(category)} style={{ width: "70px", marginLeft: "10px", marginRight: "initial"}}>
                            Add
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
                    </Col>
                  </Row>
                </div>
                <div className="d-flex justify-content-center gap-1 mt-3">
                  <Button color="secondary" className="btn btn-secondary blueBtn" onClick={handleConfigureCallClose}>
                    Cancel
                  </Button>
                  <Button className="btn blueBtn" onClick={handleCreateCall} disabled={loadingCreateCall}>
                    {loadingCreateCall ? (
                      <><Spinner size="sm" className="me-2" /> Sending Consent Request...</>
                    ) : (
                      "Send Consent Request"
                    )}
                  </Button>
                </div>
              </TabPane>

            </TabContent>
          </div>
        </ModalBody>
      </Modal>
           <ScheduleInterviewDialog
                visible={richScheduleModalOpen}
                onHide={() => setRichScheduleModalOpen(false)}
                companyId={
                    richScheduleCandidate?.company ||
                    richScheduleCandidate?.company_id ||
                    companyId   // ← job-level fallback, already in component state
                }
                candidate={richScheduleCandidate}
                currentJobId={jobData?.job_id || jobOrderId || id}
                jobTitle={jobData?.job_title || ""}
                onScheduled={() => {
                    // optional: refresh candidate list after scheduling
                }}
            />
     <Modal isOpen={phoneCallModal} toggle={phoneCallLoading ? undefined : handlePhoneCallClose} centered>
             <ModalHeader toggle={phoneCallLoading ? undefined : handlePhoneCallClose}>
               Call Confirmation
             </ModalHeader>
             <ModalBody>
               <div className="text-center">
                 <FaPhoneAlt style={{ fontSize: "40px", color: "#28a745" }} className="mb-3" />
                 <h5 className="mb-3">Are you sure you want to make this call?</h5>
               </div>
               <div className="border rounded p-3">
                 <Row className="mb-2">
                   <Col xs={5}><strong>Candidate Name</strong></Col>
                   <Col xs={7}>
                     : {phoneCallCandidate
                       ? `${phoneCallCandidate.first_name || ""} ${phoneCallCandidate.last_name || ""}`.trim() || "--"
                       : "--"}
                   </Col>
                 </Row>
                 <Row className="mb-2">
                   <Col xs={5}><strong>Phone Number</strong></Col>
                   <Col xs={7}>
                     : {phoneCallCandidate?.mobile_phone || phoneCallCandidate?.candidate_phone || "--"}
                   </Col>
                 </Row>
                 <Row>
                   <Col xs={5}><strong>Your Extension</strong></Col>
                   <Col xs={7}>: {extension}</Col>
                 </Row>
               </div>
             </ModalBody>
             <ModalFooter className="justify-content-center">
               <Button color="secondary" onClick={handlePhoneCallClose} disabled={phoneCallLoading}>
                 Cancel
               </Button>
               <Button className="btn blueBtn" onClick={handlePhoneCallProceed} disabled={phoneCallLoading}>
                 {phoneCallLoading ? (
                   <><Spinner size="sm" className="me-2" /> Proceeding...</>
                 ) : (
                   "Proceed"
                 )}
               </Button>
             </ModalFooter>
           </Modal>
           <Dialog
  header="Previous Questions (Before Last Regeneration)"
  visible={previousQuestionsModal}
  style={{ width: "80vw" }}
  contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
  onHide={() => setPreviousQuestionsModal(false)}
>
  <div className="container-fluid">
    {/* Previous Manual Questions */}
    {Object.keys(previousManualQuestions).length > 0 && (
      <div className="mb-4">
        <h5 style={{ color: "#f47f22", borderBottom: "2px solid #f47f22", paddingBottom: 6 }}>
          Section-wise Questions
        </h5>
        {Object.entries(previousManualQuestions).map(([sectionName, data], idx) => (
          <div key={idx} className="mb-3 p-3 shadow-sm" style={{ borderRadius: 10, background: "#fff", border: "1px solid #e0e0e0" }}>
            <h6 style={{ color: "#333" }}>{sectionName}</h6>
            {["beginner", "intermediate", "advanced"].map(level => {
              const qs = data?.questions?.[level] || [];
              if (!qs.length) return null;
              const levelColor = { beginner: "#28a745", intermediate: "#ffc107", advanced: "#dc3545" };
              return (
                <div key={level} className="mb-2">
                  <span style={{ background: levelColor[level], color: "#fff", padding: "2px 10px", borderRadius: 20, fontSize: 12 }}>
                    {level.toUpperCase()} ({qs.length}) 
                  </span>
                  <ul className="mt-2" style={{ paddingLeft: 0 }}>
                    {qs.map((q, i) => (
                      <li key={i} style={{ display: "flex", gap: 8, marginBottom: 4 }}>
                        <span style={{ minWidth: 20, fontWeight: 600 }}>{i + 1}.</span>
                        <span>{q}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    )}

    {/* Previous Generated Questions */}
    {Object.keys(previousGeneratedQuestions).length > 0 && (
      <div className="mb-4">
        <h5 style={{ color: "#007bff", borderBottom: "2px solid #007bff", paddingBottom: 6 }}>
          🤖 AI Generated Questions
        </h5>
        {Object.entries(previousGeneratedQuestions).map(([skill, levels], idx) => (
          <div key={idx} className="mb-3 p-3 shadow-sm" style={{ borderRadius: 10, background: "#eef6ff", border: "1px solid #cfe2ff" }}>
            <h6 style={{ color: "#333" }}>{skill}</h6>
            {["beginner", "intermediate", "advanced"].map(level => {
              const qs = levels[level] || [];
              if (!qs.length) return null;
              return (
                <div key={level} className="mb-2">
                  <strong className="text-capitalize">{level}</strong>
                  <ul className="mt-1" style={{ paddingLeft: 0 }}>
                    {qs.map((qObj, i) => (
                      <li key={i} style={{ display: "flex", gap: 8, marginBottom: 4 }}>
                        <span style={{ minWidth: 20, fontWeight: 600 }}>{i + 1}.</span>
                        <span>{qObj.text || qObj}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    )}

    {Object.keys(previousGeneratedQuestions).length === 0 && Object.keys(previousManualQuestions).length === 0 && (
      <div className="text-center text-muted py-4">No previous questions stored.</div>
    )}
  </div>

  <div style={{ display: "flex", justifyContent: "center", padding: 10, borderTop: "1px solid #eee" }}>
    <button className="btn blueBtn px-4" onClick={() => setPreviousQuestionsModal(false)}>Close</button>
  </div>
</Dialog>
<Dialog
    header="Previous Screening Questions (Before Last Regeneration)"
    visible={previousScreeningModal}
    style={{ width: "70vw" }}
    contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
    onHide={() => setPreviousScreeningModal(false)}
>
    <div className="container-fluid">
        {Object.keys(previousScreeningQuestions).length > 0 ? (
            Object.entries(previousScreeningQuestions).map(([category, questions]) => (
                <div
                    key={category}
                    className="mb-3 p-3 shadow-sm"
                    style={{ borderRadius: 10, background: "#fff", border: "1px solid #e0e0e0" }}
                >
                    <h6 style={{ color: "#6f42c1", marginBottom: 10 }}>
                        {category.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                    </h6>
                    {Array.isArray(questions) && questions.length > 0 ? (
                        <ul style={{ paddingLeft: 0 }}>
                            {questions.map((q, i) => (
                                <li key={i} style={{ display: "flex", gap: 8, marginBottom: 5 }}>
                                    <span style={{ minWidth: 20, fontWeight: 600 }}>{i + 1}.</span>
                                    <span>{q}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="text-muted" style={{ fontSize: 13 }}>No questions</div>
                    )}
                </div>
            ))
        ) : (
            <div className="text-center text-muted py-4">No previous screening questions stored.</div>
        )}
    </div>

    <div style={{ display: "flex", justifyContent: "center", gap: 10, padding: 10, borderTop: "1px solid #eee" }}>
        {/* ✅ Download from inside the modal too */}
        <button
            className="btn blueBtn px-4"
            onClick={() =>
                downloadScreeningDocx({
                    currentScreeningQuestions: screeningQuestions,
                    previousScreeningQuestions,
                    jobTitle: getValues("job_title") || "Job",
                })
            }
        >
            <i className="pi pi-download me-2" />
            Download All Screening Questions
        </button>
        <button className="btn blueBtn" onClick={() => setPreviousScreeningModal(false)}>
            Close
        </button>
    </div>
</Dialog>  
{/* Folder Candidates Modal */}
<Modal 
    isOpen={showFolderCandidatesModal} 
    toggle={() => setShowFolderCandidatesModal(false)} 
    size="lg" 
    centered
>
    <ModalHeader toggle={() => setShowFolderCandidatesModal(false)}>
        Folder Candidates 
        {selectedShortlistFolderId && (
            <span className="text-muted ms-2">
                • {candidateFolders.find(f => getFolderId(f) === selectedShortlistFolderId)?.name || "Shortlisted"}
            </span>
        )}
    </ModalHeader>
    
    <ModalBody>
        {folderCandidatesLoading ? (
            <div className="text-center py-5">
                <ProgressSpinner />
                <p className="mt-3">Loading candidates...</p>
            </div>
        ) : folderCandidates.length === 0 ? (
            <div className="text-center py-5 text-muted">
                <h5>No candidates in this folder</h5>
                <p>This folder is currently empty.</p>
            </div>
        ) : (
            <div className="folder-candidates-list">
                {folderCandidates.map((candidate, index) => {
                    const name = getCandidateName(candidate);
                    return (
                        <div key={candidate.candidate_id || index} className="candidate-card border rounded p-3 mb-3">
                            <Row>
                                <Col md={8}>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="candidate-avatar">
                                            {name.charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                            <h6 className="mb-1">{name}</h6>
                                            <div className="text-muted small">
                                                {candidate.email || "No email"}
                                            </div>
                                            {candidate.mobile_phone && (
                                                <div className="text-muted small">
                                                    📞 {candidate.mobile_phone}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4} className="text-end">
                                    <div className="d-flex flex-column gap-2 align-items-end">
                                        <button
                                            className="btn btn-sm blueBtn"
                                            onClick={() => {
                                                setSelectedJobCandidate(candidate);
                                                setShowFolderCandidatesModal(false);
                                                setJobCandidateViewTab("resume");
                                            }}
                                        >
                                            View Profile
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => handlePhoneCallOpen(candidate)}
                                        >
                                            <FaPhoneAlt /> Call
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    );
                })}
            </div>
        )}
    </ModalBody>

    <ModalFooter>
        <Button color="secondary" onClick={() => setShowFolderCandidatesModal(false)}>
            Close
        </Button>
    </ModalFooter>
</Modal>
<Modal
  isOpen={showAddToFolderModal}
  toggle={() => { setShowAddToFolderModal(false); setAddToFolderId(""); }}
  centered
>
  <ModalHeader toggle={() => { setShowAddToFolderModal(false); setAddToFolderId(""); }}>
    Add to Folder
  </ModalHeader>
  <ModalBody>
    <p className="mb-2">
      Adding <strong>{(selectedCandidateRows[jobDataId] || []).length}</strong> candidate(s) to a folder.
    </p>
    <label className="form-label fw-semibold">
      Select Folder <span className="text-danger">*</span>
    </label>
    <div className="d-flex gap-2 align-items-start">
      <select
        className="form-select"
        value={addToFolderId}
        onChange={e => setAddToFolderId(e.target.value)}
        disabled={candidateFoldersLoading}
      >
        <option value="">
          {candidateFoldersLoading ? "Loading folders..." : "Select a folder"}
        </option>
        {candidateFolders.map(folder => {
          const folderId = getFolderId(folder);
          return (
            <option key={folderId} value={folderId}>
              {getFolderName(folder)}
            </option>
          );
        })}
      </select>
      <button
        type="button"
        className="btn btn-outline-primary"
        style={{ whiteSpace: "nowrap" }}
        onClick={() => setShowCreateFolderModal(true)}
      >
        + New Folder
      </button>
    </div>
    {addToFolderId && (
      <div className="mt-2 text-muted small">
        Adding to: <strong>{getFolderName(candidateFolders.find(f => String(getFolderId(f)) === String(addToFolderId)))}</strong>
      </div>
    )}
  </ModalBody>
  <ModalFooter className="justify-content-center">
    <button
      type="button"
      className="btn blueBtn"
      onClick={() => { setShowAddToFolderModal(false); setAddToFolderId(""); }}
      disabled={addingCandidatesToFolder}
    >
      Cancel
    </button>
    <button
      type="button"
      className="btn addBtn"
      onClick={async () => {
        if (!addToFolderId) {
          Swal.fire("Warning", "Please select a folder.", "warning");
          return;
        }
        await handleAddSelectedCandidatesToFolder(addToFolderId);
      }}
      disabled={addingCandidatesToFolder}
    >
      {addingCandidatesToFolder ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
          Adding...
        </>
      ) : "Add to Folder"}
    </button>
  </ModalFooter>
</Modal>
{testResultsModal && testResultsCandidate && (() => {
  const candidate = testResultsCandidate;
  const resultKey = getTalentScanResultKey(candidate);
  const hasCached = Object.prototype.hasOwnProperty.call(candidateTalentScanResultMap, resultKey);
  const hasInitial = candidate?.talent_scan_result != null;
  const talentScanResult = candidateTalentScanResultMap[resultKey] ?? candidate?.talent_scan_result;
  const tests = talentScanResult?.results ?? [];
  const isLoading = !!loadingTalentScanResultMap[resultKey];
  const shouldShimmer = !tests.length && !!resultKey && (isLoading || (!hasCached && !hasInitial));

  const handleViewResult = async (row) => {
    if (row?.id == null || row?.attempt_id == null) return;
    try {
      const resp = await axios.post("/api/v1/ts-view-test/create-dashboard-link/", {
        assign_test_id: row.id,
        attempt_id: row.attempt_id,
      });
      if (resp.data?.url) window.open(resp.data.url, "_blank");
      else Swal.fire("Error", "URL not found in response", "error");
    } catch (err) {
      Swal.fire("Error", "Failed to generate link", "error");
    }
  };

  return (
    <Modal
      isOpen={testResultsModal}
      toggle={() => setTestResultsModal(false)}
      size="xl"
      centered
      scrollable
    >
      <ModalHeader
        toggle={() => setTestResultsModal(false)}
        className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
      >
        <div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>
            Test Results — {getCandidateName(candidate)}
          </div>
          <div style={{ fontSize: 12, opacity: 0.85 }}>
            {candidate?.email || "--"} · {candidate?.mobile_phone || "--"}
          </div>
        </div>
      </ModalHeader>

      <ModalBody style={{ maxHeight: "75vh", overflowY: "auto", background: "#f8fafc" }}>
        {shouldShimmer ? (
          <div className="border rounded">
            <OrgTableShimmer columns={7} rows={4} titleWidth="180px" />
          </div>
        ) : Array.isArray(tests) && tests.length > 0 ? (
          <div style={{ display: "grid", gap: 16 }}>
            {tests.map((t, idx) => {
              const score = t.total_candidate_score ?? 0;
              const totalScore = t.total_test_score ?? 0;
              const pct = t.candidate_percentage_score ?? 0;
              const qualified = t?.ats_details?.is_test_qualified;
              const sectionScores = Array.isArray(t?.score_info) ? t.score_info : [];
              const sentOn = formatUTCDate(t.test_info?.created_at);
              const canViewResult = t?.id != null && t?.attempt_id != null;
              const isCheated = !!t?.test_info?.is_cheated;
              const cheatedSection = t?.test_info?.cheated_section;
              const pctColor = pct >= 80 ? "#16a34a" : pct >= 60 ? "#0d6efd" : pct >= 40 ? "#d97706" : "#dc2626";

              return (
                <div
                  key={idx}
                  style={{
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: 14,
                    padding: 18,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 16, color: "#1a202c", marginBottom: 8 }}>
                        {t.test_info?.name ?? "Test"}
                      </div>
                      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
                        {t.test_info?.test_designation ?? "-"}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
                        <span style={{ fontSize: 12, color: "#1a202c", fontWeight: 500, background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: 999, padding: "4px 12px", display: "inline-flex", alignItems: "center", gap: 5 }}>
                          📅 Sent on: <strong>{sentOn}</strong>
                        </span>
                        <span style={{ fontSize: 12, color: "#1a202c", fontWeight: 500, background: "#fef9c3", border: "1px solid #fde68a", borderRadius: 999, padding: "4px 12px", display: "inline-flex", alignItems: "center", gap: 5 }}>
                          🕐 Attempted at: <strong>{formatUTCDate(t.attempted_at)}</strong>
                        </span>
                        <span style={{ fontSize: 12, color: "#1a202c", fontWeight: 500, background: "#dcfce7", border: "1px solid #86efac", borderRadius: 999, padding: "4px 12px", display: "inline-flex", alignItems: "center", gap: 5 }}>
                          ✅ Submitted at: <strong>{formatUTCDate(t.submitted_at)}</strong>
                        </span>
                        {isCheated && (
                          <span style={{ fontSize: 12, color: "#fff", fontWeight: 700, background: "#dc2626", border: "1px solid #b91c1c", borderRadius: 999, padding: "4px 12px", display: "inline-flex", alignItems: "center", gap: 5 }}>
                            🚫 Cheated{cheatedSection ? `: ${cheatedSection}` : ""}
                          </span>
                        )}
                      </div>
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 700, padding: "5px 12px", borderRadius: 999, background: qualified ? "#dcfce7" : "#fee2e2", color: qualified ? "#15803d" : "#b91c1c", border: `1px solid ${qualified ? "#86efac" : "#fecaca"}`, whiteSpace: "nowrap" }}>
                      {qualified ? "Qualified" : "Not Qualified"}
                    </span>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: 10, marginBottom: 14 }}>
                    {[
                      { label: "Score", value: `${score} / ${totalScore}` },
                      { label: "Percentage", value: `${pct}%`, color: pctColor },
                      { label: "Attempted", value: t.is_attempted ? "Yes" : "No" },
                      { label: "Submitted", value: t.is_submitted ? "Yes" : "No" },
                    ].map((m, i) => (
                      <div key={i} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 700, color: m.color || "#1a202c" }}>{m.value}</div>
                        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2, fontWeight: 600, textTransform: "uppercase" }}>{m.label}</div>
                      </div>
                    ))}
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <div style={{ height: 8, borderRadius: 999, background: "#e2e8f0", overflow: "hidden" }}>
                      <div style={{ width: `${Math.min(pct, 100)}%`, height: "100%", background: pctColor, borderRadius: 999, transition: "width .4s ease" }} />
                    </div>
                  </div>

                  {sectionScores.length > 0 ? (
                    <div style={{ overflowX: "auto" }}>
                      <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse", border: "1px solid #edf2f7", borderRadius: 8, overflow: "hidden" }}>
                        <thead>
                          <tr style={{ background: "#f1f5f9", color: "#64748b", textTransform: "uppercase", fontSize: 11 }}>
                            {["Section","Questions","Attempted","Total","Cutoff","Secured","Percentage","Behavioural"].map((h, hi, arr) => (
                              <th key={h} style={{ padding: "8px 10px", textAlign: "left", fontWeight: 700, borderRight: hi < arr.length - 1 ? "1px solid #d1dce8" : "none" }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sectionScores.map((r, i) => {
                            const isCheatedRow = isCheated && cheatedSection && r.section__name === cheatedSection;
                            return (
                              <tr key={i} style={{ borderTop: "1px solid #edf2f7", background: isCheatedRow ? "#fee2e2" : undefined }}>
                                <td style={{ padding: "8px 10px", fontWeight: 600, color: isCheatedRow ? "#b91c1c" : "#1a202c", borderRight: "1px solid #edf2f7" }}>{r.section__name ?? "-"}</td>
                                <td style={{ padding: "8px 10px", borderRight: "1px solid #edf2f7" }}>{r.no_of_questions ?? "-"}</td>
                                <td style={{ padding: "8px 10px", borderRight: "1px solid #edf2f7" }}>{r.no_of_questions_attempted ?? 0}</td>
                                <td style={{ padding: "8px 10px", borderRight: "1px solid #edf2f7" }}>{r.total_score ?? 0}</td>
                                <td style={{ padding: "8px 10px", borderRight: "1px solid #edf2f7" }}>{r.cutoff_score ?? 0}</td>
                                <td style={{ padding: "8px 10px", fontWeight: 700, color: isCheatedRow ? "#b91c1c" : "#0d6efd", borderRight: "1px solid #edf2f7" }}>{r.score_secured ?? 0}</td>
                                <td style={{ padding: "8px 10px", borderRight: "1px solid #edf2f7" }}>{r.percentage ?? 0}%</td>
                                <td style={{ padding: "8px 10px" }}>{r.behavioural_score ?? 0}%</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted mb-0" style={{ fontSize: 12 }}>No section scores found.</p>
                  )}

                  {canViewResult && (
                    <div style={{ marginTop: 14, textAlign: "right" }}>
                      <button className="btn btn-sm btn-primary" onClick={() => handleViewResult(t)}>
                        View Detailed Result
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: 16 }}>
            <div style={{ width: 80, height: 80, borderRadius: "50%", background: "#f1f5f9", border: "2px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36 }}>📋</div>
            <div style={{ fontWeight: 700, fontSize: 18, color: "#1a202c" }}>No Tests Assigned</div>
            <div style={{ fontSize: 14, color: "#94a3b8", textAlign: "center", maxWidth: 280 }}>This candidate has not been assigned any tests yet.</div>
          </div>
        )}
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <Button className="btn blueBtn" onClick={() => setTestResultsModal(false)}>Close</Button>
      </ModalFooter>
    </Modal>
    
  );
})()}
<Dialog
    header="All Screening Questions"
    visible={showAllScreeningModal}
    style={{ width: "70vw" }}
    contentStyle={{ maxHeight: "70vh", overflowY: "auto" }}
    onHide={() => setShowAllScreeningModal(false)}
>
    <div className="container-fluid">
        {Object.keys(screeningQuestions).length > 0 ? (
            Object.entries(screeningQuestions).map(([category, questions]) => (
                <div
                    key={category}
                    className="mb-3 p-3 shadow-sm"
                    style={{ borderRadius: 10, background: "#fff", border: "1px solid #e0e0e0" }}
                >
                    <h6 style={{ color: "#6f42c1", marginBottom: 10 }}>
                        {category.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                        <span className="ms-2 text-muted" style={{ fontSize: 12 }}>
                            ({Array.isArray(questions) ? questions.length : 0} questions)
                        </span>
                    </h6>
                    {Array.isArray(questions) && questions.length > 0 ? (
                        <ul style={{ paddingLeft: 0 }}>
                            {questions.map((q, i) => (
                                <li key={i} style={{ display: "flex", gap: 8, marginBottom: 5 }}>
                                    <span style={{ minWidth: 20, fontWeight: 600 }}>{i + 1}.</span>
                                    <span>{q}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="text-muted" style={{ fontSize: 13 }}>No questions</div>
                    )}
                </div>
            ))
        ) : (
            <div className="text-center text-muted py-4">No screening questions available.</div>
        )}
    </div>

    <div style={{ display: "flex", justifyContent: "center", padding: 10, borderTop: "1px solid #eee" }}>
        <button className="btn blueBtn px-4" onClick={() => setShowAllScreeningModal(false)}>
            Close
        </button>
    </div>
</Dialog>
        </>
       
    );
};

// helpers used in component
const difficultyToSkillDefaults = {
    beginner: { rating: 3, proficiency: "Beginner" },
    intermediate: { rating: 6, proficiency: "Intermediate" },
    advanced: { rating: 9, proficiency: "Advanced" },
};

function getQuestionRatio(rating, totalQuestions = 5) {
    let beginner, intermediate, advanced;
    if (rating <= 3) {
        beginner = Math.floor(totalQuestions * 0.7);
        intermediate = Math.floor(totalQuestions * 0.2);
        advanced = totalQuestions - beginner - intermediate;
    } else if (rating >= 4 && rating <= 7) {
        beginner = Math.floor(totalQuestions * 0.2);
        intermediate = Math.floor(totalQuestions * 0.6);
        advanced = totalQuestions - beginner - intermediate;
    } else {
        beginner = Math.floor(totalQuestions * 0.2);
        intermediate = Math.floor(totalQuestions * 0.3);
        advanced = totalQuestions - beginner - intermediate;
    }
    const remaining = totalQuestions - (beginner + intermediate + advanced);
    if (remaining > 0) intermediate += remaining;
    return { beginner, intermediate, advanced };
}

export default CreateJobOrder;
const EditJobOrderMenuList = (props) => {
    const searchInputRef = useRef(null);
    const {
        fetchEditJobOptions,
        companyId,
        editJobsLoading,
        editJobPage,
        editJobTotalCount,
        editJobSearchText,
        setEditJobSearchText,
        jobOrderSearchFocusedRef,
        setJobOrderMenuOpen,
    } = props.selectProps;

    const totalPages = Math.max(1, Math.ceil(editJobTotalCount / 10));
    const keepSearchInputOpen = (e) => {
        e.preventDefault();
        e.stopPropagation();
        jobOrderSearchFocusedRef.current = true;
        setJobOrderMenuOpen(true);
        requestAnimationFrame(() => {
            searchInputRef.current?.focus();
            setJobOrderMenuOpen(true);
        });
        setTimeout(() => {
            jobOrderSearchFocusedRef.current = false;
        }, 150);
    };
    const releaseSearchInput = () => {
        setTimeout(() => {
            jobOrderSearchFocusedRef.current = false;
        }, 100);
    };
    const clearSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setEditJobSearchText("");
        setJobOrderMenuOpen(true);
        fetchEditJobOptions(companyId, 1, "");
        requestAnimationFrame(() => searchInputRef.current?.focus());
    };
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setEditJobSearchText(value);
        if (!value.trim()) {
            setJobOrderMenuOpen(true);
            fetchEditJobOptions(companyId, 1, "");
        }
    };

    return (
        <components.MenuList {...props}>
            <div
                className="px-2 pt-2 pb-1"
                style={{ borderBottom: "1px solid #e2e8f0" }}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ position: "relative" }}>
                <input
                    ref={searchInputRef}
                    type="text"
                    className="form-control form-control-sm"
                    style={{ paddingRight: editJobSearchText ? 30 : undefined }}
                    placeholder="Search job & press Enter..."
                    value={editJobSearchText}
                    // ❌ removed autoFocus — it was stealing focus from the
                    // react-select control the instant the menu opened,
                    // which triggered react-select's blur→close handler.
                    onMouseDown={keepSearchInputOpen}
                    onPointerDown={keepSearchInputOpen}
                    onFocus={() => {
                        setJobOrderMenuOpen(true);
                    }}
                    onBlur={releaseSearchInput}
                    onClick={(e) => e.stopPropagation()}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                            fetchEditJobOptions(companyId, 1, editJobSearchText);
                        }
                        e.stopPropagation();
                    }}
                />
                {editJobSearchText && (
                    <button
                        type="button"
                        aria-label="Clear job search"
                        title="Clear search"
                        onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        onClick={clearSearch}
                        disabled={editJobsLoading}
                        style={{
                            position: "absolute",
                            right: 7,
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: 0,
                            background: "transparent",
                            color: "#64748b",
                            padding: 0,
                            width: 18,
                            height: 18,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: editJobsLoading ? "not-allowed" : "pointer",
                        }}
                    >
                        <FaTimes style={{ fontSize: 12 }} />
                    </button>
                )}
                </div>
            </div>

            {editJobsLoading ? (
                <div
                    className="d-flex align-items-center justify-content-center gap-2 py-3"
                    style={{ fontSize: 13, color: "#64748b" }}
                >
                    <Spinner size="sm" color="primary" />
                    Loading job orders...
                </div>
            ) : (
                props.children
            )}

            <div
                className="d-flex align-items-center justify-content-between px-2 py-2"
                style={{ borderTop: "1px solid #e2e8f0" }}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={editJobsLoading || editJobPage <= 1}
                    onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        fetchEditJobOptions(companyId, editJobPage - 1, editJobSearchText);
                    }}
                >
                    ‹ Prev
                </button>
                <span style={{ fontSize: 11 }}>
                    Page {editJobPage} / {totalPages}
                </span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={editJobsLoading || editJobPage >= totalPages}
                    onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        fetchEditJobOptions(companyId, editJobPage + 1, editJobSearchText);
                    }}
                >
                    Next ›
                </button>
            </div>
        </components.MenuList>
    );
};
